/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Money: { input: any; output: any; }
  link__Import: { input: any; output: any; }
};

export type AccountSecurityFilter = {
  id?: InputMaybe<IdOperator>;
  securityType?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export enum AccountSecurityType {
  FaceId = 'FACE_ID',
  Fingerprint = 'FINGERPRINT',
  Pin = 'PIN'
}

export type ActivateShopRequestDto = {
  shopType: ShopType;
  userId: Scalars['ID']['input'];
};

export type ActivityFeedItem = {
  __typename?: 'ActivityFeedItem';
  createdAt: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AddCustomerToStorefrontCartInput = {
  cart_id: Scalars['ID']['input'];
  customer: StorefrontCartCustomerInput;
};

export type AddDeliveryToStorefrontCartInput = {
  cart_id: Scalars['ID']['input'];
  delivery: StorefrontCartDeliveryInput;
};

export type AddItemToStorefrontCartInput = {
  cart_id: Scalars['ID']['input'];
  item: StorefrontCartItemInput;
};

export type AddPaymentToStorefrontCartInput = {
  cart_id: Scalars['ID']['input'];
  payment: StorefrontCartPaymentInput;
};

export type AddPluginToUserRequestDto = {
  plugin_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};

export type AddProductConditionToDiscountRequestDto = {
  discountId: Scalars['ID']['input'];
  productCondition: DiscountProductConditionRequestDto;
};

export type AddProductsToCollectionInput = {
  collectionId: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};

export type AddScopeToTeamCredentialInput = {
  scope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  team_id: Scalars['ID']['input'];
};

export type AddSupplierAgreementTermsInput = {
  agreed_term?: InputMaybe<SupplierAgreementTerms>;
  supplier_id: Scalars['ID']['input'];
};

export type AddSupplierLocationInput = {
  address: Scalars['String']['input'];
  address_ext?: InputMaybe<Scalars['String']['input']>;
  business_id: Scalars['ID']['input'];
  city: Scalars['String']['input'];
  gmap_data: Scalars['String']['input'];
  lat: Scalars['String']['input'];
  lng: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postal_code: Scalars['String']['input'];
  state: Scalars['String']['input'];
  state_code: Scalars['String']['input'];
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AddTeamLogoInput = {
  logo: Scalars['String']['input'];
  team_id: Scalars['ID']['input'];
};

export type AddTeamServiceAgreementTermsInput = {
  team_id: Scalars['ID']['input'];
  terms: Service_Agreement_Terms;
  terms_value: TeamServiceAgreementTermsValueInput;
};

export type AddToCartInput = {
  force_replace?: InputMaybe<Scalars['Boolean']['input']>;
  product_sku: Scalars['String']['input'];
  profit: Scalars['Float']['input'];
  profit_type: ProfitType;
  quantity: Scalars['Int']['input'];
  user_id: Scalars['ID']['input'];
};

export type Address = {
  __typename?: 'Address';
  area?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  landmark?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  area: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  landmark?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
};

export type AdjustInventoryInput = {
  location_id: Scalars['ID']['input'];
  quantity_change: Scalars['Int']['input'];
  reason_code?: InputMaybe<Scalars['String']['input']>;
  reference_id?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
};

export type AdjustStorefrontCartItemQuantityInput = {
  item_id: Scalars['ID']['input'];
  type: QuantityAdjustmentType;
};

export type AeItemBaseInfoDto = {
  __typename?: 'AeItemBaseInfoDto';
  avg_evaluation_rating?: Maybe<Scalars['String']['output']>;
  category_id?: Maybe<Scalars['String']['output']>;
  category_sequence?: Maybe<Scalars['String']['output']>;
  currency_code?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  evaluation_count?: Maybe<Scalars['String']['output']>;
  gmt_create?: Maybe<Scalars['String']['output']>;
  gmt_modified?: Maybe<Scalars['String']['output']>;
  mobile_detail?: Maybe<Scalars['String']['output']>;
  owner_member_seq_long?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['String']['output']>;
  product_status_type?: Maybe<Scalars['String']['output']>;
  sales_count?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  ws_display?: Maybe<Scalars['String']['output']>;
  ws_offline_date?: Maybe<Scalars['String']['output']>;
};

export type AeItemProperties = {
  __typename?: 'AeItemProperties';
  attr_name?: Maybe<Scalars['String']['output']>;
  attr_name_id?: Maybe<Scalars['String']['output']>;
  attr_value?: Maybe<Scalars['String']['output']>;
  attr_value_end?: Maybe<Scalars['String']['output']>;
  attr_value_id?: Maybe<Scalars['String']['output']>;
  attr_value_start?: Maybe<Scalars['String']['output']>;
  attr_value_unit?: Maybe<Scalars['String']['output']>;
};

export type AeItemProperty = {
  __typename?: 'AeItemProperty';
  ae_item_property?: Maybe<Array<Maybe<AeItemProperties>>>;
};

export type AeItemSkuInfoDtos = {
  __typename?: 'AeItemSkuInfoDtos';
  ae_item_sku_info_d_t_o?: Maybe<Array<Maybe<AeSkuPropertyDtos>>>;
  barcode?: Maybe<Scalars['String']['output']>;
  buy_amount_limit_set_by_promotion?: Maybe<Scalars['String']['output']>;
  currency_code?: Maybe<Scalars['String']['output']>;
  ean_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ipm_sku_stock?: Maybe<Scalars['String']['output']>;
  limit_strategy?: Maybe<Scalars['String']['output']>;
  offer_bulk_sale_price?: Maybe<Scalars['String']['output']>;
  offer_sale_price?: Maybe<Scalars['String']['output']>;
  price_include_tax?: Maybe<Scalars['String']['output']>;
  sku_attr?: Maybe<Scalars['String']['output']>;
  sku_available_stock?: Maybe<Scalars['String']['output']>;
  sku_bulk_order?: Maybe<Scalars['String']['output']>;
  sku_code?: Maybe<Scalars['String']['output']>;
  sku_id?: Maybe<Scalars['String']['output']>;
  sku_price?: Maybe<Scalars['String']['output']>;
  sku_stock?: Maybe<Scalars['String']['output']>;
  wholesale_price_tiers?: Maybe<Array<Maybe<WholesalePriceTiers>>>;
};

export type AeMultimediaInfoDto = {
  __typename?: 'AeMultimediaInfoDto';
  ae_video_dtos?: Maybe<Array<Maybe<AeVideoDtos>>>;
  image_urls?: Maybe<Scalars['String']['output']>;
};

export type AeSkuPropertyDto = {
  __typename?: 'AeSkuPropertyDTO';
  property_value_definition_name?: Maybe<Scalars['String']['output']>;
  property_value_id?: Maybe<Scalars['Int']['output']>;
  sku_image?: Maybe<Scalars['String']['output']>;
  sku_property_id?: Maybe<Scalars['Int']['output']>;
  sku_property_name?: Maybe<Scalars['String']['output']>;
  sku_property_value?: Maybe<Scalars['String']['output']>;
};

export type AeSkuPropertyDtos = {
  __typename?: 'AeSkuPropertyDtos';
  ae_sku_property_dtos?: Maybe<InnerAeSkuPropertyDtos>;
  currency_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ipm_sku_stock?: Maybe<Scalars['Int']['output']>;
  offer_bulk_sale_price?: Maybe<Scalars['String']['output']>;
  offer_sale_price?: Maybe<Scalars['String']['output']>;
  price_include_tax?: Maybe<Scalars['Boolean']['output']>;
  sku_attr?: Maybe<Scalars['String']['output']>;
  sku_available_stock?: Maybe<Scalars['Int']['output']>;
  sku_code?: Maybe<Scalars['String']['output']>;
  sku_id?: Maybe<Scalars['String']['output']>;
  sku_price?: Maybe<Scalars['String']['output']>;
  sku_stock?: Maybe<Scalars['Boolean']['output']>;
};

export type AeStoreInfo = {
  __typename?: 'AeStoreInfo';
  communication_rating?: Maybe<Scalars['String']['output']>;
  item_as_described_rating?: Maybe<Scalars['String']['output']>;
  shipping_speed_rating?: Maybe<Scalars['String']['output']>;
  store_country_code?: Maybe<Scalars['String']['output']>;
  store_id?: Maybe<Scalars['String']['output']>;
  store_name?: Maybe<Scalars['String']['output']>;
};

export type AeVideoDtos = {
  __typename?: 'AeVideoDtos';
  ali_member_id?: Maybe<Scalars['String']['output']>;
  media_id?: Maybe<Scalars['String']['output']>;
  media_status?: Maybe<Scalars['String']['output']>;
  media_type?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  poster_url?: Maybe<Scalars['String']['output']>;
};

export type Affiliate = {
  __typename?: 'Affiliate';
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['Any']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payout_wallet_id?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tenant_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type AffiliateApplicationInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Any']['input']>;
  name: Scalars['String']['input'];
};

export type AffiliateLink = {
  __typename?: 'AffiliateLink';
  affiliate_id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  created_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  meta?: Maybe<Scalars['Any']['output']>;
  program_id: Scalars['ID']['output'];
  target_id?: Maybe<Scalars['String']['output']>;
  target_type: Scalars['String']['output'];
  tenant_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type AffiliateProgram = {
  __typename?: 'AffiliateProgram';
  commission_type: Scalars['String']['output'];
  commission_value: Scalars['Float']['output'];
  cookie_ttl_days: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tenant_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type AgencyDetails = {
  __typename?: 'AgencyDetails';
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AliExpressProduct = {
  __typename?: 'AliExpressProduct';
  cateId?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  evaluateRate?: Maybe<Scalars['String']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  itemMainPic?: Maybe<Scalars['String']['output']>;
  itemUrl?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Scalars['String']['output']>;
  originMinPrice?: Maybe<Scalars['String']['output']>;
  originalPrice?: Maybe<Scalars['String']['output']>;
  originalPriceCurrency?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['String']['output']>;
  salePriceCurrency?: Maybe<Scalars['String']['output']>;
  salePriceFormat?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  targetOriginalPrice?: Maybe<Scalars['String']['output']>;
  targetOriginalPriceCurrency?: Maybe<Scalars['String']['output']>;
  targetSalePrice?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AliExpressProductResponse = {
  __typename?: 'AliExpressProductResponse';
  length?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Maybe<AliExpressProduct>>>;
};

export type AliexpressDsProductGetResponse = {
  __typename?: 'AliexpressDsProductGetResponse';
  result?: Maybe<Result>;
  rsp_code?: Maybe<Scalars['String']['output']>;
  rsp_msg?: Maybe<Scalars['String']['output']>;
};

/**
 * Organization-Scoped API Key Management
 *
 * Provides CRUD operations for API keys scoped to organizations.
 * API keys enable programmatic access to organization resources
 * with configurable permissions, rate limiting, and expiration.
 */
export type ApiKey = {
  __typename?: 'ApiKey';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the API key is currently active (enabled and not expired) */
  isActive: Scalars['Boolean']['output'];
  /** Whether the API key has expired */
  isExpired: Scalars['Boolean']['output'];
  lastRequest?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  permissions?: Maybe<Scalars['JSONObject']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  rateLimitEnabled?: Maybe<Scalars['Boolean']['output']>;
  rateLimitMax?: Maybe<Scalars['Int']['output']>;
  rateLimitTimeWindow?: Maybe<Scalars['Int']['output']>;
  remaining?: Maybe<Scalars['Int']['output']>;
  requestCount?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Resolved user who created this API key */
  user?: Maybe<OrganizationUser>;
  userId: Scalars['ID']['output'];
};

/** API key error information */
export type ApiKeyError = {
  __typename?: 'ApiKeyError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** API key information returned after verification */
export type ApiKeyInfo = {
  __typename?: 'ApiKeyInfo';
  enabled: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  permissions?: Maybe<Scalars['JSONObject']['output']>;
  userId: Scalars['ID']['output'];
};

/** Paginated list of API keys */
export type ApiKeyList = {
  __typename?: 'ApiKeyList';
  keys: Array<ApiKey>;
  total: Scalars['Int']['output'];
};

/** API key usage statistics for an organization */
export type ApiKeyStats = {
  __typename?: 'ApiKeyStats';
  active: Scalars['Int']['output'];
  disabled: Scalars['Int']['output'];
  expired: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppBanner = {
  __typename?: 'AppBanner';
  banner_code?: Maybe<Scalars['String']['output']>;
  collection: Catalog;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type AppBannerFilter = {
  active?: InputMaybe<BooleanOperator>;
  country?: InputMaybe<StringOperator>;
  createdAt?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
};

export type AppBannerInput = {
  banner_code?: InputMaybe<Scalars['String']['input']>;
  collection_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  url: Scalars['String']['input'];
};

/**
 * App-level cart aggregate for a user. This is a virtual/cart view
 * over duke_cart_items and is not the same as StorefrontCart.
 */
export type AppCart = {
  __typename?: 'AppCart';
  allowInstantDelivery: Scalars['Boolean']['output'];
  deliveryFee: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  hasAliexpressProduct: Scalars['Boolean']['output'];
  hasFreeDeliveryItem: Scalars['Boolean']['output'];
  hasInstantDeliveryItem: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  items: Array<CartItem>;
  profitTotal: Scalars['Float']['output'];
  shippingCost: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  userId: Scalars['ID']['output'];
};

export type Auth = {
  __typename?: 'Auth';
  token: Scalars['String']['output'];
  user: User;
};

export type AuthResult = CustomerAuth | OrganizationAuth;

export type AutogeneratedMainType = {
  __typename?: 'AutogeneratedMainType';
  agency_details?: Maybe<AgencyDetails>;
  currency_code?: Maybe<Scalars['String']['output']>;
  currency_name?: Maybe<Scalars['String']['output']>;
  currency_symbol?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  end_time?: Maybe<Scalars['Date']['output']>;
  estimate_id?: Maybe<Scalars['String']['output']>;
  estimate_type_details?: Maybe<EstimateTypeDetails>;
  full_price?: Maybe<Scalars['Int']['output']>;
  time_string?: Maybe<Scalars['String']['output']>;
  total_distance?: Maybe<Scalars['Float']['output']>;
};

/** Available permissions that can be assigned to API keys */
export type AvailableApiKeyPermissions = {
  __typename?: 'AvailableApiKeyPermissions';
  permissions: Scalars['JSONObject']['output'];
};

export enum BillingCycle {
  Annual = 'annual',
  Monthly = 'monthly'
}

export type BobAddress = {
  __typename?: 'BobAddress';
  city?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  entered_address?: Maybe<Scalars['String']['output']>;
  gs_hash?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  local_area?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
  time_created?: Maybe<Scalars['String']['output']>;
  time_modified?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
  zone_name?: Maybe<Scalars['String']['output']>;
};

export type BobAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  entered_address?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  local_area?: InputMaybe<Scalars['String']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<Scalars['String']['input']>;
};

export type BobBillingBillingTransaction = {
  __typename?: 'BobBillingBillingTransaction';
  account_code?: Maybe<Scalars['String']['output']>;
  account_id?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  payment?: Maybe<Scalars['String']['output']>;
  payment_id?: Maybe<Scalars['String']['output']>;
  payment_provider_id?: Maybe<Scalars['String']['output']>;
  provider_doc_number?: Maybe<Scalars['String']['output']>;
  shipment_id?: Maybe<Scalars['Int']['output']>;
  shipment_reference?: Maybe<Scalars['String']['output']>;
  time_created?: Maybe<Scalars['String']['output']>;
  time_modified?: Maybe<Scalars['String']['output']>;
  transaction_date?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  ua_doc_number?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

export type BobCancelShipmentRequestDto = {
  tracking_reference?: InputMaybe<Scalars['String']['input']>;
};

export type BobChannel = {
  __typename?: 'BobChannel';
  account_id?: Maybe<Scalars['Int']['output']>;
  channel_type?: Maybe<Scalars['String']['output']>;
  channel_type_logo_square_url?: Maybe<Scalars['String']['output']>;
  channel_type_logo_url?: Maybe<Scalars['String']['output']>;
  channel_type_slug?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BobCheckpoint = {
  __typename?: 'BobCheckpoint';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_friendly?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type BobCollectionAddressBook = {
  __typename?: 'BobCollectionAddressBook';
  account_id?: Maybe<Scalars['Int']['output']>;
  additional_instructions?: Maybe<Scalars['String']['output']>;
  address?: Maybe<BobAddress>;
  address_id?: Maybe<Scalars['Int']['output']>;
  collect_after?: Maybe<Scalars['String']['output']>;
  collect_before?: Maybe<Scalars['String']['output']>;
  collection_lead_time?: Maybe<Scalars['Int']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  contact_surname?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['Int']['output']>;
  custom_logo?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  include_packing_slip?: Maybe<Scalars['Boolean']['output']>;
  is_collection_address?: Maybe<Scalars['Boolean']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<BobOrderMeta>;
  mobile_number?: Maybe<Scalars['String']['output']>;
  modified_by?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  request_collection_at?: Maybe<Scalars['String']['output']>;
  shipping_label_email?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  time_created?: Maybe<Scalars['String']['output']>;
  time_modified?: Maybe<Scalars['String']['output']>;
};

export type BobCreateOrderRequestDto = {
  buyer_selected_shipping_cost: Scalars['Float']['input'];
  buyer_selected_shipping_method: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  customer_email: Scalars['String']['input'];
  customer_name: Scalars['String']['input'];
  customer_phone: Scalars['String']['input'];
  customer_surname: Scalars['String']['input'];
  delivery_address: BobAddressInput;
  order_items: Array<BobOrderItemInput>;
  payment_status: BobOrderPaymentStatus;
};

export type BobCreateShipmentRequestDto = {
  collection_address?: InputMaybe<BobAddressInput>;
  collection_after?: InputMaybe<Scalars['String']['input']>;
  collection_before?: InputMaybe<Scalars['String']['input']>;
  collection_contact_company?: InputMaybe<Scalars['String']['input']>;
  collection_contact_email?: InputMaybe<Scalars['String']['input']>;
  collection_contact_mobile_number?: InputMaybe<Scalars['String']['input']>;
  collection_contact_name?: InputMaybe<Scalars['String']['input']>;
  collection_min_date?: InputMaybe<Scalars['String']['input']>;
  custom_tracking_reference?: InputMaybe<Scalars['String']['input']>;
  declared_value?: InputMaybe<Scalars['Int']['input']>;
  delivery_address?: InputMaybe<BobAddressInput>;
  delivery_contact_company?: InputMaybe<Scalars['String']['input']>;
  delivery_contact_email?: InputMaybe<Scalars['String']['input']>;
  delivery_contact_mobile_number?: InputMaybe<Scalars['String']['input']>;
  delivery_contact_name?: InputMaybe<Scalars['String']['input']>;
  instructions_collection?: InputMaybe<Scalars['String']['input']>;
  instructions_delivery?: InputMaybe<Scalars['String']['input']>;
  parcels?: InputMaybe<Array<InputMaybe<BobParcelInput>>>;
  provider_slug?: InputMaybe<Scalars['String']['input']>;
  service_level_code?: InputMaybe<Scalars['String']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type BobGetCourierRatesRequestDto = {
  collection_address: BobAddressInput;
  declared_value?: InputMaybe<Scalars['Int']['input']>;
  delivery_address: BobAddressInput;
  parcels: Array<BobParcelInput>;
  providers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  service_levels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type BobGetCourierRatesResponseDto = {
  __typename?: 'BobGetCourierRatesResponseDto';
  account_id?: Maybe<Scalars['Int']['output']>;
  collection_address?: Maybe<BobAddress>;
  declared_value?: Maybe<Scalars['Int']['output']>;
  delivery_address?: Maybe<BobAddress>;
  id?: Maybe<Scalars['Int']['output']>;
  parcels?: Maybe<Array<Maybe<BobParcel>>>;
  provider_rate_requests?: Maybe<Array<Maybe<BobProviderRateRequest>>>;
  request_timeout?: Maybe<Scalars['String']['output']>;
  surcharge?: Maybe<Scalars['String']['output']>;
  time_created?: Maybe<Scalars['String']['output']>;
  timeout?: Maybe<Scalars['Int']['output']>;
  total_submitted_weight_kg?: Maybe<Scalars['Float']['output']>;
  webhook_url?: Maybe<Scalars['String']['output']>;
};

export type BobGetOrderFulfillmentsRequestDto = {
  order_id?: InputMaybe<Scalars['Int']['input']>;
};

export type BobGetOrderFulfillmentsResponseDto = {
  __typename?: 'BobGetOrderFulfillmentsResponseDto';
  count?: Maybe<Scalars['Int']['output']>;
  order_fulfillments?: Maybe<Array<Maybe<BobOrderFulfillments>>>;
};

export type BobGetOrdersRequestDto = {
  /** Province */
  delivery_address_zone?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  fulfillment_status?: InputMaybe<Scalars['String']['input']>;
  has_delivery_address?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  order_by?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<BobOrderPaymentStatus>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  tag_id?: InputMaybe<Scalars['Int']['input']>;
  /** The reference of the fulfillment (shipment) created in the order */
  tracking_reference?: InputMaybe<Scalars['String']['input']>;
};

export type BobGetOrdersResponseDto = {
  __typename?: 'BobGetOrdersResponseDto';
  count?: Maybe<Scalars['Int']['output']>;
  orders?: Maybe<Array<Maybe<BobOrder>>>;
};

export type BobGetRateRequestsRequestDto = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type BobGetRateRequestsResponseDto = {
  __typename?: 'BobGetRateRequestsResponseDto';
  count?: Maybe<Scalars['Int']['output']>;
  rate_requests?: Maybe<Array<Maybe<BobRateRequest>>>;
};

export type BobGetRatesAtCheckoutRequestDto = {
  collection_address: BobAddressInput;
  declared_value?: InputMaybe<Scalars['Int']['input']>;
  delivery_address: BobAddressInput;
  handling_time?: InputMaybe<Scalars['Int']['input']>;
  items: Array<BobRateItem>;
};

export type BobGetRatesAtCheckoutResponseDto = {
  __typename?: 'BobGetRatesAtCheckoutResponseDto';
  count?: Maybe<Scalars['Int']['output']>;
  rates?: Maybe<Array<Maybe<BobRate>>>;
};

export type BobGetShipmentWaybillRequestDto = {
  paper_size?: InputMaybe<Scalars['String']['input']>;
  show_email_address?: InputMaybe<Scalars['Boolean']['input']>;
  show_order_items?: InputMaybe<Scalars['Boolean']['input']>;
  tracking_references?: InputMaybe<Scalars['String']['input']>;
  waybill_size?: InputMaybe<Scalars['String']['input']>;
  waybills_per_shipment?: InputMaybe<Scalars['Int']['input']>;
};

export type BobGetShipmentsRequestDto = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BobGetShipmentsResponseDto = {
  __typename?: 'BobGetShipmentsResponseDto';
  count?: Maybe<Scalars['Int']['output']>;
  shipments?: Maybe<Array<Maybe<BobShipment>>>;
};

export type BobGetTrackingEventsRequestDto = {
  tracking_reference?: InputMaybe<Scalars['String']['input']>;
};

export type BobLiabilityCover = {
  __typename?: 'BobLiabilityCover';
  declared_value?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  provider_liability_cover?: Maybe<Scalars['Boolean']['output']>;
};

export type BobOrder = {
  __typename?: 'BobOrder';
  account_id?: Maybe<Scalars['Int']['output']>;
  archived_by_user?: Maybe<Scalars['String']['output']>;
  buyer_selected_shipping_cost?: Maybe<Scalars['Float']['output']>;
  buyer_selected_shipping_method?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<BobChannel>;
  channel_order_number?: Maybe<Scalars['String']['output']>;
  channel_order_url?: Maybe<Scalars['String']['output']>;
  channel_ref_id?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['Int']['output']>;
  created_by_user?: Maybe<BobUser>;
  currency?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_surname?: Maybe<Scalars['String']['output']>;
  date_placed_on_channel?: Maybe<Scalars['String']['output']>;
  delivery_address?: Maybe<BobAddress>;
  delivery_address_id?: Maybe<Scalars['Int']['output']>;
  fulfillment_status?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_modified_on_channel?: Maybe<Scalars['String']['output']>;
  line_item_total?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<BobOrderMeta>;
  note?: Maybe<Scalars['String']['output']>;
  order_fulfillment_presets?: Maybe<BobOrderFulfillmentPreset>;
  order_fulfillments?: Maybe<Scalars['String']['output']>;
  order_items?: Maybe<Array<Maybe<BobOrderItem>>>;
  payment_status?: Maybe<BobOrderPaymentStatus>;
  rate_request?: Maybe<BobRateRequest>;
  rate_request_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  taxes_included?: Maybe<Scalars['Boolean']['output']>;
  time_archived?: Maybe<Scalars['String']['output']>;
  time_created?: Maybe<Scalars['String']['output']>;
  time_modified?: Maybe<Scalars['String']['output']>;
  total_discount?: Maybe<Scalars['Int']['output']>;
  total_fulfilled_qty?: Maybe<Scalars['Int']['output']>;
  total_price?: Maybe<Scalars['Float']['output']>;
  total_qty?: Maybe<Scalars['Int']['output']>;
  total_tax?: Maybe<Scalars['Int']['output']>;
  total_weight_kg?: Maybe<Scalars['Float']['output']>;
};

export type BobOrderFulfillment = {
  __typename?: 'BobOrderFulfillment';
  account_id?: Maybe<Scalars['Int']['output']>;
  batch_number?: Maybe<Scalars['String']['output']>;
  channel_ref_id?: Maybe<Scalars['String']['output']>;
  failed_reason?: Maybe<Scalars['String']['output']>;
  fulfilled_by_user?: Maybe<BobUser>;
  fulfillment_provider?: Maybe<Scalars['String']['output']>;
  fulfillment_service_level_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<BobOrderFulfillmentItem>>>;
  method?: Maybe<Scalars['String']['output']>;
  method_id?: Maybe<Scalars['Int']['output']>;
  method_reference?: Maybe<Scalars['String']['output']>;
  method_status?: Maybe<Scalars['String']['output']>;
  modified_by?: Maybe<Scalars['Int']['output']>;
  order_id?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time_created?: Maybe<Scalars['String']['output']>;
  time_modified?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type BobOrderFulfillmentItem = {
  __typename?: 'BobOrderFulfillmentItem';
  id?: Maybe<Scalars['Int']['output']>;
  order_fulfillment_id?: Maybe<Scalars['Int']['output']>;
  order_id?: Maybe<Scalars['Int']['output']>;
  order_item?: Maybe<BobOrderItem>;
  order_item_id?: Maybe<Scalars['Int']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
};

export type BobOrderFulfillmentPreset = {
  __typename?: 'BobOrderFulfillmentPreset';
  buyer_contact_number?: Maybe<Scalars['String']['output']>;
  buyer_email?: Maybe<Scalars['String']['output']>;
  buyer_name?: Maybe<Scalars['String']['output']>;
  collection_address_book?: Maybe<BobCollectionAddressBook>;
  collection_address_book_id?: Maybe<Scalars['Int']['output']>;
  collection_address_book_name?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  parcels?: Maybe<Array<Maybe<BobParcel>>>;
  provider_slug?: Maybe<Scalars['String']['output']>;
  service_level_code?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BobOrderFulfillments = {
  __typename?: 'BobOrderFulfillments';
  buyer_collection?: Maybe<Scalars['String']['output']>;
  order_fulfillment?: Maybe<BobOrderFulfillment>;
  shipment?: Maybe<BobShipment>;
};

export type BobOrderItem = {
  __typename?: 'BobOrderItem';
  channel_location?: Maybe<Scalars['String']['output']>;
  channel_ref_id?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fulfilled_qty?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  total_price?: Maybe<Scalars['Int']['output']>;
  total_weight_kg?: Maybe<Scalars['Float']['output']>;
  unit_price?: Maybe<Scalars['Int']['output']>;
  unit_weight_kg?: Maybe<Scalars['Float']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type BobOrderItemInput = {
  channel_location?: InputMaybe<Scalars['String']['input']>;
  channel_ref_id?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fulfilled_qty?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  total_price?: InputMaybe<Scalars['Int']['input']>;
  total_weight_kg?: InputMaybe<Scalars['Float']['input']>;
  unit_price?: InputMaybe<Scalars['Int']['input']>;
  unit_weight_kg?: InputMaybe<Scalars['Float']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type BobOrderMeta = {
  __typename?: 'BobOrderMeta';
  buyer_selected_shipping_method_codes?: Maybe<Scalars['String']['output']>;
  original_address?: Maybe<Scalars['String']['output']>;
};

export enum BobOrderPaymentStatus {
  Paid = 'paid',
  /** partially-paid */
  Unpaid = 'unpaid'
}

export type BobParcel = {
  __typename?: 'BobParcel';
  actual_height_cm?: Maybe<Scalars['String']['output']>;
  actual_length_cm?: Maybe<Scalars['String']['output']>;
  actual_weight_kg?: Maybe<Scalars['String']['output']>;
  actual_width_cm?: Maybe<Scalars['String']['output']>;
  custom_parcel_reference?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  is_additional?: Maybe<Scalars['String']['output']>;
  package_id?: Maybe<Scalars['Int']['output']>;
  provider_tracking_reference?: Maybe<Scalars['String']['output']>;
  submitted_height_cm?: Maybe<Scalars['Float']['output']>;
  submitted_length_cm?: Maybe<Scalars['Float']['output']>;
  submitted_weight_kg?: Maybe<Scalars['Float']['output']>;
  submitted_width_cm?: Maybe<Scalars['Float']['output']>;
  time_created?: Maybe<Scalars['String']['output']>;
  time_modified?: Maybe<Scalars['String']['output']>;
  tracking_reference?: Maybe<Scalars['String']['output']>;
};

export type BobParcelInput = {
  custom_parcel_reference?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  submitted_height_cm?: InputMaybe<Scalars['Float']['input']>;
  submitted_length_cm?: InputMaybe<Scalars['Float']['input']>;
  submitted_weight_kg?: InputMaybe<Scalars['Float']['input']>;
  submitted_width_cm?: InputMaybe<Scalars['Float']['input']>;
};

export type BobProviderRateRequest = {
  __typename?: 'BobProviderRateRequest';
  failed_reason?: Maybe<Scalars['String']['output']>;
  is_custom_account?: Maybe<Scalars['String']['output']>;
  provider_id?: Maybe<Scalars['Int']['output']>;
  provider_name?: Maybe<Scalars['String']['output']>;
  provider_slug?: Maybe<Scalars['String']['output']>;
  rate_response_id?: Maybe<Scalars['Int']['output']>;
  responses?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BobRate = {
  __typename?: 'BobRate';
  base_rate?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  liability_cover?: Maybe<BobLiabilityCover>;
  max_delivery_date?: Maybe<Scalars['String']['output']>;
  min_delivery_date?: Maybe<Scalars['String']['output']>;
  service_code?: Maybe<Scalars['String']['output']>;
  service_name?: Maybe<Scalars['String']['output']>;
  surcharges?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  total_price?: Maybe<Scalars['Int']['output']>;
};

export type BobRateItem = {
  description?: InputMaybe<Scalars['String']['input']>;
  height_cm?: InputMaybe<Scalars['Float']['input']>;
  length_cm?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  weight_kg?: InputMaybe<Scalars['Float']['input']>;
  width_cm?: InputMaybe<Scalars['Float']['input']>;
};

export type BobRateRequest = {
  __typename?: 'BobRateRequest';
  account?: Maybe<BobShipmentAccount>;
  account_id?: Maybe<Scalars['Int']['output']>;
  collection_address?: Maybe<BobAddress>;
  declared_value?: Maybe<Scalars['Int']['output']>;
  delivery_address?: Maybe<BobAddress>;
  id?: Maybe<Scalars['Int']['output']>;
  parcels?: Maybe<Array<Maybe<BobParcel>>>;
  provider_rate_requests?: Maybe<Array<Maybe<BobProviderRateRequest>>>;
  request_timeout?: Maybe<Scalars['String']['output']>;
  surcharge?: Maybe<Scalars['String']['output']>;
  time_created?: Maybe<Scalars['String']['output']>;
  timeout?: Maybe<Scalars['Int']['output']>;
  total_submitted_weight_kg?: Maybe<Scalars['Float']['output']>;
  webhook_url?: Maybe<Scalars['String']['output']>;
};

export type BobShipment = {
  __typename?: 'BobShipment';
  account?: Maybe<BobShipmentAccount>;
  account_id?: Maybe<Scalars['Int']['output']>;
  billing_transactions?: Maybe<Array<Maybe<BobBillingBillingTransaction>>>;
  charged_amount?: Maybe<Scalars['Float']['output']>;
  charged_weight_kg?: Maybe<Scalars['Int']['output']>;
  collected_date?: Maybe<Scalars['String']['output']>;
  collection_address?: Maybe<BobAddress>;
  collection_address_id?: Maybe<Scalars['Int']['output']>;
  collection_after?: Maybe<Scalars['String']['output']>;
  collection_before?: Maybe<Scalars['String']['output']>;
  collection_contact_email?: Maybe<Scalars['String']['output']>;
  collection_contact_mobile_number?: Maybe<Scalars['String']['output']>;
  collection_contact_name?: Maybe<Scalars['String']['output']>;
  collection_min_date?: Maybe<Scalars['String']['output']>;
  courier_confirmed_rate?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['Int']['output']>;
  created_by_user?: Maybe<BobUser>;
  custom_account?: Maybe<Scalars['Boolean']['output']>;
  custom_account_code?: Maybe<Scalars['String']['output']>;
  custom_tracking_reference?: Maybe<Scalars['String']['output']>;
  declared_value?: Maybe<Scalars['String']['output']>;
  delivered_date?: Maybe<Scalars['String']['output']>;
  delivery_address?: Maybe<BobAddress>;
  delivery_address_id?: Maybe<Scalars['Int']['output']>;
  delivery_contact_email?: Maybe<Scalars['String']['output']>;
  delivery_contact_mobile_number?: Maybe<Scalars['String']['output']>;
  delivery_contact_name?: Maybe<Scalars['String']['output']>;
  failed_reason?: Maybe<Scalars['String']['output']>;
  has_provider_doc?: Maybe<Scalars['Boolean']['output']>;
  health_status?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_response_code?: Maybe<Scalars['Int']['output']>;
  manifest_id?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<BobShipmentMeta>;
  modified_by?: Maybe<Scalars['Int']['output']>;
  modified_by_user?: Maybe<Scalars['String']['output']>;
  next_retry_time?: Maybe<Scalars['String']['output']>;
  order_fulfillment?: Maybe<Scalars['String']['output']>;
  order_fulfillment_id?: Maybe<Scalars['Int']['output']>;
  parcel_count?: Maybe<Scalars['Int']['output']>;
  parcels?: Maybe<Array<Maybe<BobParcel>>>;
  provider?: Maybe<BobShipmentProvider>;
  provider_id?: Maybe<Scalars['Int']['output']>;
  provider_shipment_id?: Maybe<Scalars['String']['output']>;
  provider_slug?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  rate_response_id?: Maybe<Scalars['Int']['output']>;
  retry_count?: Maybe<Scalars['Int']['output']>;
  service_level?: Maybe<BobShipmentServiceLevel>;
  service_level_code?: Maybe<Scalars['String']['output']>;
  service_level_cut_off_time?: Maybe<Scalars['String']['output']>;
  service_level_id?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submission_status?: Maybe<Scalars['String']['output']>;
  submitted_weight_kg?: Maybe<Scalars['Float']['output']>;
  surcharge?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  time_created?: Maybe<Scalars['String']['output']>;
  time_modified?: Maybe<Scalars['String']['output']>;
  timeout?: Maybe<Scalars['Int']['output']>;
  tracking_expiry_date?: Maybe<Scalars['String']['output']>;
  tracking_last_event_time?: Maybe<Scalars['String']['output']>;
  tracking_reference?: Maybe<Scalars['String']['output']>;
};

export type BobShipmentAccount = {
  __typename?: 'BobShipmentAccount';
  account_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BobShipmentMeta = {
  __typename?: 'BobShipmentMeta';
  collection_address_book_id?: Maybe<Scalars['Int']['output']>;
  collection_reference?: Maybe<Scalars['String']['output']>;
  estimated_collection_date?: Maybe<Scalars['String']['output']>;
  estimated_delivery_date?: Maybe<Scalars['String']['output']>;
  health_status_reason?: Maybe<Scalars['String']['output']>;
  sl_collection_agent_id?: Maybe<Scalars['String']['output']>;
  sl_collection_agent_zone?: Maybe<Scalars['String']['output']>;
  sl_collection_branch?: Maybe<Scalars['String']['output']>;
  sl_delivery_agent_id?: Maybe<Scalars['String']['output']>;
  sl_delivery_agent_zone?: Maybe<Scalars['String']['output']>;
  sl_delivery_branch?: Maybe<Scalars['String']['output']>;
};

export type BobShipmentMovementEvent = {
  __typename?: 'BobShipmentMovementEvent';
  collected_time?: Maybe<Scalars['String']['output']>;
  delivered_time?: Maybe<Scalars['String']['output']>;
  in_transit_time?: Maybe<Scalars['String']['output']>;
  out_for_delivery_time?: Maybe<Scalars['String']['output']>;
};

export type BobShipmentProvider = {
  __typename?: 'BobShipmentProvider';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type BobShipmentServiceLevel = {
  __typename?: 'BobShipmentServiceLevel';
  code?: Maybe<Scalars['String']['output']>;
  collection_cut_off_time?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expected_delivery_time_hours?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BobShipmentWaybill = {
  __typename?: 'BobShipmentWaybill';
  download_url?: Maybe<Scalars['String']['output']>;
  file_history_id?: Maybe<Scalars['String']['output']>;
  pdf_queued?: Maybe<Scalars['Boolean']['output']>;
  shipments?: Maybe<Array<Maybe<BobShipment>>>;
  waybills_ready?: Maybe<Scalars['Boolean']['output']>;
};

export type BobTrackingEvent = {
  __typename?: 'BobTrackingEvent';
  checkpoints?: Maybe<Array<Maybe<BobCheckpoint>>>;
  courier_logo?: Maybe<Scalars['String']['output']>;
  courier_name?: Maybe<Scalars['String']['output']>;
  courier_phone?: Maybe<Scalars['String']['output']>;
  courier_slug?: Maybe<Scalars['String']['output']>;
  custom_order_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_checkpoint_time?: Maybe<Scalars['String']['output']>;
  merchant_logo?: Maybe<Scalars['String']['output']>;
  merchant_name?: Maybe<Scalars['String']['output']>;
  order_number?: Maybe<Scalars['String']['output']>;
  service_level?: Maybe<Scalars['String']['output']>;
  shipment_movement_events?: Maybe<BobShipmentMovementEvent>;
  shipment_time_created?: Maybe<Scalars['String']['output']>;
  shipment_tracking_reference?: Maybe<Scalars['String']['output']>;
  show_branding?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_friendly?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BobUser = {
  __typename?: 'BobUser';
  accepted_terms?: Maybe<Scalars['String']['output']>;
  account_id?: Maybe<Scalars['Int']['output']>;
  api_key?: Maybe<Scalars['String']['output']>;
  created_by_user?: Maybe<BobUser>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time_created?: Maybe<Scalars['String']['output']>;
  time_modified?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BooleanOperator = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BreakDownItems = {
  __typename?: 'BreakDownItems';
  average: Scalars['Int']['output'];
  excellent: Scalars['Int']['output'];
  good: Scalars['Int']['output'];
  poor: Scalars['Int']['output'];
  veryGood: Scalars['Int']['output'];
};

export type BulkFeatureUpdateResult = {
  __typename?: 'BulkFeatureUpdateResult';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  totalRequested: Scalars['Int']['output'];
  totalUpdated: Scalars['Int']['output'];
  updated: Array<FeatureUpdateResult>;
};

export type BulkOperationResult = {
  __typename?: 'BulkOperationResult';
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type BulkProductStockInput = {
  cost_price: Scalars['Float']['input'];
  personnel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  qty: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
};

export type BulkUpdateFeaturesInput = {
  enabled: Scalars['Boolean']['input'];
  features: Array<FeatureModule>;
  tenantId: Scalars['ID']['input'];
};

export type CampaginCondition = {
  __typename?: 'CampaginCondition';
  Model: Scalars['String']['output'];
  attribute: Scalars['String']['output'];
  operator: ComparisonOperator;
  value: Scalars['Float']['output'];
};

export type CampaginConditionInput = {
  Model: Scalars['String']['input'];
  attribute: Scalars['String']['input'];
  operator: ComparisonOperator;
  value: Scalars['Float']['input'];
};

export type Campaign = {
  __typename?: 'Campaign';
  campaignImageUrl?: Maybe<Scalars['String']['output']>;
  conditions: Array<CampaginCondition>;
  couponCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  participation?: Maybe<CampaignParticipation>;
  startDate: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CampaignFilter = {
  endDate?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
  startDate?: InputMaybe<DateOperator>;
  title?: InputMaybe<StringOperator>;
};

export type CampaignModel = {
  __typename?: 'CampaignModel';
  attributes: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  operators: Array<ComparisonOperator>;
};

export type CampaignParticipation = {
  __typename?: 'CampaignParticipation';
  earnedPoints: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
};

export type CancelReservationInput = {
  reservation_id: Scalars['ID']['input'];
};

export type CartAssignmentFilter = {
  order?: InputMaybe<CartFilter>;
  priority?: InputMaybe<NumberOperator>;
  rider_id?: InputMaybe<IdOperator>;
  status?: InputMaybe<StringOperator>;
};

export type CartConflict = {
  __typename?: 'CartConflict';
  allowReplace: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type CartFilter = {
  cart_number?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  customer_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  instantDelivery?: InputMaybe<BooleanOperator>;
  offline?: InputMaybe<BooleanOperator>;
  payment_id?: InputMaybe<StringOperator>;
  shop_id?: InputMaybe<IdOperator>;
  source?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  supplier_status?: InputMaybe<StringOperator>;
  tracking_code?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
  user_type?: InputMaybe<StringOperator>;
};

/** Cart item for the in-app cart, backed by duke_cart_items and enriched with product data. */
export type CartItem = {
  __typename?: 'CartItem';
  discount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  inStock: Scalars['Boolean']['output'];
  isFreeDelivery?: Maybe<Scalars['Boolean']['output']>;
  lineSubtotal?: Maybe<Scalars['Float']['output']>;
  lineTotal?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Product>;
  productSku: Scalars['ID']['output'];
  profit: Scalars['Float']['output'];
  profitType: ProfitType;
  quantity: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
};

export type CartOperationResult = {
  __typename?: 'CartOperationResult';
  cart?: Maybe<AppCart>;
  conflict?: Maybe<CartConflict>;
  success: Scalars['Boolean']['output'];
};

export type Catalog = {
  __typename?: 'Catalog';
  banner: Scalars['String']['output'];
  config?: Maybe<CollectionConfig>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFreeDelivery?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CatalogCollection = {
  __typename?: 'CatalogCollection';
  catalog?: Maybe<Catalog>;
  collection?: Maybe<Catalog>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CatalogConfigInput = {
  collection_id: Scalars['ID']['input'];
  free_delivery_locations?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_free_delivery: Scalars['Boolean']['input'];
  reduction_type?: InputMaybe<ReductionType>;
  reduction_value?: InputMaybe<Scalars['Float']['input']>;
};

export type CatalogData = CatalogCollection | CategoryCollection | ProductCollection;

export type CatalogFilter = {
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
};

export type CatalogInput = {
  banner: Scalars['String']['input'];
  config?: InputMaybe<CatalogConfigInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CatalogMedia = {
  __typename?: 'CatalogMedia';
  id?: Maybe<Scalars['ID']['output']>;
  media?: Maybe<Scalars['String']['output']>;
};

export enum CatalogType {
  Catalog = 'CATALOG',
  Category = 'CATEGORY',
  Product = 'PRODUCT'
}

export type CategoryCollection = {
  __typename?: 'CategoryCollection';
  category?: Maybe<ProductCategory>;
  collection?: Maybe<Catalog>;
  id?: Maybe<Scalars['ID']['output']>;
};

export enum CategoryType {
  Digital = 'DIGITAL',
  Physical = 'PHYSICAL'
}

export enum ChangeBy {
  Ops = 'ops',
  Reseller = 'reseller'
}

export type ChangePaymentSetupInput = {
  country: CountryCode;
  provider_type: ProviderType;
};

export type ChangeTeamNameInput = {
  name: Scalars['String']['input'];
  team_id: Scalars['ID']['input'];
};

export enum ChannelType {
  Sms = 'sms',
  Whatsapp = 'whatsapp'
}

export type ChargeWalletInput = {
  amount: Scalars['Float']['input'];
  currency: CurrencyInput;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  secret: Scalars['String']['input'];
  wallet_id: Scalars['ID']['input'];
};

export type ChargeWalletResponseDto = {
  __typename?: 'ChargeWalletResponseDTO';
  error?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transaction?: Maybe<Transaction>;
};

export type CheckTransactionInput = {
  reference: Scalars['String']['input'];
  type: TransactionType;
};

export type CheckTransactionResponseDto = {
  __typename?: 'CheckTransactionResponseDTO';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  transaction?: Maybe<Transaction>;
};

export type ClaimCouponInput = {
  code: Scalars['String']['input'];
  user_id: Scalars['ID']['input'];
};

export type ClaimDiscountRequestDto = {
  discount_code: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ClearStorefrontCartInput = {
  cart_id: Scalars['ID']['input'];
};

export type ClientProductFilter = {
  catalog?: InputMaybe<CatalogFilter>;
  category?: InputMaybe<ProductCategoryFilter>;
  combination_string?: InputMaybe<StringOperator>;
  distributionChannels?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  main_stock?: InputMaybe<NumberOperator>;
  price?: InputMaybe<NumberOperator>;
  productType?: InputMaybe<ProductType>;
  product_origin?: InputMaybe<StringOperator>;
  qty?: InputMaybe<NumberOperator>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
  sku?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  tags?: InputMaybe<StringOperator>;
  title?: InputMaybe<StringOperator>;
  uuid?: InputMaybe<StringOperator>;
};

export type ClosingBalance = {
  __typename?: 'ClosingBalance';
  balance: Scalars['Float']['output'];
  closed: Scalars['Boolean']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  wallet_id: Scalars['ID']['output'];
};

export type CollectionConfig = {
  __typename?: 'CollectionConfig';
  /** this array carries location ids if the collection is restricted to certain locations */
  free_delivery_locations?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  id: Scalars['ID']['output'];
  is_free_delivery?: Maybe<Scalars['Boolean']['output']>;
  /** The reduction type can be either percentage or amount */
  reduction_type?: Maybe<ReductionType>;
  /** The reduction value can be either a percentage or an amount depending on the reduction type */
  reduction_value?: Maybe<Scalars['Float']['output']>;
};

export enum ComparisonOperator {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL'
}

export enum Condition {
  And = 'and',
  Or = 'or'
}

export type ConsumeReservationInput = {
  reservation_id: Scalars['ID']['input'];
};

export enum CountryCode {
  Gh = 'GH',
  Ng = 'NG',
  Za = 'ZA'
}

export type CountryCodeOperator = {
  eq?: InputMaybe<CountryCode>;
  in?: InputMaybe<Array<CountryCode>>;
  notIn?: InputMaybe<Array<CountryCode>>;
};

export type Coupon = {
  __typename?: 'Coupon';
  cash_rewards?: Maybe<Scalars['Float']['output']>;
  code: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  duration: Scalars['String']['output'];
  durationValue: Scalars['Int']['output'];
  expired: Scalars['Boolean']['output'];
  expires_on?: Maybe<Scalars['DateTime']['output']>;
  free_deliveries?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  issueToAll: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neverEnds: Scalars['Boolean']['output'];
  number_of_days?: Maybe<Scalars['Int']['output']>;
  redemption?: Maybe<CouponRedemption>;
  start_date?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: CouponType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CouponDuration {
  Day = 'day',
  Hour = 'hour',
  Minute = 'minute',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export type CouponFilter = {
  cash_rewards?: InputMaybe<NumberOperator>;
  code?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  createdAt?: InputMaybe<DateOperator>;
  expires_on?: InputMaybe<DateOperator>;
  free_deliveries?: InputMaybe<NumberOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  number_of_days?: InputMaybe<NumberOperator>;
  special?: InputMaybe<BooleanOperator>;
  type?: InputMaybe<CouponType>;
  user_id?: InputMaybe<IdOperator>;
};

export type CouponInput = {
  cash_rewards?: InputMaybe<Scalars['Float']['input']>;
  code: Scalars['String']['input'];
  duration: CouponDuration;
  duration_value: Scalars['Int']['input'];
  free_deliveries?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueToAll: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  neverEnds: Scalars['Boolean']['input'];
  start_date: Scalars['Date']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type: CouponType;
};

export type CouponInsight = {
  __typename?: 'CouponInsight';
  totalConsumed?: Maybe<Scalars['Int']['output']>;
  totalConsumedValue?: Maybe<Scalars['Float']['output']>;
  totalRedemptions?: Maybe<Scalars['Int']['output']>;
  totalRedemptionsValue?: Maybe<Scalars['Float']['output']>;
};

export type CouponRedemption = {
  __typename?: 'CouponRedemption';
  cash_rewards_exhausted?: Maybe<Scalars['Float']['output']>;
  coupon?: Maybe<Coupon>;
  coupon_id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  free_delivery_exhausted?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  redeemed: Scalars['Boolean']['output'];
  reseller?: Maybe<User>;
  updatedAt: Scalars['DateTime']['output'];
  user_id: Scalars['ID']['output'];
};

export type CouponRedemptionFilter = {
  coupon_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  redeemed?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<IdOperator>;
};

export enum CouponType {
  CashRewards = 'cash_rewards',
  Combo = 'combo',
  FreeDelivery = 'free_delivery'
}

export type CreateAffiliateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAffiliateLinkInput = {
  affiliate_id: Scalars['ID']['input'];
  meta?: InputMaybe<Scalars['Any']['input']>;
  program_id: Scalars['ID']['input'];
  target_id?: InputMaybe<Scalars['String']['input']>;
  target_type: Scalars['String']['input'];
};

export type CreateAffiliateProgramInput = {
  commission_type: Scalars['String']['input'];
  commission_value: Scalars['Float']['input'];
  cookie_ttl_days?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};

/** Input for creating an API key */
export type CreateApiKeyInput = {
  /**
   * Expiration time in seconds from now.
   * Default: 90 days. Min: 1 hour. Max: 1 year.
   */
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  /** Additional metadata to store with the key */
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Display name for the API key */
  name: Scalars['String']['input'];
  /**
   * Specific permissions to grant (resource:action format).
   * If omitted, default read-only permissions are applied.
   */
  permissions?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Enable rate limiting for this key (default: true) */
  rateLimitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum requests within the rate limit window */
  rateLimitMax?: InputMaybe<Scalars['Int']['input']>;
  /** Rate limit window in milliseconds */
  rateLimitTimeWindow?: InputMaybe<Scalars['Int']['input']>;
  /** Amount to refill the remaining count */
  refillAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Interval in milliseconds to refill remaining count */
  refillInterval?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum usage count (null = unlimited) */
  remaining?: InputMaybe<Scalars['Int']['input']>;
};

/** Result of API key creation - includes the raw key (only shown once) */
export type CreateApiKeyResult = {
  __typename?: 'CreateApiKeyResult';
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  permissions?: Maybe<Scalars['JSONObject']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type CreateCampaignInput = {
  campaignImageUrl?: InputMaybe<Scalars['String']['input']>;
  conditions: Array<CampaginConditionInput>;
  couponCode: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateCustomStatusInput = {
  allowedTransitions?: InputMaybe<Array<Scalars['String']['input']>>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  isCancellation?: InputMaybe<Scalars['Boolean']['input']>;
  isTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  statusCode: Scalars['String']['input'];
  statusColor?: InputMaybe<Scalars['String']['input']>;
  statusDescription?: InputMaybe<Scalars['String']['input']>;
  statusIcon?: InputMaybe<Scalars['String']['input']>;
  statusLabel: Scalars['String']['input'];
};

export type CreateCustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDeveloperInput = {
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type CreateDigitalOrderInput = {
  customer_address_id?: InputMaybe<Scalars['ID']['input']>;
  customer_id: Scalars['ID']['input'];
  delivery_id?: InputMaybe<Scalars['ID']['input']>;
  orderItems?: InputMaybe<Array<InputMaybe<OrderProductInput>>>;
  orderTotal: Scalars['Float']['input'];
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  user_id: Scalars['ID']['input'];
};

export type CreateDiscountRequestDto = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  banner_url: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<UserType>;
  description: Scalars['String']['input'];
  expiry_date: Scalars['String']['input'];
  fixed_amount_allocation?: InputMaybe<FixedAmountAllocation>;
  is_draft: Scalars['Boolean']['input'];
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locations_tagname?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  product_condition?: InputMaybe<ProductCondition>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  redemptions_limit?: InputMaybe<Scalars['Int']['input']>;
  start_date: Scalars['String']['input'];
  type: DiscountType;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  valid_country: Scalars['String']['input'];
};

export type CreateInventoryLocationInput = {
  address?: InputMaybe<Scalars['Any']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parent_location_id?: InputMaybe<Scalars['ID']['input']>;
  settings?: InputMaybe<Scalars['Any']['input']>;
  type: InventoryLocationType;
};

export type CreateMemberInput = {
  developer_id: Scalars['ID']['input'];
  role: MemberRole;
  team_id: Scalars['ID']['input'];
};

export type CreateOperationCountryInput = {
  country: Scalars['String']['input'];
  country_code: CountryCode;
  currency: CurrencyCode;
  currency_code: CurrencyCode;
  currency_symbol: Scalars['String']['input'];
  iso_code: Scalars['String']['input'];
  phone_code: Scalars['String']['input'];
};

export type CreateOrganizationInput = {
  adminEmail: Scalars['String']['input'];
  adminName?: InputMaybe<Scalars['String']['input']>;
  adminPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customDomain?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  name: Scalars['String']['input'];
  operationCountries?: InputMaybe<Array<Scalars['ID']['input']>>;
  plan?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  tenantType?: InputMaybe<TenantType>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationPaymentAccountInput = {
  account_address?: InputMaybe<Scalars['JSONObject']['input']>;
  account_code: Scalars['String']['input'];
  account_name: Scalars['String']['input'];
  account_number: Scalars['String']['input'];
  account_provider: Scalars['String']['input'];
  currency: CurrencyInput;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  payment_type: PaymentType;
  transfer_type: TransferType;
};

export type CreatePaymentRequestInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  destination_wallet_id?: InputMaybe<Scalars['ID']['input']>;
  destination_wallet_type: WalletType;
  execution_date?: InputMaybe<Scalars['DateTime']['input']>;
  idempotency_key: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  source_wallet_id?: InputMaybe<Scalars['ID']['input']>;
  source_wallet_type: WalletType;
};

export type CreatePluginRequestDto = {
  banner_image?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  developer?: InputMaybe<Scalars['String']['input']>;
  endpoint: Scalars['String']['input'];
  logo: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreatePspCredentialInput = {
  country: Scalars['String']['input'];
  environment: PspEnvironment;
  label?: InputMaybe<Scalars['String']['input']>;
  provider: PspProvider;
  public_key?: InputMaybe<Scalars['String']['input']>;
  secret_key: Scalars['String']['input'];
  webhook_secret?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReservationInput = {
  expires_at: Scalars['Date']['input'];
  location_id?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  reference_id: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};

export type CreateSalesRequestDto = {
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  order_date?: InputMaybe<Scalars['String']['input']>;
  order_id: Scalars['ID']['input'];
  order_value: Scalars['Float']['input'];
  payment_reference?: InputMaybe<Scalars['ID']['input']>;
  product_cost: Scalars['Float']['input'];
  product_price: Scalars['Float']['input'];
  profit_added: Scalars['Float']['input'];
  reseller_id?: InputMaybe<Scalars['ID']['input']>;
  sku: Scalars['String']['input'];
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSharedProductRequestDto = {
  product_cost_price: Scalars['Float']['input'];
  product_id: Scalars['ID']['input'];
  profit_added_by_reseller: Scalars['Float']['input'];
  shared_by: Scalars['ID']['input'];
  total_selling_price: Scalars['Float']['input'];
};

export type CreateSharedProductResponseDto = {
  __typename?: 'CreateSharedProductResponseDto';
  sharedProduct?: Maybe<SharedProduct>;
};

export type CreateShopRequestDto = {
  /** Profile image */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** The public-facing contact email address for the shop. Customers will use this email to communicate with the shop owner. */
  contactEmail: Scalars['String']['input'];
  /** Country code of where shop is located */
  country: CountryCode;
  /** Backdrop banner image */
  coverImage?: InputMaybe<Scalars['String']['input']>;
  /** Currency code the shop will receive payouts in. */
  currency: CurrencyCode;
  deliveryAgent?: InputMaybe<DeliveryAgent>;
  deliveryOption?: InputMaybe<DeliveryOption>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The shop owner's email address. Tendo will use this email address to communicate with the shop owner. */
  email: Scalars['String']['input'];
  /** Indicates whether shop is active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<ShopLocationRequestDto>;
  /** Full name of shop */
  name: Scalars['String']['input'];
  ownerId: Scalars['ID']['input'];
  paymentOptions: Array<InputMaybe<PaymentOption>>;
  phone: Scalars['String']['input'];
  /** Tags used to identify the shop */
  shopTags: Array<InputMaybe<Scalars['String']['input']>>;
  shopType: ShopType;
  shortUrl?: InputMaybe<Scalars['String']['input']>;
  /** The host name only. Should NOT contain .mysoko.shop. */
  sokoWorldHostname: Scalars['String']['input'];
};

export type CreateShopResponseDto = {
  __typename?: 'CreateShopResponseDto';
  shopId?: Maybe<Scalars['ID']['output']>;
};

export type CreateStorefrontCartInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  items: Array<InputMaybe<StorefrontCartItemInput>>;
  shop_id: Scalars['ID']['input'];
  status?: InputMaybe<StorefrontCartStatusType>;
};

export type CreateTeamCredentialInput = {
  scope: Array<Scalars['String']['input']>;
  team_id: Scalars['ID']['input'];
};

export type CreateTeamInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTopDealBannerInput = {
  url: Scalars['String']['input'];
};

export type CreateUserAccountSecurityInput = {
  securityToken: Scalars['String']['input'];
  securityType: AccountSecurityType;
  userType: UserType;
  user_id: Scalars['ID']['input'];
};

export type CreateWalletInput = {
  currency: CurrencyInput;
  merchant_id: Scalars['ID']['input'];
  wallet_type?: InputMaybe<WalletType>;
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum CurrencyCode {
  Ghs = 'GHS',
  Ngn = 'NGN',
  Zar = 'ZAR'
}

export type CurrencyInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum CurrencyType {
  Base = 'base',
  Fiat = 'fiat',
  Points = 'points'
}

export type CurrencyTypeOperator = {
  eq?: InputMaybe<CurrencyType>;
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<Array<Maybe<CustomerAddress>>>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  reseller?: Maybe<User>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  area: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  landmark?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
};

export type CustomerAuth = {
  __typename?: 'CustomerAuth';
  customerId: Scalars['ID']['output'];
  customerType: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  tenantId: Scalars['ID']['output'];
};

export type CustomerAuthPayload = {
  __typename?: 'CustomerAuthPayload';
  token: Scalars['String']['output'];
  user?: Maybe<Customer>;
};

export type CustomerFilter = {
  address?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  phone?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type CustomerInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type CustomerLoginInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerPaymentProfileInput = {
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type CustomerProfileInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type CustomerSubscription = {
  __typename?: 'CustomerSubscription';
  billing_cycle: BillingCycle;
  created_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  next_billing_date: Scalars['Date']['output'];
  status: SubscriptionStatus;
  subscription?: Maybe<Subscription>;
  subscription_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
  user_email: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
};

export type CustomerSubscriptionInput = {
  billing_cycle: BillingCycle;
  created_at?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  next_billing_date: Scalars['Date']['input'];
  status: SubscriptionStatus;
  subscription?: InputMaybe<SubscriptionInput>;
  subscription_id: Scalars['ID']['input'];
  updated_at?: InputMaybe<Scalars['Date']['input']>;
  user_email: Scalars['String']['input'];
  user_id: Scalars['ID']['input'];
};

export type DashboardKpis = {
  __typename?: 'DashboardKpis';
  activeUsers: Scalars['Int']['output'];
  activeUsersChange: Scalars['String']['output'];
  apiRequests: Scalars['Int']['output'];
  apiRequestsChange: Scalars['String']['output'];
  monthlyRevenue: Scalars['Float']['output'];
  monthlyRevenueChange: Scalars['String']['output'];
  totalTenants: Scalars['Int']['output'];
  totalTenantsChange: Scalars['String']['output'];
};

export type DashboardStats = {
  __typename?: 'DashboardStats';
  activityFeed: Array<ActivityFeedItem>;
  kpis: DashboardKpis;
  monthlyGrowth: Array<MonthlyGrowthPoint>;
  planDistribution: Array<PlanDistributionItem>;
  recentSignups: Array<RecentSignup>;
  topTenants: Array<TopTenant>;
};

export type DateOperator = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  between?: InputMaybe<DateRange>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateRange = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type DateRangeDto = {
  __typename?: 'DateRangeDTO';
  end?: Maybe<Scalars['Date']['output']>;
  start?: Maybe<Scalars['Date']['output']>;
};

export type DateRangeFilter = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeletePspCredentialInput = {
  country: CountryCode;
  environment: PspEnvironment;
  provider: PspProvider;
};

export type DeleteUserAccountSecurityInput = {
  id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};

export type DeliveredOrders = {
  __typename?: 'DeliveredOrders';
  cart_id?: Maybe<Scalars['ID']['output']>;
  cart_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  date_to_credit?: Maybe<Scalars['Date']['output']>;
  days_profit_has_delayed?: Maybe<Scalars['Int']['output']>;
  deposit_refunded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  order_id?: Maybe<Scalars['ID']['output']>;
  order_number?: Maybe<Scalars['String']['output']>;
  profit_added?: Maybe<Scalars['Float']['output']>;
  profit_credit_status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type DeliveredOrdersFilter = {
  cart_id?: InputMaybe<IdOperator>;
  cart_number?: InputMaybe<StringOperator>;
  date_to_credit?: InputMaybe<DateOperator>;
  days_profit_has_delayed?: InputMaybe<NumberOperator>;
  id?: InputMaybe<IdOperator>;
  order_id?: InputMaybe<IdOperator>;
  order_number?: InputMaybe<StringOperator>;
  profit_credit_status?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type Delivery = {
  __typename?: 'Delivery';
  country?: Maybe<Scalars['String']['output']>;
  hasInstantDelivery: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  instantDeliveryPrice?: Maybe<Scalars['Float']['output']>;
  isPayOnline: Scalars['Boolean']['output'];
  location: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['ID']['output']>;
};

export enum DeliveryAgent {
  Shop = 'SHOP',
  Tendo = 'TENDO'
}

export type DeliveryFilter = {
  country?: InputMaybe<StringOperator>;
  hasInstantDelivery?: InputMaybe<BooleanOperator>;
  id?: InputMaybe<StringOperator>;
  isPayOnline?: InputMaybe<BooleanOperator>;
  location?: InputMaybe<StringOperator>;
  price?: InputMaybe<NumberOperator>;
  remarks?: InputMaybe<StringOperator>;
  supplierId?: InputMaybe<IdOperator>;
};

export type DeliveryInput = {
  hasInstantDelivery: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  instantDeliveryPrice?: InputMaybe<Scalars['Float']['input']>;
  isPayOnline: Scalars['Boolean']['input'];
  location: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export enum DeliveryOption {
  Manual = 'Manual',
  Swoove = 'Swoove'
}

export type DeliveryPricesInput = {
  address: Scalars['String']['input'];
  destination?: InputMaybe<Latlng>;
  source?: InputMaybe<Latlng>;
};

export type DeliveryZone = {
  __typename?: 'DeliveryZone';
  base_price: Scalars['Float']['output'];
  coordinates: Array<LatLng>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DeliveryZonesFilter = {
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
};

export type DeliveryZonesInput = {
  base_price: Scalars['Float']['input'];
  coordinates: Array<InputMaybe<Scalars['Any']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type Details = {
  dob?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  referred_by?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type Developer = {
  __typename?: 'Developer';
  id: Scalars['ID']['output'];
  memberships?: Maybe<Array<Maybe<Member>>>;
  reseller?: Maybe<User>;
  reseller_id: Scalars['ID']['output'];
};

export type DeveloperLoginInput = {
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type DeveloperResponse = {
  __typename?: 'DeveloperResponse';
  developer?: Maybe<Developer>;
  team?: Maybe<Team>;
  token?: Maybe<Scalars['String']['output']>;
};

export type DigitalOrder = {
  __typename?: 'DigitalOrder';
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  customerId: Scalars['ID']['output'];
  deliveryMode: Scalars['String']['output'];
  digitalDetails?: Maybe<Scalars['Any']['output']>;
  id: Scalars['ID']['output'];
  orderNumber: Scalars['String']['output'];
  paymentReference?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  product?: Maybe<Product>;
  productId: Scalars['ID']['output'];
  profitAdded: Scalars['Float']['output'];
  reseller?: Maybe<User>;
  resellerId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  supplier?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DigitalOrderFilter = {
  id?: InputMaybe<IdOperator>;
  orderNumber?: InputMaybe<StringOperator>;
};

export type DigitalOrderInput = {
  customerId: Scalars['ID']['input'];
  deliveryMode: Scalars['String']['input'];
  digitalDetails?: InputMaybe<Scalars['Any']['input']>;
  paymentReference?: InputMaybe<Scalars['String']['input']>;
  paymentStatus: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  productId: Scalars['ID']['input'];
  profitAdded: Scalars['Float']['input'];
  resellerId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type DisableFeatureInput = {
  feature: FeatureModule;
  tenantId: Scalars['ID']['input'];
};

export type Discount = {
  __typename?: 'Discount';
  amount?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_by?: Maybe<UserType>;
  description: Scalars['String']['output'];
  expiry_date: Scalars['String']['output'];
  fixed_amount_allocation?: Maybe<FixedAmountAllocation>;
  has_expired?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_draft: Scalars['Boolean']['output'];
  locations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locations_tagname?: Maybe<Scalars['String']['output']>;
  number_of_times_used?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  product_condition?: Maybe<ProductCondition>;
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  redemptions_limit?: Maybe<Scalars['Int']['output']>;
  start_date: Scalars['String']['output'];
  tenant_id?: Maybe<Scalars['String']['output']>;
  type: DiscountType;
  updated_at?: Maybe<Scalars['Date']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
  valid_country: Scalars['String']['output'];
};

export type DiscountFilter = {
  amount?: InputMaybe<NumberOperator>;
  code?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<DateOperator>;
  created_by?: InputMaybe<StringOperator>;
  description?: InputMaybe<StringOperator>;
  expiry_date?: InputMaybe<DateOperator>;
  fixed_amount_allocation?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  is_draft?: InputMaybe<BooleanOperator>;
  locations?: InputMaybe<StringOperator>;
  number_of_times_used?: InputMaybe<NumberOperator>;
  percentage?: InputMaybe<NumberOperator>;
  redemptions_limit?: InputMaybe<NumberOperator>;
  start_date?: InputMaybe<DateOperator>;
  tenant_id?: InputMaybe<StringOperator>;
  type?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
  user_id?: InputMaybe<IdOperator>;
  valid_country?: InputMaybe<StringOperator>;
};

export type DiscountProductCondition = {
  __typename?: 'DiscountProductCondition';
  condition: ProductCondition;
  created_at?: Maybe<Scalars['Date']['output']>;
  discount_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  product?: Maybe<Product>;
  product_sku: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type DiscountProductConditionFilter = {
  condition?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<DateOperator>;
  discount_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  product_sku?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
};

export type DiscountProductConditionRequestDto = {
  condition: ProductCondition;
  product_sku: Scalars['String']['input'];
};

export enum DiscountType {
  FixedAmount = 'FIXED_AMOUNT',
  FreeDelivery = 'FREE_DELIVERY',
  Percentage = 'PERCENTAGE'
}

export type DiscountUseFilter = {
  country_code?: InputMaybe<StringOperator>;
  discount_code?: InputMaybe<StringOperator>;
  discount_id?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type DoesShopExistResponseDto = {
  __typename?: 'DoesShopExistResponseDto';
  shopExists?: Maybe<Scalars['Boolean']['output']>;
};

export type DownloadWalletStatementInput = {
  dateRange?: InputMaybe<DateRangeFilter>;
  user_id: Scalars['ID']['input'];
  wallet_id: Scalars['ID']['input'];
};

export type EnableFeatureInput = {
  config?: InputMaybe<Scalars['JSONObject']['input']>;
  feature: FeatureModule;
  tenantId: Scalars['ID']['input'];
};

export type EstimateTypeDetails = {
  __typename?: 'EstimateTypeDetails';
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FeatureAccessCheck = {
  __typename?: 'FeatureAccessCheck';
  hasAccess: Scalars['Boolean']['output'];
  missingFeature?: Maybe<FeatureModule>;
  reason?: Maybe<Scalars['String']['output']>;
  requiredRole?: Maybe<UserRole>;
  requiredTier?: Maybe<SubscriptionTier>;
};

export enum FeatureCategory {
  Addon = 'ADDON',
  Core = 'CORE',
  Enterprise = 'ENTERPRISE',
  Premium = 'PREMIUM'
}

export type FeatureDefinition = {
  __typename?: 'FeatureDefinition';
  allowedRoles: Array<UserRole>;
  category: FeatureCategory;
  conflictsWith?: Maybe<Array<FeatureModule>>;
  dependsOn?: Maybe<Array<FeatureModule>>;
  description: Scalars['String']['output'];
  module: FeatureModule;
  name: Scalars['String']['output'];
  requiredTier: Array<SubscriptionTier>;
  tenantTypes: Array<TenantType>;
};

/** Feature Flag Management Schema */
export enum FeatureModule {
  AdminPanel = 'ADMIN_PANEL',
  Affiliates = 'AFFILIATES',
  AliexpressIntegration = 'ALIEXPRESS_INTEGRATION',
  Analytics = 'ANALYTICS',
  ApiAccess = 'API_ACCESS',
  BrandedMobileApp = 'BRANDED_MOBILE_APP',
  Cart = 'CART',
  Coupons = 'COUPONS',
  Customers = 'CUSTOMERS',
  CustomDomain = 'CUSTOM_DOMAIN',
  Delivery = 'DELIVERY',
  DeliveryZones = 'DELIVERY_ZONES',
  DistributorModule = 'DISTRIBUTOR_MODULE',
  Inventory = 'INVENTORY',
  Leaderboard = 'LEADERBOARD',
  LoyaltyRewards = 'LOYALTY_REWARDS',
  Marketplace = 'MARKETPLACE',
  Notifications = 'NOTIFICATIONS',
  Orders = 'ORDERS',
  Payments = 'PAYMENTS',
  Pickup = 'PICKUP',
  Products = 'PRODUCTS',
  Reporting = 'REPORTING',
  Reselling = 'RESELLING',
  RestaurantModule = 'RESTAURANT_MODULE',
  RoleManagement = 'ROLE_MANAGEMENT',
  ShopifyIntegration = 'SHOPIFY_INTEGRATION',
  Storefront = 'STOREFRONT',
  StripeIntegration = 'STRIPE_INTEGRATION',
  Suppliers = 'SUPPLIERS',
  SupplierDashboard = 'SUPPLIER_DASHBOARD',
  UserManagement = 'USER_MANAGEMENT',
  Wallet = 'WALLET',
  WalletAdvanced = 'WALLET_ADVANCED',
  XeroIntegration = 'XERO_INTEGRATION'
}

export type FeatureUpdateResult = {
  __typename?: 'FeatureUpdateResult';
  enabled: Scalars['Boolean']['output'];
  errors?: Maybe<Array<Scalars['String']['output']>>;
  feature: FeatureModule;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FeatureUsageStats = {
  __typename?: 'FeatureUsageStats';
  enabledTenants: Scalars['Int']['output'];
  feature: FeatureModule;
  totalTenants: Scalars['Int']['output'];
  usagePercentage: Scalars['Float']['output'];
};

export type FeaturedCategories = {
  __typename?: 'FeaturedCategories';
  banners?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  category?: Maybe<ProductCategory>;
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type FeaturedCategoriesFilter = {
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
};

export type FeaturedCategoryInput = {
  category_id: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FetchShopifyShopInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ShopifyShopFilter>;
};

export type FetchShopifyShopsInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ShopifyShopFilter>;
  pagination?: InputMaybe<Pagination>;
};

export type FetchUserInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<UserFilter>;
  pagination?: InputMaybe<Pagination>;
};

export enum FixedAmountAllocation {
  ProductSpecific = 'PRODUCT_SPECIFIC',
  TotalAmount = 'TOTAL_AMOUNT'
}

export type ForexRate = {
  __typename?: 'ForexRate';
  createdAt?: Maybe<Scalars['Date']['output']>;
  ghs?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ngn?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  zar?: Maybe<Scalars['Float']['output']>;
};

export type ForexRateFilter = {
  createdAt?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
};

export type ForexRateInput = {
  ghs?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  ngn?: InputMaybe<Scalars['Float']['input']>;
  zar?: InputMaybe<Scalars['Float']['input']>;
};

export type GeneratedAliExpressProduct = {
  __typename?: 'GeneratedAliExpressProduct';
  aliexpress_ds_product_get_response?: Maybe<AliexpressDsProductGetResponse>;
  code?: Maybe<Scalars['String']['output']>;
  request_id?: Maybe<Scalars['String']['output']>;
};

export type GetAvailablePaymentFacilitatorInput = {
  amount: Scalars['Float']['input'];
  reason_for_payment: ReasonForPayment;
};

export type GetCustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GetDeveloperFilter = {
  email?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  phone?: InputMaybe<StringOperator>;
  reseller_id?: InputMaybe<IdOperator>;
  username?: InputMaybe<StringOperator>;
};

export type GetDeveloperInput = {
  filter?: InputMaybe<GetDeveloperFilter>;
};

export type GetDevelopersInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<GetDeveloperFilter>;
  pagination?: InputMaybe<Pagination>;
};

export type GetOperationCountryInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<OperationCountryFilter>;
  pagination?: InputMaybe<Pagination>;
};

export type GetOrganizationPaymentAccountsInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<OrganizationPaymentAccountFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<SortOrder>;
};

export type GetOrganizationPaymentSetupsInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<OrganizationPaymentSetupFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<SortOrder>;
};

export type GetSalesRequestDto = {
  filter?: InputMaybe<SalesFilter>;
  pagination: Pagination;
};

export type GetSharedProductRequestDto = {
  shared_product_id: Scalars['ID']['input'];
};

export type GetShopResponseDto = {
  __typename?: 'GetShopResponseDto';
  shop?: Maybe<Shop>;
};

export type GetShopsRequestDto = {
  filter?: InputMaybe<ShopFilter>;
  pagination: Pagination;
};

export type GetStorefrontTransactionsInput = {
  condition?: InputMaybe<Condition>;
  filter: StorefrontTransactionFilter;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<SortOrder>;
};

export type GetSupplierPickupLocationInput = {
  supplier_id: Scalars['String']['input'];
};

export type GetSupportedProvidersInput = {
  country: CountryCode;
  filter?: InputMaybe<PaystackBanksFilter>;
};

export type GetTeamFilter = {
  id?: InputMaybe<IdOperator>;
  service_id?: InputMaybe<StringOperator>;
};

export type GetTeamInput = {
  filter?: InputMaybe<GetTeamFilter>;
};

export type GetTeamsFilter = {
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  service_id?: InputMaybe<StringOperator>;
};

export type GetTeamsInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<GetTeamsFilter>;
  pagination?: InputMaybe<Pagination>;
};

export type GetTenantWalletFilter = {
  currency_type?: InputMaybe<CurrencyTypeOperator>;
  tenant_id?: InputMaybe<IdOperator>;
  wallet_id?: InputMaybe<IdOperator>;
};

export type GetTenantWalletInput = {
  filter?: InputMaybe<GetTenantWalletFilter>;
};

export type GetTransactionsInput = {
  condition?: InputMaybe<Condition>;
  filter: TransactionFilter;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<SortOrder>;
};

export type GetWalletBalanceInput = {
  dateRange?: InputMaybe<DateRangeFilter>;
  wallet_id: Scalars['ID']['input'];
};

export type GetWalletFilter = {
  currency_type?: InputMaybe<CurrencyTypeOperator>;
  merchant_id?: InputMaybe<IdOperator>;
  wallet_id?: InputMaybe<IdOperator>;
};

export type GetWalletInput = {
  filter?: InputMaybe<GetWalletFilter>;
};

export type GetWalletPayoutsInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<WalletPayoutFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<SortOrder>;
};

export type GetWalletTransactionsInput = {
  filter?: InputMaybe<TransactionFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<SortOrder>;
  wallet_id: Scalars['ID']['input'];
};

export type IdOperator = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type IndustryStatusTemplate = {
  __typename?: 'IndustryStatusTemplate';
  allowedTransitions?: Maybe<Array<Scalars['String']['output']>>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isCancellation: Scalars['Boolean']['output'];
  isTerminal: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  statusCode: Scalars['String']['output'];
  statusColor?: Maybe<Scalars['String']['output']>;
  statusDescription?: Maybe<Scalars['String']['output']>;
  statusIcon?: Maybe<Scalars['String']['output']>;
  statusLabel: Scalars['String']['output'];
  tenantType: Scalars['String']['output'];
};

export type InitiateCardSetupInput = {
  integration_id: Scalars['String']['input'];
  supplier_email: Scalars['String']['input'];
  supplier_phone: Scalars['String']['input'];
};

export type InitiateCustomerPaymentInput = {
  amount: Scalars['Float']['input'];
  country: CountryCode;
  currency: CurrencyInput;
  customer: CustomerPaymentProfileInput;
  fees?: InputMaybe<Scalars['JSONObject']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  psp: PaymentFacilitator;
  redirectUrl: Scalars['String']['input'];
  secret: Scalars['String']['input'];
  tenantPaymentId: Scalars['String']['input'];
};

export type InitiateCustomerPaymentResult = {
  __typename?: 'InitiateCustomerPaymentResult';
  paymentLink?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['JSONObject']['output']>;
  status: Scalars['String']['output'];
  transaction?: Maybe<Scalars['JSONObject']['output']>;
};

export type InnerAeSkuPropertyDtos = {
  __typename?: 'InnerAeSkuPropertyDtos';
  ae_sku_property_d_t_o?: Maybe<Array<Maybe<AeSkuPropertyDto>>>;
};

export type Inventory = {
  __typename?: 'Inventory';
  allocated_quantity: Scalars['Int']['output'];
  available_quantity: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  last_updated: Scalars['Date']['output'];
  location?: Maybe<InventoryLocation>;
  location_id: Scalars['ID']['output'];
  on_hand_quantity: Scalars['Int']['output'];
  product?: Maybe<Product>;
  reserved_quantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  tenant_id: Scalars['String']['output'];
  transactions?: Maybe<Array<Maybe<InventoryTransaction>>>;
  version: Scalars['Int']['output'];
};

export enum InventoryDistinctField {
  AllocatedQuantity = 'allocated_quantity',
  AvailableQuantity = 'available_quantity',
  Id = 'id',
  LastUpdated = 'last_updated',
  LocationId = 'location_id',
  OnHandQuantity = 'on_hand_quantity',
  ReservedQuantity = 'reserved_quantity',
  Sku = 'sku'
}

export type InventoryFilter = {
  allocated_quantity?: InputMaybe<NumberOperator>;
  available_quantity?: InputMaybe<NumberOperator>;
  id?: InputMaybe<IdOperator>;
  location_id?: InputMaybe<IdOperator>;
  on_hand_quantity?: InputMaybe<NumberOperator>;
  reserved_quantity?: InputMaybe<NumberOperator>;
  sku?: InputMaybe<StringOperator>;
};

export type InventoryLocation = {
  __typename?: 'InventoryLocation';
  address?: Maybe<Scalars['Any']['output']>;
  children?: Maybe<Array<Maybe<InventoryLocation>>>;
  created_at: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  inventory_items?: Maybe<Array<Maybe<Inventory>>>;
  is_active: Scalars['Boolean']['output'];
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<InventoryLocation>;
  parent_location_id?: Maybe<Scalars['ID']['output']>;
  settings?: Maybe<Scalars['Any']['output']>;
  tenant_id: Scalars['String']['output'];
  type: InventoryLocationType;
  updated_at: Scalars['Date']['output'];
};

export type InventoryLocationAddress = {
  __typename?: 'InventoryLocationAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export enum InventoryLocationDistinctField {
  CreatedAt = 'created_at',
  Id = 'id',
  IsActive = 'is_active',
  IsDefault = 'is_default',
  Name = 'name',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

export type InventoryLocationFilter = {
  id?: InputMaybe<IdOperator>;
  is_active?: InputMaybe<BooleanOperator>;
  is_default?: InputMaybe<BooleanOperator>;
  name?: InputMaybe<StringOperator>;
  parent_location_id?: InputMaybe<IdOperator>;
  type?: InputMaybe<StringOperator>;
};

export type InventoryLocationQuantityInput = {
  location_id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type InventoryLocationSort = {
  field: InventoryLocationDistinctField;
  order: SortOrder;
};

export enum InventoryLocationType {
  Store = 'store',
  ThirdPartyLogistics = 'thirdPartyLogistics',
  Virtual = 'virtual',
  Warehouse = 'warehouse'
}

export type InventoryReservation = {
  __typename?: 'InventoryReservation';
  created_at: Scalars['Date']['output'];
  expires_at: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<InventoryLocation>;
  location_id?: Maybe<Scalars['ID']['output']>;
  quantity: Scalars['Int']['output'];
  reference_id: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  status: ReservationStatus;
  tenant_id: Scalars['String']['output'];
};

export type InventoryReservationFilter = {
  expires_at?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
  location_id?: InputMaybe<IdOperator>;
  reference_id?: InputMaybe<StringOperator>;
  sku?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
};

export type InventorySort = {
  field: InventoryDistinctField;
  order: SortOrder;
};

export type InventoryStats = {
  __typename?: 'InventoryStats';
  total_allocated: Scalars['Int']['output'];
  total_available: Scalars['Int']['output'];
  total_locations: Scalars['Int']['output'];
  total_on_hand: Scalars['Int']['output'];
  total_reserved: Scalars['Int']['output'];
  total_skus: Scalars['Int']['output'];
};

export type InventoryTransaction = {
  __typename?: 'InventoryTransaction';
  created_at: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  inventory?: Maybe<Inventory>;
  inventory_id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<InventoryLocation>;
  location_id?: Maybe<Scalars['ID']['output']>;
  quantity_change: Scalars['Int']['output'];
  reason_code?: Maybe<Scalars['String']['output']>;
  reference_id?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  tenant_id: Scalars['String']['output'];
  transaction_type: InventoryTransactionType;
  user_id?: Maybe<Scalars['String']['output']>;
};

export enum InventoryTransactionDistinctField {
  CreatedAt = 'created_at',
  Id = 'id',
  LocationId = 'location_id',
  QuantityChange = 'quantity_change',
  Sku = 'sku',
  TransactionType = 'transaction_type'
}

export type InventoryTransactionFilter = {
  created_at?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
  inventory_id?: InputMaybe<IdOperator>;
  location_id?: InputMaybe<IdOperator>;
  quantity_change?: InputMaybe<NumberOperator>;
  reason_code?: InputMaybe<StringOperator>;
  reference_id?: InputMaybe<StringOperator>;
  sku?: InputMaybe<StringOperator>;
  transaction_type?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<StringOperator>;
};

export type InventoryTransactionSort = {
  field: InventoryTransactionDistinctField;
  order: SortOrder;
};

export enum InventoryTransactionType {
  Adjustment = 'adjustment',
  Return = 'return',
  Sale = 'sale',
  Transfer = 'transfer'
}

export type Latlng = {
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
};

export type LatLng = {
  __typename?: 'LatLng';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type LatLngInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type LeaderBoardConfig = {
  __typename?: 'LeaderBoardConfig';
  firstPlaceBonusCashPoints?: Maybe<Scalars['Float']['output']>;
  firstPlaceBonusDeliveries?: Maybe<Scalars['Int']['output']>;
  secondPlaceBonusCashPoints?: Maybe<Scalars['Float']['output']>;
  secondPlaceBonusDeliveries?: Maybe<Scalars['Int']['output']>;
  thirdPlaceBonusCashPoints?: Maybe<Scalars['Float']['output']>;
  thirdPlaceBonusDeliveries?: Maybe<Scalars['Int']['output']>;
};

export type LeaderBoardConfigInput = {
  firstPlaceBonusCashPoints?: InputMaybe<Scalars['Float']['input']>;
  firstPlaceBonusDeliveries?: InputMaybe<Scalars['Int']['input']>;
  secondPlaceBonusCashPoints?: InputMaybe<Scalars['Float']['input']>;
  secondPlaceBonusDeliveries?: InputMaybe<Scalars['Int']['input']>;
  thirdPlaceBonusCashPoints?: InputMaybe<Scalars['Float']['input']>;
  thirdPlaceBonusDeliveries?: InputMaybe<Scalars['Int']['input']>;
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  points?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  reward?: Maybe<Scalars['String']['output']>;
  source_id: Scalars['ID']['output'];
};

export type LoadProductToShopify = {
  combination_string?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  media: Array<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  product_id: Scalars['ID']['input'];
  product_origin: ProductOrigin;
  qty: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
  supplier_generic_name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type LoadProductToShopifyInput = {
  integration_id?: InputMaybe<Scalars['ID']['input']>;
  products?: InputMaybe<Array<LoadProductToShopify>>;
};

export enum LockStatus {
  Frozen = 'frozen',
  Limited = 'limited',
  Open = 'open'
}

export type LogisticsInfoDto = {
  __typename?: 'LogisticsInfoDto';
  delivery_time?: Maybe<Scalars['String']['output']>;
  ship_to_country?: Maybe<Scalars['String']['output']>;
};

export type MakePaymentInput = {
  amount: Scalars['Float']['input'];
  currency: CurrencyInput;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  provider?: InputMaybe<PaystackMobileMoneyProvider>;
  reason_for_payment: ReasonForPayment;
  secret: Scalars['String']['input'];
  wallet_id?: InputMaybe<Scalars['ID']['input']>;
};

export type MakePaymentResponseDto = {
  __typename?: 'MakePaymentResponseDTO';
  error?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Member = {
  __typename?: 'Member';
  created_at?: Maybe<Scalars['Date']['output']>;
  developer?: Maybe<Developer>;
  developer_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  role: MemberRole;
  team?: Maybe<Team>;
  team_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export enum MemberRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type MoneyOperator = {
  between?: InputMaybe<MoneyRange>;
  eq?: InputMaybe<Scalars['Money']['input']>;
  gt?: InputMaybe<Scalars['Money']['input']>;
  gte?: InputMaybe<Scalars['Money']['input']>;
  lt?: InputMaybe<Scalars['Money']['input']>;
  lte?: InputMaybe<Scalars['Money']['input']>;
};

export type MoneyRange = {
  end: Scalars['Money']['input'];
  start: Scalars['Money']['input'];
};

export type MonthlyGrowthPoint = {
  __typename?: 'MonthlyGrowthPoint';
  month: Scalars['String']['output'];
  tenants: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation?: Maybe<OrganizationMember>;
  accountRegister: Auth;
  activateShop: Scalars['Boolean']['output'];
  addBusinessDocuments?: Maybe<Scalars['Boolean']['output']>;
  addComment?: Maybe<Scalars['Boolean']['output']>;
  addCommentsToProduct?: Maybe<Scalars['Boolean']['output']>;
  addCustomerToStorefrontCart?: Maybe<StorefrontCart>;
  addDeliveryToStorefrontCart?: Maybe<StorefrontCart>;
  addDeviceToken?: Maybe<Scalars['Boolean']['output']>;
  addInstantDeliveryItems?: Maybe<Scalars['Boolean']['output']>;
  addItemToStoreFrontCart?: Maybe<StorefrontCart>;
  addOrganizationPaymentAccount?: Maybe<OrganizationPaymentAccount>;
  addPaymentToStorefrontCart?: Maybe<StorefrontCart>;
  addPluginToUser?: Maybe<UserPlugin>;
  addProductConditionsToDiscount?: Maybe<Scalars['Boolean']['output']>;
  addProductToShop?: Maybe<Scalars['Boolean']['output']>;
  addProductToShopCollection?: Maybe<Scalars['Boolean']['output']>;
  addProductsToCollection?: Maybe<Scalars['Boolean']['output']>;
  addProductsToDiscount?: Maybe<Scalars['Boolean']['output']>;
  addProductsToShopCollection?: Maybe<Scalars['Boolean']['output']>;
  addPspCredential?: Maybe<PspCredential>;
  addScopeToTeamCredential?: Maybe<TeamCredential>;
  addSupplierAgreementTerms?: Maybe<Scalars['Boolean']['output']>;
  addSupplierBusinessDetails?: Maybe<Scalars['Boolean']['output']>;
  addSupplierCategories: Scalars['Boolean']['output'];
  addSupplierDeviceToken?: Maybe<Scalars['Boolean']['output']>;
  addSupplierLocation?: Maybe<SupplierLocation>;
  addSupplierPaymentDetails?: Maybe<Scalars['Boolean']['output']>;
  addTeamLogo?: Maybe<Team>;
  addTeamServiceAgreementTerms?: Maybe<TeamServiceAgreementTermsValue>;
  addToCart: CartOperationResult;
  addUserPaymentDetails?: Maybe<Scalars['Boolean']['output']>;
  addUsersToCoupon?: Maybe<Scalars['Boolean']['output']>;
  adjustInventory?: Maybe<Inventory>;
  adjustStorefrontCartItemQuantity?: Maybe<StorefrontCart>;
  allowResellingOfProduct?: Maybe<Scalars['Boolean']['output']>;
  applyForAffiliate: Affiliate;
  approvePartnership: Scalars['Boolean']['output'];
  assignOrderToRider?: Maybe<Scalars['Boolean']['output']>;
  authenticateCustomer?: Maybe<CustomerAuth>;
  authenticateWithToken: SupplierAuthPayload;
  banReseller?: Maybe<Scalars['Boolean']['output']>;
  bobCancelShipment?: Maybe<BobShipment>;
  /** create new orders for accounts */
  bobCreateOrder?: Maybe<BobOrder>;
  bobCreateShipment?: Maybe<BobShipment>;
  bulkCreateProducts?: Maybe<Scalars['Boolean']['output']>;
  bulkMarkSupplierProductInWarehouse?: Maybe<Scalars['Boolean']['output']>;
  bulkPublishOrUnpublishProducts?: Maybe<Scalars['Boolean']['output']>;
  bulkRemoveProducts?: Maybe<Scalars['Boolean']['output']>;
  bulkUnMarkSupplierProductInWarehouse?: Maybe<Scalars['Boolean']['output']>;
  /** Bulk update features for tenant */
  bulkUpdateFeatures: BulkFeatureUpdateResult;
  bulkUpdateProductSock?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateTenantProductStatus: BulkOperationResult;
  bulkVerifyProducts?: Maybe<Scalars['Boolean']['output']>;
  cancelInvitation?: Maybe<Scalars['Boolean']['output']>;
  cancelOrder?: Maybe<Order>;
  cancelReservation?: Maybe<Scalars['Boolean']['output']>;
  changePassword?: Maybe<Scalars['Boolean']['output']>;
  changePaymentSetup?: Maybe<Scalars['Boolean']['output']>;
  changeResellerSupplierShop?: Maybe<Scalars['Boolean']['output']>;
  changeResellerUsername?: Maybe<Scalars['Boolean']['output']>;
  changeSupplierEmail?: Maybe<Scalars['Boolean']['output']>;
  changeSupplierPassword?: Maybe<Scalars['Boolean']['output']>;
  changeSupplierStatus?: Maybe<Scalars['Boolean']['output']>;
  changeTeamName?: Maybe<Team>;
  chargeWallet: ChargeWalletResponseDto;
  checkPasswordAvailability?: Maybe<Scalars['Boolean']['output']>;
  claimCoupon?: Maybe<Scalars['Boolean']['output']>;
  claimDiscount?: Maybe<Scalars['Boolean']['output']>;
  clearCart: Scalars['Boolean']['output'];
  clearStorefrontCart?: Maybe<Scalars['Boolean']['output']>;
  consumeReservation?: Maybe<Scalars['Boolean']['output']>;
  createAccountSecurity?: Maybe<UserAccountSecurity>;
  createAffiliate: Affiliate;
  createAffiliateLink: AffiliateLink;
  createAffiliateProgram: AffiliateProgram;
  /**
   * Create a new API key for the current organization.
   * Returns the raw key value (only shown once).
   * Requires: apikey:create permission or owner/admin role.
   */
  createApiKey: CreateApiKeyResult;
  createAppBanner?: Maybe<Scalars['Boolean']['output']>;
  createCampaign?: Maybe<Scalars['Boolean']['output']>;
  createCatalog?: Maybe<Scalars['Boolean']['output']>;
  createCollectionConfig?: Maybe<Scalars['Boolean']['output']>;
  createCoupon?: Maybe<Scalars['Boolean']['output']>;
  createCouponForUsers?: Maybe<Scalars['Boolean']['output']>;
  createCustomOrderStatus: OrderStatusRegistry;
  createCustomer?: Maybe<Customer>;
  createCustomerAddress?: Maybe<CustomerAddress>;
  createDefaultResellerUser?: Maybe<User>;
  createDeliveryLocation: Scalars['Boolean']['output'];
  createDeliveryZone?: Maybe<Scalars['Boolean']['output']>;
  createDeveloper?: Maybe<DeveloperResponse>;
  createDigitalOrder: Scalars['String']['output'];
  createDigitalOrderReminder?: Maybe<Scalars['Boolean']['output']>;
  createDiscount?: Maybe<Discount>;
  createFeaturedCategory?: Maybe<Scalars['Boolean']['output']>;
  createInventoryLocation?: Maybe<InventoryLocation>;
  createNotification?: Maybe<Notification>;
  createOfflineOrder?: Maybe<Scalars['Boolean']['output']>;
  createOperationCountry?: Maybe<OperationCountry>;
  createOrder: Scalars['ID']['output'];
  createOrganization?: Maybe<Organization>;
  createPartnership: Scalars['Boolean']['output'];
  createPickUpLocation: Scalars['Boolean']['output'];
  createPlugin?: Maybe<Plugin>;
  createProduct?: Maybe<Scalars['Boolean']['output']>;
  createProductCategory?: Maybe<Scalars['Boolean']['output']>;
  createProductShipment?: Maybe<Scalars['Boolean']['output']>;
  createProductTemplate?: Maybe<Scalars['Boolean']['output']>;
  createPromoBanner?: Maybe<Scalars['Boolean']['output']>;
  createReservation?: Maybe<InventoryReservation>;
  createReview: Scalars['Boolean']['output'];
  createRider?: Maybe<Scalars['Boolean']['output']>;
  createSharedProduct: CreateSharedProductResponseDto;
  createShop: CreateShopResponseDto;
  createShopCollection?: Maybe<Scalars['Boolean']['output']>;
  createStorefrontCart?: Maybe<StorefrontCart>;
  createSupplier?: Maybe<SupplierCreationResponse>;
  createSupplierCustomer?: Maybe<Customer>;
  createTenantProduct: Product;
  createTerm: Scalars['Boolean']['output'];
  createTopDeal?: Maybe<Scalars['Boolean']['output']>;
  createTopDealBanner?: Maybe<Scalars['Boolean']['output']>;
  createTrendingProduct?: Maybe<Scalars['Boolean']['output']>;
  createWallet: WalletResponseDto;
  creditUserWalletWithDelayedOrders?: Maybe<Scalars['Boolean']['output']>;
  customerSignIn?: Maybe<CustomerAuthPayload>;
  customerSignUp?: Maybe<CustomerAuthPayload>;
  customerSupplierSignUp?: Maybe<CustomerAuthPayload>;
  deleteAccountSecurity?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Delete an API key.
   * Requires: apikey:delete permission or owner/admin role.
   */
  deleteApiKey: Scalars['Boolean']['output'];
  deleteAppBanner?: Maybe<Scalars['Boolean']['output']>;
  deleteCampaign?: Maybe<Scalars['Boolean']['output']>;
  deleteCoupon?: Maybe<Scalars['Boolean']['output']>;
  deleteDeliveryLocation: Scalars['Boolean']['output'];
  deleteDeliveryZone?: Maybe<Scalars['Boolean']['output']>;
  deleteDigitalOrder?: Maybe<Scalars['Boolean']['output']>;
  deleteDiscount?: Maybe<Scalars['Boolean']['output']>;
  deleteFeaturedCategory?: Maybe<Scalars['Boolean']['output']>;
  deleteInventoryLocation?: Maybe<Scalars['Boolean']['output']>;
  deleteOperationCountry?: Maybe<Scalars['Boolean']['output']>;
  deleteOrganization?: Maybe<Scalars['Boolean']['output']>;
  deleteOrganizationPaymentAccount?: Maybe<Scalars['Boolean']['output']>;
  deletePartnership: Scalars['Boolean']['output'];
  deletePickUpLocation: Scalars['Boolean']['output'];
  deletePlugin?: Maybe<Scalars['Boolean']['output']>;
  deleteProductTemplate?: Maybe<Scalars['Boolean']['output']>;
  deletePspCredential?: Maybe<Scalars['Boolean']['output']>;
  deleteReseller?: Maybe<Scalars['Boolean']['output']>;
  deleteTenantProduct: Scalars['Boolean']['output'];
  deleteTerm: Scalars['Boolean']['output'];
  deleteTopDeal?: Maybe<Scalars['Boolean']['output']>;
  deleteTrendingProduct?: Maybe<Scalars['Boolean']['output']>;
  developerLogin?: Maybe<DeveloperResponse>;
  /** Disable a feature for tenant */
  disableFeature: FeatureUpdateResult;
  disableSupplier?: Maybe<Scalars['Boolean']['output']>;
  dispatchTestNotification?: Maybe<Scalars['Boolean']['output']>;
  editProductStat?: Maybe<Scalars['Boolean']['output']>;
  /** Enable a feature for tenant */
  enableFeature: FeatureUpdateResult;
  enableSupplier?: Maybe<Scalars['Boolean']['output']>;
  endLeaderBoardSession?: Maybe<Scalars['Boolean']['output']>;
  exportProducts: Scalars['String']['output'];
  forgotPassword?: Maybe<Scalars['String']['output']>;
  freezeWallet?: Maybe<WalletResponseDto>;
  generateAccessToken?: Maybe<Scalars['Boolean']['output']>;
  getOrderOtp?: Maybe<Scalars['Boolean']['output']>;
  initializeOrderStatusRegistry: Array<OrderStatusRegistry>;
  /** Initialize default features for new tenant */
  initializeTenantFeatures: BulkFeatureUpdateResult;
  initiateCardSetup?: Maybe<Scalars['String']['output']>;
  initiateCustomerPayment: InitiateCustomerPaymentResult;
  inviteMember?: Maybe<OrganizationInvitation>;
  inviteResellerBySupplier?: Maybe<Scalars['Boolean']['output']>;
  joinSupplierResellerNetwork?: Maybe<Scalars['Boolean']['output']>;
  loadProductsToShopify?: Maybe<Scalars['Boolean']['output']>;
  makeExternalPayment?: Maybe<Scalars['String']['output']>;
  makePayment?: Maybe<Scalars['String']['output']>;
  makeRequestForProduct?: Maybe<Scalars['Boolean']['output']>;
  makeWalletWithdrawal: ChargeWalletResponseDto;
  markAllNotificationsAsRead?: Maybe<Scalars['Boolean']['output']>;
  markCouponAsExpired: Scalars['Boolean']['output'];
  markNotificationAsRead?: Maybe<Notification>;
  markSupplierProductInWarehouse?: Maybe<Scalars['Boolean']['output']>;
  onPurchaseSharedProduct?: Maybe<OnPurchaseSharedProductResponseDto>;
  opsAttendToProduct?: Maybe<Scalars['Boolean']['output']>;
  pauseAffiliateProgram: AffiliateProgram;
  platformActivateUser: PlatformUser;
  platformAssignRole: PlatformUser;
  platformChangePassword: Scalars['Boolean']['output'];
  platformConfirmPasswordReset: Scalars['Boolean']['output'];
  platformCreateOrganization?: Maybe<Organization>;
  platformCreateRole: PlatformRole;
  platformCreateUser: PlatformUser;
  platformDeactivateUser: PlatformUser;
  platformDeleteOrganization?: Maybe<Scalars['Boolean']['output']>;
  platformDeleteRole: Scalars['Boolean']['output'];
  platformDeleteUser: Scalars['Boolean']['output'];
  platformDuplicateRole: PlatformRole;
  platformLogin: PlatformAuthResponse;
  platformLogout: Scalars['Boolean']['output'];
  platformReactivateOrganization?: Maybe<Organization>;
  platformRefreshToken: PlatformRefreshResponse;
  platformRequestPasswordReset: Scalars['Boolean']['output'];
  platformResetUserPassword: Scalars['String']['output'];
  platformSuspendOrganization?: Maybe<Organization>;
  platformUpdateOrganization?: Maybe<Organization>;
  platformUpdateOrganizationPlan?: Maybe<Organization>;
  platformUpdateRole: PlatformRole;
  platformUpdateUser: PlatformUser;
  processManualProfitPayout?: Maybe<Scalars['Boolean']['output']>;
  processOrder?: Maybe<Scalars['Boolean']['output']>;
  processProfitPayout?: Maybe<Scalars['Boolean']['output']>;
  publishOrUnpublishProduct?: Maybe<Scalars['Boolean']['output']>;
  refundResellerSecurityDeposit?: Maybe<Scalars['Boolean']['output']>;
  refundResellerSecurityDepositBulk?: Maybe<Scalars['Boolean']['output']>;
  regenerateTeamCredential?: Maybe<TeamCredential>;
  /** Reinitialize status registry from tenant type template (WARNING: deletes custom statuses) */
  reinitializeStatusRegistry: Array<OrderStatusRegistry>;
  rejectInvitation?: Maybe<Scalars['Boolean']['output']>;
  rejectPartnership: Scalars['Boolean']['output'];
  releaseAccount?: Maybe<Scalars['Boolean']['output']>;
  releaseUserAccount?: Maybe<Scalars['Boolean']['output']>;
  removeCatalog?: Maybe<Scalars['Boolean']['output']>;
  removeCategory?: Maybe<Scalars['Boolean']['output']>;
  removeCollectionConfig?: Maybe<Scalars['Boolean']['output']>;
  removeCustomer?: Maybe<Scalars['Boolean']['output']>;
  removeCustomerAddress?: Maybe<Scalars['Boolean']['output']>;
  removeFailedItems?: Maybe<Scalars['Boolean']['output']>;
  removeFromCart: AppCart;
  removeInstantDeliveryItems?: Maybe<Scalars['Boolean']['output']>;
  removeItemFromStorefrontCart?: Maybe<StorefrontCart>;
  removeMember?: Maybe<MutationResponse>;
  removePluginFromUser?: Maybe<Scalars['Boolean']['output']>;
  removeProduct?: Maybe<Scalars['Boolean']['output']>;
  removeProductCategory?: Maybe<Scalars['Boolean']['output']>;
  removeProductCombination?: Maybe<Scalars['Boolean']['output']>;
  removeProductConditionsFromDiscount?: Maybe<Scalars['Boolean']['output']>;
  removeProductFromCollection?: Maybe<Scalars['Boolean']['output']>;
  removeProductFromShop?: Maybe<Scalars['Boolean']['output']>;
  removeProductImage?: Maybe<Scalars['Boolean']['output']>;
  removePromoBanner?: Maybe<Scalars['Boolean']['output']>;
  removeResellerBySupplier?: Maybe<Scalars['Boolean']['output']>;
  removeReview?: Maybe<Scalars['Boolean']['output']>;
  removeRider?: Maybe<Scalars['Boolean']['output']>;
  removeShopCollection?: Maybe<Scalars['Boolean']['output']>;
  removeShopifyShop?: Maybe<Scalars['Boolean']['output']>;
  removeSupplier?: Maybe<Scalars['Boolean']['output']>;
  removeTopDealsBanners?: Maybe<Scalars['Boolean']['output']>;
  removeUser?: Maybe<Scalars['Boolean']['output']>;
  removeVariation?: Maybe<Scalars['Boolean']['output']>;
  reportOrderIssueByRider?: Maybe<Scalars['Boolean']['output']>;
  requestChangeEmail?: Maybe<Scalars['Boolean']['output']>;
  requestChangePhone?: Maybe<Scalars['Boolean']['output']>;
  requestChangeSupplierPhone?: Maybe<Scalars['Boolean']['output']>;
  requestEmailVerification?: Maybe<Scalars['String']['output']>;
  requestOTP: RequestOtpResponse;
  requestPhoneVerification?: Maybe<PhoneVerificationOutPut>;
  requestRiderOTP: RequestOtpResponse;
  requestSupplierEmailVerification: Scalars['String']['output'];
  requestSupplierOTP?: Maybe<RequestSupplierOtpResponse>;
  requestSupplierPartnershipOnProducts?: Maybe<Scalars['Boolean']['output']>;
  requestSupplierPhoneVerification: RequestSupplierPhoneVerificationResponse;
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  resetSupplierPassword?: Maybe<Scalars['Boolean']['output']>;
  /** Reset tenant features to default for their type and tier */
  resetTenantFeatures: BulkFeatureUpdateResult;
  resetUserAccount?: Maybe<Scalars['Boolean']['output']>;
  retryProcessingItems?: Maybe<Scalars['Boolean']['output']>;
  reverseTransaction?: Maybe<Transaction>;
  reviewOrder: Scalars['Boolean']['output'];
  /**
   * Revoke all API keys for the current organization.
   * Requires: owner role only.
   */
  revokeAllApiKeys: Scalars['Int']['output'];
  rotatePspCredential?: Maybe<PspCredential>;
  sendMarketingPushNotification?: Maybe<Scalars['Boolean']['output']>;
  sendSupplierResetPasswordMail?: Maybe<Scalars['Boolean']['output']>;
  setActiveOrganization?: Maybe<TenantContext>;
  setSupplierPickupLocation?: Maybe<Scalars['Boolean']['output']>;
  setSupplierProductMarkup?: Maybe<Scalars['Boolean']['output']>;
  setupAccount: RequestOtpResponse;
  setupCard?: Maybe<Scalars['String']['output']>;
  setupOrganizationPayment?: Maybe<OrganizationPaymentSetup>;
  socialMediaLogin?: Maybe<Auth>;
  stripeAccountSession?: Maybe<Scalars['String']['output']>;
  stripeExternalBankAccount?: Maybe<Scalars['Boolean']['output']>;
  submitChargeOTP?: Maybe<PaystackSuccess>;
  supplierResellerLogin?: Maybe<Auth>;
  supplierSignIn: SupplierAuthPayload;
  suspendReseller?: Maybe<Scalars['Boolean']['output']>;
  switchOrganization?: Maybe<TenantContext>;
  syncShopifyProducts?: Maybe<Scalars['Boolean']['output']>;
  toggleCategoryState: Scalars['Boolean']['output'];
  toggleFreeDelivery: Scalars['Boolean']['output'];
  transferInventory?: Maybe<Scalars['Boolean']['output']>;
  transitionOrderStatus?: Maybe<Order>;
  unMarkSupplierProductInWarehouse?: Maybe<Scalars['Boolean']['output']>;
  unlockWallet?: Maybe<WalletResponseDto>;
  unshareProduct: Scalars['Boolean']['output'];
  updateAccountSecurity?: Maybe<UserAccountSecurity>;
  updateAffiliateStatus: Affiliate;
  /**
   * Update an existing API key.
   * Requires: apikey:update permission or owner/admin role.
   */
  updateApiKey?: Maybe<ApiKey>;
  updateAppBanner?: Maybe<Scalars['Boolean']['output']>;
  updateCampaign?: Maybe<Campaign>;
  updateCartItem: AppCart;
  updateCatalog?: Maybe<Scalars['Boolean']['output']>;
  updateCollectionConfig?: Maybe<Scalars['Boolean']['output']>;
  updateCoupon?: Maybe<Scalars['Boolean']['output']>;
  updateCustomer?: Maybe<Scalars['Boolean']['output']>;
  updateCustomerAddressOnOrder?: Maybe<Scalars['Boolean']['output']>;
  updateDeliveryLocation: Scalars['Boolean']['output'];
  updateDeliveryZone?: Maybe<Scalars['Boolean']['output']>;
  updateDigitalOrder?: Maybe<Scalars['Boolean']['output']>;
  updateDiscount?: Maybe<Discount>;
  updateForexRate?: Maybe<Scalars['Boolean']['output']>;
  updateInventoryLocation?: Maybe<InventoryLocation>;
  updateMemberRole?: Maybe<MutationResponse>;
  updateMyCustomerProfile: Customer;
  updateOperationCountry?: Maybe<OperationCountry>;
  updateOpsConfig: Scalars['Boolean']['output'];
  updateOrderDetailsOps?: Maybe<Scalars['Boolean']['output']>;
  updateOrderSKU?: Maybe<Scalars['Boolean']['output']>;
  updateOrderStatusByRider?: Maybe<Scalars['Boolean']['output']>;
  updateOrderStatusDefinition: OrderStatusRegistry;
  updateOrganization?: Maybe<Organization>;
  updateOrganizationPaymentAccount?: Maybe<OrganizationPaymentAccount>;
  updatePartnership: Scalars['Boolean']['output'];
  updatePickUpLocation: Scalars['Boolean']['output'];
  updatePlugin?: Maybe<Scalars['Boolean']['output']>;
  updateProduct?: Maybe<Scalars['Boolean']['output']>;
  updateProductCategories?: Maybe<Scalars['Boolean']['output']>;
  updateProductCategory?: Maybe<Scalars['Boolean']['output']>;
  updateProductCategoryAndTags?: Maybe<Scalars['Boolean']['output']>;
  updateProductCombination?: Maybe<Scalars['Boolean']['output']>;
  updateProductDistribution?: Maybe<Scalars['Boolean']['output']>;
  updateProductInformation?: Maybe<Scalars['Boolean']['output']>;
  updateProductInstantDeliveryState?: Maybe<Scalars['Boolean']['output']>;
  updateProductInventory?: Maybe<Scalars['Boolean']['output']>;
  updateProductLikeState?: Maybe<Scalars['Boolean']['output']>;
  updateProductMedia?: Maybe<Scalars['Boolean']['output']>;
  updateProductSaveState?: Maybe<Scalars['Boolean']['output']>;
  updateProductShipment?: Maybe<Scalars['Boolean']['output']>;
  updateProductStatus?: Maybe<Scalars['Boolean']['output']>;
  updateProductStock?: Maybe<Scalars['Boolean']['output']>;
  updateProductTemplate?: Maybe<Scalars['Boolean']['output']>;
  updateProductVariation?: Maybe<Scalars['Boolean']['output']>;
  updatePromoBanner?: Maybe<Scalars['Boolean']['output']>;
  updateRider?: Maybe<Scalars['Boolean']['output']>;
  updateShopCollection?: Maybe<Scalars['Boolean']['output']>;
  updateShopDetails: UpdateShopDetailsResponseDto;
  updateStorefrontCartStatus?: Maybe<Scalars['Boolean']['output']>;
  updateSupplier: Scalars['Boolean']['output'];
  updateSupplierAgreementTerms?: Maybe<Scalars['Boolean']['output']>;
  updateSupplierBusinessContact?: Maybe<Scalars['Boolean']['output']>;
  updateSupplierBusinessDetails?: Maybe<Scalars['Boolean']['output']>;
  updateSupplierDetails?: Maybe<Scalars['Boolean']['output']>;
  updateSupplierGenericName?: Maybe<Scalars['Boolean']['output']>;
  updateSupplierPayment?: Maybe<SupplierPaymentDetails>;
  updateSupplierProfile?: Maybe<Scalars['Boolean']['output']>;
  updateSupplierShopDetails: UpdateShopDetailsResponseDto;
  updateSupplierShopSlug?: Maybe<Shop>;
  updateSupplierType?: Maybe<Scalars['Boolean']['output']>;
  updateTenantCustomerStatus: Customer;
  updateTenantProduct: Product;
  updateTenantSettings?: Maybe<TenantInfo>;
  /** Update tenant subscription tier and adjust features */
  updateTenantTier: TenantUpgradeResult;
  updateTerm: Scalars['Boolean']['output'];
  updateUserDetails?: Maybe<Scalars['Boolean']['output']>;
  updateVariation?: Maybe<Scalars['Boolean']['output']>;
  updaterResellerShopSlug?: Maybe<Shop>;
  userLogin?: Maybe<Auth>;
  verifyAccountSecurity?: Maybe<User>;
  verifyAliExpressProduct?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Verify an API key (for testing purposes).
   * Requires: apikey:verify permission or owner/admin role.
   */
  verifyApiKey: VerifyApiKeyResult;
  verifyEmail?: Maybe<Scalars['Boolean']['output']>;
  verifyOTP?: Maybe<Scalars['Boolean']['output']>;
  verifyOrderOtp?: Maybe<Scalars['Boolean']['output']>;
  verifyProduct?: Maybe<Scalars['Boolean']['output']>;
  verifyRiderOTP: RiderAuth;
  verifySupplierAccount?: Maybe<Scalars['Boolean']['output']>;
  verifySupplierBusiness?: Maybe<Scalars['Boolean']['output']>;
  verifySupplierOTP?: Maybe<Scalars['Boolean']['output']>;
  walletPayoutDecision?: Maybe<WalletPayoutResponseDto>;
};


export type MutationAcceptInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type MutationAccountRegisterArgs = {
  input?: InputMaybe<AccountRegisterInput>;
};


export type MutationActivateShopArgs = {
  data: ActivateShopRequestDto;
};


export type MutationAddBusinessDocumentsArgs = {
  input?: InputMaybe<AddBusinessDocumentInput>;
};


export type MutationAddCommentArgs = {
  input?: InputMaybe<AddCommentInput>;
};


export type MutationAddCommentsToProductArgs = {
  input?: InputMaybe<AddCommentsToProductInput>;
};


export type MutationAddCustomerToStorefrontCartArgs = {
  input: AddCustomerToStorefrontCartInput;
};


export type MutationAddDeliveryToStorefrontCartArgs = {
  input: AddDeliveryToStorefrontCartInput;
};


export type MutationAddDeviceTokenArgs = {
  device: Scalars['String']['input'];
  token: Scalars['String']['input'];
  user_id: Scalars['ID']['input'];
};


export type MutationAddInstantDeliveryItemsArgs = {
  skus: Array<Scalars['String']['input']>;
};


export type MutationAddItemToStoreFrontCartArgs = {
  input: AddItemToStorefrontCartInput;
};


export type MutationAddOrganizationPaymentAccountArgs = {
  input: CreateOrganizationPaymentAccountInput;
};


export type MutationAddPaymentToStorefrontCartArgs = {
  input: AddPaymentToStorefrontCartInput;
};


export type MutationAddPluginToUserArgs = {
  data: AddPluginToUserRequestDto;
};


export type MutationAddProductConditionsToDiscountArgs = {
  input: Array<AddProductConditionToDiscountRequestDto>;
};


export type MutationAddProductToShopArgs = {
  product_id: Scalars['ID']['input'];
  profit_added: Scalars['Float']['input'];
  shop_id: Scalars['ID']['input'];
};


export type MutationAddProductToShopCollectionArgs = {
  collection_id: Scalars['ID']['input'];
  product_id: Scalars['ID']['input'];
};


export type MutationAddProductsToCollectionArgs = {
  input?: InputMaybe<AddProductsToCollectionInput>;
};


export type MutationAddProductsToDiscountArgs = {
  discountId: Scalars['ID']['input'];
  productSKUs: Array<Scalars['String']['input']>;
};


export type MutationAddProductsToShopCollectionArgs = {
  collection_id: Scalars['ID']['input'];
  product_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationAddPspCredentialArgs = {
  input: CreatePspCredentialInput;
};


export type MutationAddScopeToTeamCredentialArgs = {
  input: AddScopeToTeamCredentialInput;
};


export type MutationAddSupplierAgreementTermsArgs = {
  input?: InputMaybe<AddSupplierAgreementTermsInput>;
};


export type MutationAddSupplierBusinessDetailsArgs = {
  input?: InputMaybe<SupplierBusinessInput>;
};


export type MutationAddSupplierCategoriesArgs = {
  categories: Array<Scalars['ID']['input']>;
  supplier_id: Scalars['ID']['input'];
};


export type MutationAddSupplierDeviceTokenArgs = {
  input?: InputMaybe<SupplierAddDeviceTokenInput>;
};


export type MutationAddSupplierLocationArgs = {
  input?: InputMaybe<AddSupplierLocationInput>;
};


export type MutationAddSupplierPaymentDetailsArgs = {
  input?: InputMaybe<AddSupplierPaymentInput>;
};


export type MutationAddTeamLogoArgs = {
  input: AddTeamLogoInput;
};


export type MutationAddTeamServiceAgreementTermsArgs = {
  input: AddTeamServiceAgreementTermsInput;
};


export type MutationAddToCartArgs = {
  input: AddToCartInput;
};


export type MutationAddUserPaymentDetailsArgs = {
  input?: InputMaybe<UserPaymentInput>;
};


export type MutationAddUsersToCouponArgs = {
  input: UsersCouponInput;
};


export type MutationAdjustInventoryArgs = {
  input: AdjustInventoryInput;
};


export type MutationAdjustStorefrontCartItemQuantityArgs = {
  input: AdjustStorefrontCartItemQuantityInput;
};


export type MutationAllowResellingOfProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApplyForAffiliateArgs = {
  input: AffiliateApplicationInput;
};


export type MutationApprovePartnershipArgs = {
  id: Scalars['ID']['input'];
  term_id: Scalars['ID']['input'];
};


export type MutationAssignOrderToRiderArgs = {
  orderId: Scalars['ID']['input'];
  priority: Scalars['Int']['input'];
  riderId: Scalars['ID']['input'];
};


export type MutationAuthenticateCustomerArgs = {
  token: Scalars['String']['input'];
};


export type MutationAuthenticateWithTokenArgs = {
  input?: InputMaybe<AuthenticateWithTokenInput>;
};


export type MutationBanResellerArgs = {
  input?: InputMaybe<BanResellerInput>;
};


export type MutationBobCancelShipmentArgs = {
  data: BobCancelShipmentRequestDto;
};


export type MutationBobCreateOrderArgs = {
  data: BobCreateOrderRequestDto;
};


export type MutationBobCreateShipmentArgs = {
  data: BobCreateShipmentRequestDto;
};


export type MutationBulkCreateProductsArgs = {
  products?: InputMaybe<Array<InputMaybe<TempCreateProductInput>>>;
};


export type MutationBulkMarkSupplierProductInWarehouseArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkPublishOrUnpublishProductsArgs = {
  ids: Array<Scalars['ID']['input']>;
  personnel: Scalars['String']['input'];
  published: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBulkRemoveProductsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkUnMarkSupplierProductInWarehouseArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkUpdateFeaturesArgs = {
  input: BulkUpdateFeaturesInput;
};


export type MutationBulkUpdateProductSockArgs = {
  input?: InputMaybe<Array<BulkProductStockInput>>;
};


export type MutationBulkUpdateTenantProductStatusArgs = {
  productIds: Array<Scalars['ID']['input']>;
  published: Scalars['Boolean']['input'];
};


export type MutationBulkVerifyProductsArgs = {
  input: Array<VerifyProductInput>;
};


export type MutationCancelInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type MutationCancelOrderArgs = {
  orderId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelReservationArgs = {
  input: CancelReservationInput;
};


export type MutationChangePasswordArgs = {
  input?: InputMaybe<ChangePasswordInput>;
};


export type MutationChangePaymentSetupArgs = {
  input: ChangePaymentSetupInput;
};


export type MutationChangeResellerSupplierShopArgs = {
  reseller_id: Scalars['ID']['input'];
  supplier_shop_id: Scalars['ID']['input'];
};


export type MutationChangeResellerUsernameArgs = {
  input?: InputMaybe<ChangeResellerUsernameInput>;
};


export type MutationChangeSupplierEmailArgs = {
  input?: InputMaybe<SupplierEmailChangeInput>;
};


export type MutationChangeSupplierPasswordArgs = {
  input?: InputMaybe<SupplierPasswordChangeInput>;
};


export type MutationChangeSupplierStatusArgs = {
  id: Scalars['ID']['input'];
  supplier_status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangeTeamNameArgs = {
  input: ChangeTeamNameInput;
};


export type MutationChargeWalletArgs = {
  input: ChargeWalletInput;
};


export type MutationCheckPasswordAvailabilityArgs = {
  input?: InputMaybe<CheckPasswordAvailabilityInput>;
};


export type MutationClaimCouponArgs = {
  input: ClaimCouponInput;
};


export type MutationClaimDiscountArgs = {
  input: ClaimDiscountRequestDto;
};


export type MutationClearCartArgs = {
  user_id: Scalars['ID']['input'];
};


export type MutationClearStorefrontCartArgs = {
  input: ClearStorefrontCartInput;
};


export type MutationConsumeReservationArgs = {
  input: ConsumeReservationInput;
};


export type MutationCreateAccountSecurityArgs = {
  input: CreateUserAccountSecurityInput;
};


export type MutationCreateAffiliateArgs = {
  input: CreateAffiliateInput;
};


export type MutationCreateAffiliateLinkArgs = {
  input: CreateAffiliateLinkInput;
};


export type MutationCreateAffiliateProgramArgs = {
  input: CreateAffiliateProgramInput;
};


export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


export type MutationCreateAppBannerArgs = {
  input: AppBannerInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateCatalogArgs = {
  input?: InputMaybe<CatalogInput>;
};


export type MutationCreateCollectionConfigArgs = {
  input?: InputMaybe<CatalogConfigInput>;
};


export type MutationCreateCouponArgs = {
  input: CouponInput;
};


export type MutationCreateCouponForUsersArgs = {
  input: UsersCouponInput;
};


export type MutationCreateCustomOrderStatusArgs = {
  input: CreateCustomStatusInput;
};


export type MutationCreateCustomerArgs = {
  input?: InputMaybe<CustomerInput>;
};


export type MutationCreateCustomerAddressArgs = {
  customer_id: Scalars['ID']['input'];
  input?: InputMaybe<AddressInput>;
};


export type MutationCreateDeliveryLocationArgs = {
  input: DeliveryInput;
};


export type MutationCreateDeliveryZoneArgs = {
  input?: InputMaybe<DeliveryZonesInput>;
};


export type MutationCreateDeveloperArgs = {
  input: CreateDeveloperInput;
};


export type MutationCreateDigitalOrderArgs = {
  input: DigitalOrderInput;
};


export type MutationCreateDigitalOrderReminderArgs = {
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDiscountArgs = {
  input: CreateDiscountRequestDto;
};


export type MutationCreateFeaturedCategoryArgs = {
  banners?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['ID']['input'];
  color: Scalars['String']['input'];
};


export type MutationCreateInventoryLocationArgs = {
  input: CreateInventoryLocationInput;
};


export type MutationCreateNotificationArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOfflineOrderArgs = {
  input?: InputMaybe<Array<InputMaybe<OfflineOrdersInput>>>;
};


export type MutationCreateOperationCountryArgs = {
  input: CreateOperationCountryInput;
};


export type MutationCreateOrderArgs = {
  input?: InputMaybe<OrderCreateInput>;
};


export type MutationCreateOrganizationArgs = {
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type MutationCreatePartnershipArgs = {
  client: Scalars['ID']['input'];
  contractor: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  skus: Array<Scalars['String']['input']>;
};


export type MutationCreatePickUpLocationArgs = {
  input: PickUpInput;
};


export type MutationCreatePluginArgs = {
  data: CreatePluginRequestDto;
};


export type MutationCreateProductArgs = {
  input?: InputMaybe<CreateProductInput>;
};


export type MutationCreateProductCategoryArgs = {
  input?: InputMaybe<ProductCategoryInput>;
};


export type MutationCreateProductShipmentArgs = {
  input?: InputMaybe<ProductShipmentInput>;
};


export type MutationCreateProductTemplateArgs = {
  body?: InputMaybe<Array<TemplateInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreatePromoBannerArgs = {
  input?: InputMaybe<PromoBannerInput>;
};


export type MutationCreateReservationArgs = {
  input: CreateReservationInput;
};


export type MutationCreateReviewArgs = {
  input: ReviewInput;
};


export type MutationCreateRiderArgs = {
  input: RiderInput;
};


export type MutationCreateSharedProductArgs = {
  input: CreateSharedProductRequestDto;
};


export type MutationCreateShopArgs = {
  data: CreateShopRequestDto;
};


export type MutationCreateShopCollectionArgs = {
  input?: InputMaybe<ShopCollectionInput>;
};


export type MutationCreateStorefrontCartArgs = {
  input: CreateStorefrontCartInput;
};


export type MutationCreateSupplierArgs = {
  input?: InputMaybe<SupplierInput>;
};


export type MutationCreateSupplierCustomerArgs = {
  input?: InputMaybe<CustomerInput>;
  supplier_id: Scalars['ID']['input'];
};


export type MutationCreateTenantProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateTermArgs = {
  input: TermInput;
};


export type MutationCreateTopDealArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationCreateTopDealBannerArgs = {
  input: CreateTopDealBannerInput;
};


export type MutationCreateTrendingProductArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationCreateWalletArgs = {
  input: CreateWalletInput;
};


export type MutationCreditUserWalletWithDelayedOrdersArgs = {
  orders: Array<InputMaybe<Scalars['ID']['input']>>;
  paid_security_deposit?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCustomerSignInArgs = {
  input?: InputMaybe<CustomerLoginInput>;
};


export type MutationCustomerSignUpArgs = {
  input?: InputMaybe<CustomerInput>;
  user_id: Scalars['ID']['input'];
};


export type MutationCustomerSupplierSignUpArgs = {
  input?: InputMaybe<CustomerInput>;
  supplier_id: Scalars['ID']['input'];
};


export type MutationDeleteAccountSecurityArgs = {
  input: DeleteUserAccountSecurityInput;
};


export type MutationDeleteApiKeyArgs = {
  keyId: Scalars['ID']['input'];
};


export type MutationDeleteAppBannerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCampaignArgs = {
  filter?: InputMaybe<CampaignFilter>;
};


export type MutationDeleteCouponArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDeliveryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDeliveryZoneArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDigitalOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDiscountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeaturedCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInventoryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOperationCountryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationDeleteOrganizationPaymentAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePartnershipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePickUpLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePluginArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePspCredentialArgs = {
  input: DeletePspCredentialInput;
};


export type MutationDeleteResellerArgs = {
  input?: InputMaybe<DeleteResellerInput>;
};


export type MutationDeleteTenantProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTermArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTopDealArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationDeleteTrendingProductArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationDeveloperLoginArgs = {
  input: DeveloperLoginInput;
};


export type MutationDisableFeatureArgs = {
  input: DisableFeatureInput;
};


export type MutationDisableSupplierArgs = {
  id: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
};


export type MutationDispatchTestNotificationArgs = {
  message: Scalars['String']['input'];
  pushToken?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationEditProductStatArgs = {
  input: EditProductStatInput;
};


export type MutationEnableFeatureArgs = {
  input: EnableFeatureInput;
};


export type MutationEnableSupplierArgs = {
  enableProducts?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationEndLeaderBoardSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExportProductsArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ProductFilter>;
};


export type MutationForgotPasswordArgs = {
  input?: InputMaybe<ForgotPasswordInput>;
};


export type MutationFreezeWalletArgs = {
  wallet_id: Scalars['ID']['input'];
};


export type MutationGenerateAccessTokenArgs = {
  code: Scalars['String']['input'];
};


export type MutationGetOrderOtpArgs = {
  customer_id: Scalars['ID']['input'];
  order_id: Scalars['ID']['input'];
};


export type MutationInitializeOrderStatusRegistryArgs = {
  tenantType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInitializeTenantFeaturesArgs = {
  tenantId: Scalars['ID']['input'];
  tenantType: TenantType;
  tier?: InputMaybe<SubscriptionTier>;
};


export type MutationInitiateCardSetupArgs = {
  input?: InputMaybe<InitiateCardSetupInput>;
};


export type MutationInitiateCustomerPaymentArgs = {
  input: InitiateCustomerPaymentInput;
};


export type MutationInviteMemberArgs = {
  email: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  role: Scalars['String']['input'];
};


export type MutationInviteResellerBySupplierArgs = {
  email: Scalars['String']['input'];
  supplier_id: Scalars['ID']['input'];
  terms_id: Scalars['ID']['input'];
};


export type MutationJoinSupplierResellerNetworkArgs = {
  reseller_id: Scalars['ID']['input'];
  supplier_id: Scalars['ID']['input'];
  terms_id: Scalars['ID']['input'];
};


export type MutationLoadProductsToShopifyArgs = {
  input?: InputMaybe<LoadProductToShopifyInput>;
};


export type MutationMakeExternalPaymentArgs = {
  input: MakePaymentInput;
};


export type MutationMakePaymentArgs = {
  input: MakePaymentInput;
};


export type MutationMakeRequestForProductArgs = {
  input?: InputMaybe<MakeRequestForProduct>;
};


export type MutationMakeWalletWithdrawalArgs = {
  input: WalletWithdrawalInput;
};


export type MutationMarkCouponAsExpiredArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkNotificationAsReadArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationMarkSupplierProductInWarehouseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOnPurchaseSharedProductArgs = {
  input?: InputMaybe<OnPurchaseSharedProductRequestDto>;
};


export type MutationOpsAttendToProductArgs = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  media?: InputMaybe<Array<Scalars['String']['input']>>;
  personnel?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPauseAffiliateProgramArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformActivateUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformAssignRoleArgs = {
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationPlatformChangePasswordArgs = {
  input: PlatformChangePasswordInput;
};


export type MutationPlatformConfirmPasswordResetArgs = {
  input: PlatformConfirmResetPasswordInput;
};


export type MutationPlatformCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationPlatformCreateRoleArgs = {
  input: PlatformRoleInput;
};


export type MutationPlatformCreateUserArgs = {
  input: PlatformUserInput;
};


export type MutationPlatformDeactivateUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformDuplicateRoleArgs = {
  id: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
};


export type MutationPlatformLoginArgs = {
  input: PlatformLoginInput;
};


export type MutationPlatformReactivateOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationPlatformRequestPasswordResetArgs = {
  input: PlatformResetPasswordInput;
};


export type MutationPlatformResetUserPasswordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlatformSuspendOrganizationArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPlatformUpdateOrganizationArgs = {
  id: Scalars['ID']['input'];
  input: PlatformUpdateOrganizationInput;
};


export type MutationPlatformUpdateOrganizationPlanArgs = {
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  plan: Scalars['String']['input'];
};


export type MutationPlatformUpdateRoleArgs = {
  id: Scalars['ID']['input'];
  input: PlatformRoleInput;
};


export type MutationPlatformUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input: PlatformUserInput;
};


export type MutationProcessManualProfitPayoutArgs = {
  cart_number: Scalars['String']['input'];
};


export type MutationProcessOrderArgs = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProcessProfitPayoutArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationPublishOrUnpublishProductArgs = {
  id: Scalars['ID']['input'];
  personnel: Scalars['String']['input'];
  published: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRefundResellerSecurityDepositArgs = {
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  reference: Scalars['String']['input'];
};


export type MutationRefundResellerSecurityDepositBulkArgs = {
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  references: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationRegenerateTeamCredentialArgs = {
  input: CreateTeamCredentialInput;
};


export type MutationReinitializeStatusRegistryArgs = {
  tenantType: Scalars['String']['input'];
};


export type MutationRejectInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type MutationRejectPartnershipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReleaseAccountArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationRemoveCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCollectionConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCustomerAddressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveFailedItemsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRemoveFromCartArgs = {
  cart_item_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};


export type MutationRemoveInstantDeliveryItemsArgs = {
  skus: Array<Scalars['String']['input']>;
};


export type MutationRemoveItemFromStorefrontCartArgs = {
  input?: InputMaybe<RemoveItemFromStorefrontCartInput>;
};


export type MutationRemoveMemberArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemovePluginFromUserArgs = {
  filter: UserPluginFilter;
};


export type MutationRemoveProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveProductCategoryArgs = {
  category_id: Scalars['ID']['input'];
  product_id: Scalars['ID']['input'];
};


export type MutationRemoveProductCombinationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveProductConditionsFromDiscountArgs = {
  productConditionIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveProductFromCollectionArgs = {
  input?: InputMaybe<AddProductsToCollectionInput>;
};


export type MutationRemoveProductFromShopArgs = {
  product_id: Scalars['ID']['input'];
  shop_id: Scalars['ID']['input'];
};


export type MutationRemoveProductImageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePromoBannerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveResellerBySupplierArgs = {
  reseller_id: Scalars['ID']['input'];
  supplier_id: Scalars['ID']['input'];
};


export type MutationRemoveReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveRiderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveShopCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveShopifyShopArgs = {
  supplier_id: Scalars['ID']['input'];
};


export type MutationRemoveSupplierArgs = {
  filter?: InputMaybe<SupplierFilter>;
};


export type MutationRemoveTopDealsBannersArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveVariationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReportOrderIssueByRiderArgs = {
  input: RiderIssueReportInput;
};


export type MutationRequestChangeEmailArgs = {
  input?: InputMaybe<RequestChangeEmailInput>;
};


export type MutationRequestChangePhoneArgs = {
  input?: InputMaybe<RequestChangePhoneInput>;
};


export type MutationRequestChangeSupplierPhoneArgs = {
  input?: InputMaybe<RequestChangeSupplierPhoneInput>;
};


export type MutationRequestEmailVerificationArgs = {
  input?: InputMaybe<RequestEmailVerificationInput>;
};


export type MutationRequestOtpArgs = {
  input?: InputMaybe<RequestOtpInput>;
};


export type MutationRequestPhoneVerificationArgs = {
  input?: InputMaybe<CheckPasswordAvailabilityInput>;
};


export type MutationRequestRiderOtpArgs = {
  input?: InputMaybe<RequestRiderOtpInput>;
};


export type MutationRequestSupplierEmailVerificationArgs = {
  input?: InputMaybe<RequestEmailVerificationInput>;
};


export type MutationRequestSupplierOtpArgs = {
  input?: InputMaybe<RequestOtpInput>;
};


export type MutationRequestSupplierPartnershipOnProductsArgs = {
  product_skus: Array<Scalars['String']['input']>;
  supplier_id: Scalars['ID']['input'];
};


export type MutationRequestSupplierPhoneVerificationArgs = {
  input?: InputMaybe<RequestSupplierPhoneVerificationInput>;
};


export type MutationResetPasswordArgs = {
  input?: InputMaybe<ResetPasswordInput>;
};


export type MutationResetSupplierPasswordArgs = {
  input?: InputMaybe<SupplierPasswordResetInput>;
};


export type MutationResetTenantFeaturesArgs = {
  tenantId: Scalars['ID']['input'];
};


export type MutationResetUserAccountArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationRetryProcessingItemsArgs = {
  country: Scalars['String']['input'];
};


export type MutationReverseTransactionArgs = {
  input: ReverseTransactionInput;
};


export type MutationReviewOrderArgs = {
  orderId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRotatePspCredentialArgs = {
  input: RotatePspCredentialInput;
};


export type MutationSendMarketingPushNotificationArgs = {
  message: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationSendSupplierResetPasswordMailArgs = {
  input?: InputMaybe<SupplierPasswordResetMailInput>;
};


export type MutationSetActiveOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationSetSupplierPickupLocationArgs = {
  input?: InputMaybe<SetSupplierPickupLocationInput>;
};


export type MutationSetSupplierProductMarkupArgs = {
  input?: InputMaybe<SetSupplierProductMarkupInput>;
};


export type MutationSetupAccountArgs = {
  input?: InputMaybe<SetupAccountInput>;
};


export type MutationSetupOrganizationPaymentArgs = {
  provider_type: ProviderType;
};


export type MutationSocialMediaLoginArgs = {
  nonce?: InputMaybe<Scalars['String']['input']>;
  platform: SocialPlatform;
  token: Scalars['String']['input'];
};


export type MutationStripeAccountSessionArgs = {
  input?: InputMaybe<StripeAccountSessionInput>;
};


export type MutationStripeExternalBankAccountArgs = {
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSubmitChargeOtpArgs = {
  input: SubmitChargeOtpInput;
};


export type MutationSupplierResellerLoginArgs = {
  input?: InputMaybe<SupplierUserLoginInput>;
};


export type MutationSupplierSignInArgs = {
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  emailOrPhone: Scalars['String']['input'];
  password: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSuspendResellerArgs = {
  input?: InputMaybe<SuspendResellerInput>;
};


export type MutationSwitchOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationSyncShopifyProductsArgs = {
  input: SyncShopifyProductInput;
};


export type MutationToggleCategoryStateArgs = {
  id: Scalars['ID']['input'];
  state: Scalars['Boolean']['input'];
};


export type MutationToggleFreeDeliveryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTransferInventoryArgs = {
  input: TransferInventoryInput;
};


export type MutationTransitionOrderStatusArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};


export type MutationUnMarkSupplierProductInWarehouseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnlockWalletArgs = {
  wallet_id: Scalars['ID']['input'];
};


export type MutationUnshareProductArgs = {
  input: UnshareProductRequestDto;
};


export type MutationUpdateAccountSecurityArgs = {
  input: UpdateUserAccountSecurityInput;
};


export type MutationUpdateAffiliateStatusArgs = {
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpdateApiKeyArgs = {
  input: UpdateApiKeyInput;
};


export type MutationUpdateAppBannerArgs = {
  input: AppBannerInput;
};


export type MutationUpdateCampaignArgs = {
  data: UpdateCampaignInput;
  filter?: InputMaybe<CampaignFilter>;
};


export type MutationUpdateCartItemArgs = {
  input: UpdateCartItemInput;
};


export type MutationUpdateCatalogArgs = {
  input?: InputMaybe<CatalogInput>;
};


export type MutationUpdateCollectionConfigArgs = {
  input?: InputMaybe<CatalogConfigInput>;
};


export type MutationUpdateCouponArgs = {
  input: CouponInput;
};


export type MutationUpdateCustomerArgs = {
  input?: InputMaybe<CustomerInput>;
};


export type MutationUpdateCustomerAddressOnOrderArgs = {
  customer_address_id: Scalars['ID']['input'];
  order_id: Scalars['ID']['input'];
};


export type MutationUpdateDeliveryLocationArgs = {
  input: DeliveryInput;
};


export type MutationUpdateDeliveryZoneArgs = {
  input?: InputMaybe<DeliveryZonesInput>;
};


export type MutationUpdateDigitalOrderArgs = {
  id: Scalars['ID']['input'];
  input: DigitalOrderInput;
};


export type MutationUpdateDiscountArgs = {
  data: UpdateDiscountData;
  filter: DiscountFilter;
};


export type MutationUpdateForexRateArgs = {
  input?: InputMaybe<ForexRateInput>;
};


export type MutationUpdateInventoryLocationArgs = {
  input: UpdateInventoryLocationInput;
};


export type MutationUpdateMemberRoleArgs = {
  organizationId: Scalars['ID']['input'];
  role: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateMyCustomerProfileArgs = {
  input: CustomerProfileInput;
};


export type MutationUpdateOperationCountryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOperationCountryInput;
};


export type MutationUpdateOpsConfigArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  deliveryLimitForPaymentOnDelivery?: InputMaybe<Scalars['Int']['input']>;
  leaderboardConfig?: InputMaybe<LeaderBoardConfigInput>;
  payableSecurityDeposit?: InputMaybe<Scalars['Int']['input']>;
  paymentCap?: InputMaybe<Scalars['Int']['input']>;
  paymentThreshold?: InputMaybe<Scalars['Int']['input']>;
  supplierDashboardUrl?: InputMaybe<Scalars['String']['input']>;
  whatsAppCommunityLink?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOrderDetailsOpsArgs = {
  cart_id: Scalars['ID']['input'];
  delivery_id?: InputMaybe<Scalars['ID']['input']>;
  delivery_price: Scalars['Float']['input'];
  order_id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};


export type MutationUpdateOrderSkuArgs = {
  id: Scalars['ID']['input'];
  sku: Scalars['ID']['input'];
};


export type MutationUpdateOrderStatusByRiderArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  orderItems: Array<Scalars['ID']['input']>;
  status: Scalars['String']['input'];
};


export type MutationUpdateOrderStatusDefinitionArgs = {
  input: UpdateStatusDefinitionInput;
  statusId: Scalars['ID']['input'];
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationPaymentAccountArgs = {
  input: UpdateOrganizationPaymentAccountInput;
};


export type MutationUpdatePartnershipArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  skus?: InputMaybe<Array<Scalars['String']['input']>>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdatePickUpLocationArgs = {
  input: PickUpInput;
};


export type MutationUpdatePluginArgs = {
  data: UpdatePluginRequestDto;
};


export type MutationUpdateProductArgs = {
  input?: InputMaybe<CreateProductInput>;
};


export type MutationUpdateProductCategoriesArgs = {
  input: UpdateProductCategoriesInput;
};


export type MutationUpdateProductCategoryArgs = {
  input?: InputMaybe<ProductCategoryInput>;
};


export type MutationUpdateProductCategoryAndTagsArgs = {
  input?: InputMaybe<ProductCategoryAndTagsInput>;
};


export type MutationUpdateProductCombinationArgs = {
  input?: InputMaybe<ProductCombinationInput>;
};


export type MutationUpdateProductDistributionArgs = {
  input?: InputMaybe<UpdateProductDistributionInput>;
};


export type MutationUpdateProductInformationArgs = {
  input?: InputMaybe<ProductInformationInput>;
};


export type MutationUpdateProductInstantDeliveryStateArgs = {
  id: Scalars['ID']['input'];
  instantDelivery: Scalars['Boolean']['input'];
  personnel: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProductInventoryArgs = {
  input?: InputMaybe<ProductInventoryInput>;
};


export type MutationUpdateProductLikeStateArgs = {
  input: EditProductStatInput;
};


export type MutationUpdateProductMediaArgs = {
  input?: InputMaybe<ProductMediaInput>;
};


export type MutationUpdateProductSaveStateArgs = {
  input: EditProductStatInput;
};


export type MutationUpdateProductShipmentArgs = {
  input?: InputMaybe<ProductShipmentInput>;
};


export type MutationUpdateProductStatusArgs = {
  input?: InputMaybe<UpdateProductStatusInput>;
};


export type MutationUpdateProductStockArgs = {
  input: ProductStockInput;
};


export type MutationUpdateProductTemplateArgs = {
  body?: InputMaybe<Array<TemplateInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateProductVariationArgs = {
  input?: InputMaybe<UpdateVariationInput>;
};


export type MutationUpdatePromoBannerArgs = {
  input?: InputMaybe<PromoBannerInput>;
};


export type MutationUpdateRiderArgs = {
  id: Scalars['ID']['input'];
  input: RiderInput;
};


export type MutationUpdateShopCollectionArgs = {
  input?: InputMaybe<ShopCollectionInput>;
};


export type MutationUpdateShopDetailsArgs = {
  data: UpdateShopDetailsRequestDto;
  premium_subscription?: InputMaybe<CustomerSubscriptionInput>;
};


export type MutationUpdateStorefrontCartStatusArgs = {
  input: UpdateStorefrontCartStatusInput;
};


export type MutationUpdateSupplierArgs = {
  input?: InputMaybe<SupplierInput>;
};


export type MutationUpdateSupplierAgreementTermsArgs = {
  input?: InputMaybe<AddSupplierAgreementTermsInput>;
};


export type MutationUpdateSupplierBusinessContactArgs = {
  input?: InputMaybe<UpdateSupplierBusinessContactInput>;
};


export type MutationUpdateSupplierBusinessDetailsArgs = {
  input?: InputMaybe<UpdateSupplierBusinessDetailsInput>;
};


export type MutationUpdateSupplierDetailsArgs = {
  input?: InputMaybe<UpdateSupplierDetailsInput>;
};


export type MutationUpdateSupplierGenericNameArgs = {
  input: VerifySupplierBusinessInput;
};


export type MutationUpdateSupplierPaymentArgs = {
  input?: InputMaybe<UpdateSupplierPaymentInput>;
};


export type MutationUpdateSupplierProfileArgs = {
  input?: InputMaybe<SupplierProfileUpdateInput>;
};


export type MutationUpdateSupplierShopDetailsArgs = {
  data: UpdateShopDetailsRequestDto;
};


export type MutationUpdateSupplierShopSlugArgs = {
  data: UpdateSupplierSlugInput;
};


export type MutationUpdateSupplierTypeArgs = {
  id: Scalars['ID']['input'];
  supplier_type: SupplierType;
};


export type MutationUpdateTenantCustomerStatusArgs = {
  customerId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpdateTenantProductArgs = {
  id: Scalars['ID']['input'];
  input: TenantProductInput;
};


export type MutationUpdateTenantSettingsArgs = {
  settings: Scalars['JSONObject']['input'];
};


export type MutationUpdateTenantTierArgs = {
  input: UpdateTenantTierInput;
};


export type MutationUpdateTermArgs = {
  input: TermInput;
};


export type MutationUpdateUserDetailsArgs = {
  input?: InputMaybe<UpdateUserDetailsInput>;
};


export type MutationUpdateVariationArgs = {
  input?: InputMaybe<VariationInput>;
};


export type MutationUpdaterResellerShopSlugArgs = {
  data: UpdateResellerSlugInput;
};


export type MutationUserLoginArgs = {
  input?: InputMaybe<UserLoginInput>;
};


export type MutationVerifyAccountSecurityArgs = {
  input: VerifyUserAccountSecurityInput;
};


export type MutationVerifyAliExpressProductArgs = {
  input: VerifyAliExpressProductInput;
};


export type MutationVerifyApiKeyArgs = {
  key: Scalars['String']['input'];
  permissions?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type MutationVerifyEmailArgs = {
  input?: InputMaybe<VerifyEmailInput>;
};


export type MutationVerifyOtpArgs = {
  input?: InputMaybe<VerifyOtpInput>;
};


export type MutationVerifyOrderOtpArgs = {
  customer_id: Scalars['ID']['input'];
  order_id: Scalars['ID']['input'];
  otp: Scalars['String']['input'];
};


export type MutationVerifyProductArgs = {
  input: VerifyProductInput;
};


export type MutationVerifyRiderOtpArgs = {
  input?: InputMaybe<VerifyOtpInput>;
};


export type MutationVerifySupplierAccountArgs = {
  input?: InputMaybe<VerifySupplierAccountInput>;
};


export type MutationVerifySupplierBusinessArgs = {
  input: VerifySupplierBusinessInput;
};


export type MutationVerifySupplierOtpArgs = {
  input?: InputMaybe<VerifySupplierOtpInput>;
};


export type MutationWalletPayoutDecisionArgs = {
  input: WalletPayoutRequestDecision;
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  body?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<NotificationType>;
};

export type NotificationFilter = {
  id?: InputMaybe<IdOperator>;
  read?: InputMaybe<BooleanOperator>;
  type?: InputMaybe<NotificationType>;
  user_id?: InputMaybe<IdOperator>;
};

export enum NotificationType {
  Newsletter = 'Newsletter',
  System = 'System',
  User = 'User'
}

export type NumberOperator = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type NumberRange = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
};

export type OfflineOrder = {
  __typename?: 'OfflineOrder';
  area: Scalars['String']['output'];
  batchId: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  customerPhone: Scalars['String']['output'];
  deliveryAmount: Scalars['Float']['output'];
  deliveryLocation: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  productSku: Scalars['ID']['output'];
  profit: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  remark: Scalars['String']['output'];
  resellerPhone: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  updatedAt: Scalars['Date']['output'];
};

/** this schema is for offline sales */
export type OfflineOrdersInput = {
  area: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  customerPhone: Scalars['String']['input'];
  deliveryAmount: Scalars['Float']['input'];
  deliveryLocation: Scalars['ID']['input'];
  productSku: Scalars['ID']['input'];
  profit: Scalars['Float']['input'];
  quantity: Scalars['Int']['input'];
  resellerPhone: Scalars['String']['input'];
  totalAmount: Scalars['Float']['input'];
};

export type OfflineSaleInput = {
  address?: InputMaybe<AddressInput>;
  address_id?: InputMaybe<Scalars['ID']['input']>;
  customer_id?: InputMaybe<Scalars['ID']['input']>;
  delivery_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<InputMaybe<OrderProductInput>>>;
  payment_type?: InputMaybe<Scalars['String']['input']>;
  shop_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type OnDiscountUseRequestDto = {
  discount_code: Scalars['String']['input'];
  discount_id: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type OnPurchaseSharedProductRequestDto = {
  product_id: Scalars['ID']['input'];
  profit_added_by_reseller: Scalars['Int']['input'];
  total_selling_price: Scalars['Int']['input'];
};

export type OnPurchaseSharedProductResponseDto = {
  __typename?: 'OnPurchaseSharedProductResponseDto';
  productId?: Maybe<Scalars['ID']['output']>;
};

export type OperationCountry = {
  __typename?: 'OperationCountry';
  country: Scalars['String']['output'];
  country_code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  currency_code: Scalars['String']['output'];
  currency_symbol: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  iso_code: Scalars['String']['output'];
  phone_code: Scalars['String']['output'];
};

export type OperationCountryFilter = {
  country?: InputMaybe<StringOperator>;
  country_code?: InputMaybe<StringOperator>;
  currency?: InputMaybe<StringOperator>;
  currency_code?: InputMaybe<StringOperator>;
  currency_symbol?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  iso_code?: InputMaybe<StringOperator>;
  phone_code?: InputMaybe<StringOperator>;
};

export type OpsConfig = {
  __typename?: 'OpsConfig';
  country: Scalars['String']['output'];
  deliveryLimitForPaymentOnDelivery: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  leaderboardConfig?: Maybe<LeaderBoardConfig>;
  payableSecurityDeposit: Scalars['Int']['output'];
  paymentCap: Scalars['Int']['output'];
  paymentThreshold: Scalars['Int']['output'];
  supplierDashboardUrl?: Maybe<Scalars['String']['output']>;
  whatsAppCommunityLink?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  address?: Maybe<CustomerAddress>;
  cart_number: Scalars['String']['output'];
  country: Scalars['String']['output'];
  coupon_id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Customer>;
  customer_address_id?: Maybe<Scalars['ID']['output']>;
  customer_id: Scalars['ID']['output'];
  customer_paid: Scalars['Boolean']['output'];
  delivery?: Maybe<Delivery>;
  delivery_amount?: Maybe<Scalars['Float']['output']>;
  delivery_id?: Maybe<Scalars['ID']['output']>;
  delivery_instructions?: Maybe<Scalars['String']['output']>;
  delivery_type: Scalars['String']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  free_delivery?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  instantDelivery?: Maybe<Scalars['Boolean']['output']>;
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  order_total: Scalars['Float']['output'];
  payment?: Maybe<Transaction>;
  payment_id?: Maybe<Scalars['ID']['output']>;
  payment_status?: Maybe<Scalars['String']['output']>;
  payment_type: Scalars['String']['output'];
  reseller?: Maybe<User>;
  security_deposit?: Maybe<Scalars['Float']['output']>;
  security_deposit_paid?: Maybe<Scalars['Boolean']['output']>;
  shipping_cost?: Maybe<Scalars['Float']['output']>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  statusHistory: Array<OrderStatusHistoryEntry>;
  supplier?: Maybe<Supplier>;
  supplier_id?: Maybe<Scalars['ID']['output']>;
  tenant_id?: Maybe<Scalars['ID']['output']>;
  tracking_code?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user_id: Scalars['ID']['output'];
  user_type: Scalars['String']['output'];
};

export type OrderComment = {
  __typename?: 'OrderComment';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  staff_name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type OrderCreateInput = {
  address_id?: InputMaybe<Scalars['ID']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  coupon_id?: InputMaybe<Scalars['ID']['input']>;
  customer_id: Scalars['ID']['input'];
  customer_paid: Scalars['Boolean']['input'];
  delivery_amount: Scalars['Float']['input'];
  delivery_id?: InputMaybe<Scalars['ID']['input']>;
  delivery_type: OrderDeliveryType;
  discount: Scalars['Float']['input'];
  estimate_id?: InputMaybe<Scalars['ID']['input']>;
  free_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreviousOrder?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instantDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  payment_id?: InputMaybe<Scalars['String']['input']>;
  payment_status: OrderPaymentStatus;
  payment_type: OrderPaymentMethod;
  products: Array<OrderProductInput>;
  reseller: Scalars['ID']['input'];
  security_deposit?: InputMaybe<Scalars['Float']['input']>;
  shipping_cost?: InputMaybe<Scalars['Float']['input']>;
  shop_id?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  supplier_status?: InputMaybe<Scalars['String']['input']>;
  total_amount: Scalars['Float']['input'];
};

export enum OrderDeliveryType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export type OrderFilter = {
  cart_number?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  customer_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  instantDelivery?: InputMaybe<BooleanOperator>;
  offline?: InputMaybe<BooleanOperator>;
  orderId?: InputMaybe<IdOperator>;
  orderNumber?: InputMaybe<StringOperator>;
  payment_id?: InputMaybe<StringOperator>;
  productId?: InputMaybe<IdOperator>;
  sku?: InputMaybe<IdOperator>;
  source?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  supplier_status?: InputMaybe<StringOperator>;
  tenant_id?: InputMaybe<StringOperator>;
  tracking_code?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
  user_type?: InputMaybe<StringOperator>;
};

export type OrderGraphData = {
  __typename?: 'OrderGraphData';
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type OrderHistory = {
  __typename?: 'OrderHistory';
  created_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  ops_personel?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type OrderInput = {
  cartNumber?: InputMaybe<Scalars['String']['input']>;
  customer_address_id?: InputMaybe<Scalars['ID']['input']>;
  customer_id: Scalars['ID']['input'];
  delivery_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  orderTotal: Scalars['Float']['input'];
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  user_id: Scalars['ID']['input'];
};

export type OrderItem = {
  __typename?: 'OrderItem';
  comments?: Maybe<Array<Maybe<OrderComment>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  history?: Maybe<Array<Maybe<OrderHistory>>>;
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['ID']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Product>;
  profitAdded?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['ID']['output'];
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplier_status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum OrderKind {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Tendo = 'TENDO'
}

export type OrderLifecycleHistoryEntry = {
  __typename?: 'OrderLifecycleHistoryEntry';
  created_at: Scalars['Date']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  from_status?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  ops_personnel?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['ID']['output']>;
  order_product_id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  to_status?: Maybe<Scalars['String']['output']>;
};

export enum OrderPaymentMethod {
  Cash = 'CASH',
  PaymentOnline = 'PAYMENT_ONLINE',
  PaymentOnDelivery = 'PAYMENT_ON_DELIVERY'
}

export enum OrderPaymentStatus {
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  SplitPayment = 'SPLIT_PAYMENT'
}

export type OrderProductFilter = {
  created_at?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
  orderId?: InputMaybe<NumberOperator>;
  orderNumber?: InputMaybe<StringOperator>;
  price?: InputMaybe<NumberOperator>;
  profitAdded?: InputMaybe<NumberOperator>;
  quantity?: InputMaybe<NumberOperator>;
  sku?: InputMaybe<StringOperator>;
  source?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  supplier_status?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
};

export type OrderProductInput = {
  cost_price?: InputMaybe<Scalars['Float']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  price: Scalars['Float']['input'];
  product_id: Scalars['ID']['input'];
  profitAdded: Scalars['Float']['input'];
  qty: Scalars['Int']['input'];
};

export type OrderReview = {
  __typename?: 'OrderReview';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order_id: Scalars['ID']['output'];
  rating: Scalars['Float']['output'];
};

export type OrderSort = {
  field?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Sort>;
};

export type OrderStats = {
  __typename?: 'OrderStats';
  ordersAllTime: Scalars['Int']['output'];
  ordersMonth: Scalars['Int']['output'];
  ordersToday: Scalars['Int']['output'];
  ordersWeek: Scalars['Int']['output'];
  ordersYear: Scalars['Int']['output'];
};

export type OrderStatsStats = {
  __typename?: 'OrderStatsStats';
  totalCancelled: Scalars['Int']['output'];
  totalDelivered: Scalars['Int']['output'];
  totalPending: Scalars['Int']['output'];
  totalSuccessful: Scalars['Int']['output'];
};

export enum OrderStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Intransit = 'INTRANSIT',
  Paid = 'PAID',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Returned = 'RETURNED'
}

export type OrderStatusHistoryEntry = {
  __typename?: 'OrderStatusHistoryEntry';
  created_at: Scalars['Date']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  from_status?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order_id: Scalars['ID']['output'];
  to_status: Scalars['String']['output'];
};

export type OrderStatusRegistry = {
  __typename?: 'OrderStatusRegistry';
  allowedTransitions?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCancellation: Scalars['Boolean']['output'];
  isTerminal: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  statusCode: Scalars['String']['output'];
  statusColor?: Maybe<Scalars['String']['output']>;
  statusDescription?: Maybe<Scalars['String']['output']>;
  statusIcon?: Maybe<Scalars['String']['output']>;
  statusLabel: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderStatusesStats = {
  __typename?: 'OrderStatusesStats';
  totalCancelled: Scalars['Int']['output'];
  totalDelivered: Scalars['Int']['output'];
  totalPending: Scalars['Int']['output'];
  totalSuccessful: Scalars['Int']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  custom_domain?: Maybe<Scalars['String']['output']>;
  default_user?: Maybe<User>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  invitations?: Maybe<Array<OrganizationInvitation>>;
  logo?: Maybe<Scalars['String']['output']>;
  memberRole?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<OrganizationMember>>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  name: Scalars['String']['output'];
  operation_countries?: Maybe<Array<OperationCountry>>;
  plan?: Maybe<Scalars['String']['output']>;
  primary_color?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  tenant_type?: Maybe<TenantType>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAuth = {
  __typename?: 'OrganizationAuth';
  organizationId: Scalars['ID']['output'];
  permissions: Array<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type OrganizationComprehensive = {
  __typename?: 'OrganizationComprehensive';
  activeMembers: Scalars['Int']['output'];
  billingEmail?: Maybe<Scalars['String']['output']>;
  createdDaysAgo: Scalars['Int']['output'];
  enabledFeatures: Array<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isSuspended: Scalars['Boolean']['output'];
  lastActivity?: Maybe<Scalars['DateTime']['output']>;
  memberCount: Scalars['Int']['output'];
  organization: Organization;
  pendingInvitations: Scalars['Int']['output'];
  stats: OrganizationDetailStats;
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  suspensionReason?: Maybe<Scalars['String']['output']>;
};

export type OrganizationDetailStats = {
  __typename?: 'OrganizationDetailStats';
  lastOrderDate?: Maybe<Scalars['DateTime']['output']>;
  lastProductAddedDate?: Maybe<Scalars['DateTime']['output']>;
  totalCustomers: Scalars['Int']['output'];
  totalOrders: Scalars['Int']['output'];
  totalProducts: Scalars['Int']['output'];
  totalRevenue: Scalars['Float']['output'];
};

export type OrganizationFilter = {
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  isActive?: InputMaybe<BooleanOperator>;
  plan?: InputMaybe<StringOperator>;
  search?: InputMaybe<StringOperator>;
  slug?: InputMaybe<StringOperator>;
  tenantType?: InputMaybe<TenantType>;
};

export type OrganizationInvitation = {
  __typename?: 'OrganizationInvitation';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inviterId: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OrganizationInvitationResponse = {
  __typename?: 'OrganizationInvitationResponse';
  invitation?: Maybe<OrganizationInvitation>;
  message?: Maybe<Scalars['String']['output']>;
  user?: Maybe<OrganizationUser>;
};

export type OrganizationMember = {
  __typename?: 'OrganizationMember';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  user?: Maybe<OrganizationUser>;
  userId: Scalars['ID']['output'];
};

export type OrganizationPaymentAccount = {
  __typename?: 'OrganizationPaymentAccount';
  account_address?: Maybe<Scalars['JSONObject']['output']>;
  account_code: Scalars['String']['output'];
  account_name: Scalars['String']['output'];
  account_number: Scalars['String']['output'];
  account_provider: Scalars['String']['output'];
  country: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  organization_id: Scalars['ID']['output'];
  payment_type: PaymentType;
  transfer_type: TransferType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationPaymentAccountFilter = {
  country?: InputMaybe<CountryCodeOperator>;
  currency?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  payment_type?: InputMaybe<PaymentTypeOperator>;
  transfer_type?: InputMaybe<TransferTypeOperator>;
};

export type OrganizationPaymentSetup = {
  __typename?: 'OrganizationPaymentSetup';
  country: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  has_payment_setup: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organization_id: Scalars['ID']['output'];
  provider_details?: Maybe<PspCredential>;
  provider_type: ProviderType;
  setup_complete: Scalars['Boolean']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationPaymentSetupFilter = {
  country?: InputMaybe<CountryCodeOperator>;
  has_payment_setup?: InputMaybe<BooleanOperator>;
  id?: InputMaybe<IdOperator>;
  provider_type?: InputMaybe<ProviderTypeOperator>;
  setup_complete?: InputMaybe<BooleanOperator>;
};

export type OrganizationStats = {
  __typename?: 'OrganizationStats';
  activeOrganizations: Scalars['Int']['output'];
  organizationsByPlan: Array<TypeCount>;
  organizationsByType: Array<TypeCount>;
  recentOrganizations: Array<Organization>;
  totalOrganizations: Scalars['Int']['output'];
};

export type OrganizationUser = {
  __typename?: 'OrganizationUser';
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  phoneVerified: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PackageInfoDto = {
  __typename?: 'PackageInfoDto';
  base_unit?: Maybe<Scalars['String']['output']>;
  gross_weight?: Maybe<Scalars['String']['output']>;
  package_height?: Maybe<Scalars['String']['output']>;
  package_length?: Maybe<Scalars['String']['output']>;
  package_type?: Maybe<Scalars['String']['output']>;
  package_width?: Maybe<Scalars['String']['output']>;
  product_unit?: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginationResponse = {
  __typename?: 'PaginationResponse';
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Partnership = {
  __typename?: 'Partnership';
  client_id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  products: Array<Product>;
  skus: Array<Scalars['String']['output']>;
  status: PartnershipStatus;
  supplier_id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnershipFilter = {
  client_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  status?: InputMaybe<PartnershipStatus>;
  supplier_id?: InputMaybe<IdOperator>;
};

export enum PartnershipStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type PastLeaderboardIntervals = {
  __typename?: 'PastLeaderboardIntervals';
  activity_id?: Maybe<Scalars['String']['output']>;
  end_date_time?: Maybe<Scalars['String']['output']>;
  recurrence_type?: Maybe<Scalars['String']['output']>;
  recurrence_type_value?: Maybe<Scalars['Int']['output']>;
  start_date_time?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum PaymentFacilitator {
  House = 'house',
  Momo = 'momo',
  Paystack = 'paystack',
  Stripe = 'stripe',
  Tingg = 'tingg'
}

export type PaymentFacilitatorResponseDto = {
  __typename?: 'PaymentFacilitatorResponseDTO';
  amount: Scalars['Float']['output'];
  country: Scalars['String']['output'];
  currency: Currency;
  facilitator: Scalars['JSONObject']['output'];
  fees?: Maybe<Scalars['JSONObject']['output']>;
  tenantPaymentId: Scalars['String']['output'];
  totalToCharge: Scalars['Float']['output'];
};

export type PaymentInput = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};

export enum PaymentOption {
  Cash = 'Cash',
  Online = 'Online'
}

export enum PaymentType {
  Bank = 'bank',
  Card = 'card',
  MobileMoney = 'mobile_money'
}

export type PaymentTypeOperator = {
  eq?: InputMaybe<PaymentType>;
  in?: InputMaybe<Array<PaymentType>>;
  notIn?: InputMaybe<Array<PaymentType>>;
};

export enum PaystackAccountType {
  Business = 'business',
  Personal = 'personal'
}

export type PaystackBankChargeInput = {
  account_number: Scalars['String']['input'];
  code: Scalars['String']['input'];
};

export type PaystackBankListResponse = {
  __typename?: 'PaystackBankListResponse';
  data?: Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type PaystackBanksFilter = {
  country?: InputMaybe<Scalars['String']['input']>;
  gateway?: InputMaybe<Scalars['String']['input']>;
  next?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  previous?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaystackGhanaBankType>;
  use_cursor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaystackChargeInput = {
  amount: Scalars['Float']['input'];
  currency: CurrencyInput;
  email: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  reference: Scalars['String']['input'];
};

export type PaystackChargeSubmitBirthdayInput = {
  birthday: Scalars['DateTime']['input'];
  reference: Scalars['String']['input'];
};

export type PaystackChargeSubmitOtpInput = {
  otp: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};

export type PaystackChargeSubmitPhoneInput = {
  phone: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};

export type PaystackChargeSubmitPinInput = {
  pin: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};

export type PaystackError = {
  __typename?: 'PaystackError';
  data?: Maybe<Scalars['JSONObject']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum PaystackGhanaBankType {
  Ghipps = 'ghipps',
  MobileMoney = 'mobile_money'
}

export type PaystackInitializeBankTransferChargeInput = {
  bank: PaystackBankChargeInput;
  charge: PaystackChargeInput;
};

export type PaystackInitializeMobileMoneyChargeInput = {
  charge: PaystackChargeInput;
  mobile_money: PaystackMobileMoneyChargeInput;
};

export type PaystackInitializeTransactionInput = {
  amount: Scalars['Float']['input'];
  authorization_code?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyInput;
  email: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  redirect_url?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
};

export type PaystackMobileMoneyChargeInput = {
  phone: Scalars['String']['input'];
  provider: PaystackMobileMoneyProvider;
};

export enum PaystackMobileMoneyProvider {
  Atl = 'atl',
  Mtn = 'mtn',
  Vod = 'vod'
}

export type PaystackResolveAccountInput = {
  account_number: Scalars['String']['input'];
  bank_code: Scalars['String']['input'];
};

export type PaystackSuccess = {
  __typename?: 'PaystackSuccess';
  data?: Maybe<Scalars['JSONObject']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type PaystackValidateAccountInput = {
  account_name?: InputMaybe<Scalars['String']['input']>;
  account_number: Scalars['String']['input'];
  account_type?: InputMaybe<Scalars['String']['input']>;
  bank_code: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  /** Customer’s mode of identity. This could be one of: [ identityNumber, passportNumber, businessRegistrationNumber ] */
  document_number?: InputMaybe<Scalars['String']['input']>;
  document_type?: InputMaybe<Scalars['String']['input']>;
};

export type Permission = {
  __typename?: 'Permission';
  action: Scalars['String']['output'];
  permission: Scalars['String']['output'];
  resource: Scalars['String']['output'];
};

export type PhoneVerificationOutPut = {
  __typename?: 'PhoneVerificationOutPut';
  code?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type PickUpInput = {
  google_location: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  latitude: Scalars['String']['input'];
  location: Scalars['String']['input'];
  longitude: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type Pickup = {
  __typename?: 'Pickup';
  country?: Maybe<Scalars['String']['output']>;
  google_location?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
};

export type PlanDistributionItem = {
  __typename?: 'PlanDistributionItem';
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  plan: Scalars['String']['output'];
};

export type PlatformAuthResponse = {
  __typename?: 'PlatformAuthResponse';
  expiresIn: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
  token: Scalars['String']['output'];
  user: PlatformUser;
};

export type PlatformChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type PlatformConfirmResetPasswordInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type PlatformLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type PlatformRefreshResponse = {
  __typename?: 'PlatformRefreshResponse';
  expiresIn: Scalars['Int']['output'];
  token: Scalars['String']['output'];
};

export type PlatformResetPasswordInput = {
  email: Scalars['String']['input'];
};

export type PlatformRole = {
  __typename?: 'PlatformRole';
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isSystemRole: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  userCount?: Maybe<Scalars['Int']['output']>;
};

export type PlatformRoleFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSystemRole?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
};

export type PlatformRoleList = {
  __typename?: 'PlatformRoleList';
  roles: Array<PlatformRole>;
  total: Scalars['Int']['output'];
};

export type PlatformUpdateOrganizationInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customDomain?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operationCountries?: InputMaybe<Array<Scalars['ID']['input']>>;
  plan?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tenantType?: InputMaybe<TenantType>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformUser = {
  __typename?: 'PlatformUser';
  createdAt?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneVerified?: Maybe<Scalars['Boolean']['output']>;
  platformRole?: Maybe<PlatformRole>;
  role?: Maybe<PlatformUserRole>;
  roleId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PlatformUserFilter = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<PlatformUserRole>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformUserInput = {
  email: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
};

export type PlatformUserList = {
  __typename?: 'PlatformUserList';
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  users: Array<PlatformUser>;
};

export enum PlatformUserRole {
  Admin = 'ADMIN',
  Analyst = 'ANALYST',
  SuperAdmin = 'SUPER_ADMIN',
  Support = 'SUPPORT'
}

export type PlatformUserStats = {
  __typename?: 'PlatformUserStats';
  activeUsers: Scalars['Int']['output'];
  inactiveUsers: Scalars['Int']['output'];
  recentLogins: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  usersByRole: Array<RoleCount>;
};

export type Plugin = {
  __typename?: 'Plugin';
  banner_image?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  created_at?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  developer?: Maybe<Scalars['String']['output']>;
  endpoint: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_installed_by_current_user?: Maybe<Scalars['Boolean']['output']>;
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
  verified: Scalars['Boolean']['output'];
};

export type PluginFilter = {
  banner_image?: InputMaybe<StringOperator>;
  category?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<DateOperator>;
  description?: InputMaybe<StringOperator>;
  developer?: InputMaybe<StringOperator>;
  endpoint?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  logo?: InputMaybe<StringOperator>;
  name?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
  verified?: InputMaybe<BooleanOperator>;
};

export type Product = {
  __typename?: 'Product';
  attended_to?: Maybe<Scalars['Boolean']['output']>;
  avatar: Scalars['String']['output'];
  barcode?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Maybe<ProductCategory>>>;
  combination_string?: Maybe<Scalars['String']['output']>;
  combinations?: Maybe<Array<Maybe<ProductCombination>>>;
  comments?: Maybe<Array<Maybe<ProductComment>>>;
  cost_price: Scalars['Float']['output'];
  country?: Maybe<CountryCode>;
  created_at?: Maybe<Scalars['Date']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  digitalDetails?: Maybe<Scalars['Any']['output']>;
  discount?: Maybe<Discount>;
  distributionChannels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  extra_information?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inhouse?: Maybe<Scalars['Boolean']['output']>;
  instantDelivery?: Maybe<Scalars['Boolean']['output']>;
  likesCount?: Maybe<Scalars['Float']['output']>;
  limited_stock?: Maybe<Scalars['Boolean']['output']>;
  main_stock?: Maybe<Scalars['Int']['output']>;
  maximumDeliveryTime?: Maybe<Scalars['Int']['output']>;
  media?: Maybe<Array<Maybe<ProductAvatar>>>;
  minimumDeliveryTime?: Maybe<Scalars['Int']['output']>;
  minimumOrderQuantity?: Maybe<Scalars['Int']['output']>;
  overalReview: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  productType?: Maybe<ProductType>;
  product_origin?: Maybe<ProductOrigin>;
  profit_added?: Maybe<Scalars['Float']['output']>;
  published: Scalars['Boolean']['output'];
  qty?: Maybe<Scalars['Int']['output']>;
  resell: Scalars['Boolean']['output'];
  reviewBreakDown: ReviewBreakDown;
  reviews?: Maybe<Array<Review>>;
  savesCount?: Maybe<Scalars['Float']['output']>;
  sharesCount?: Maybe<Scalars['Float']['output']>;
  shippingCost?: Maybe<Scalars['Float']['output']>;
  shop_id?: Maybe<Scalars['ID']['output']>;
  sku: Scalars['String']['output'];
  status?: Maybe<ProductStatus>;
  supplier?: Maybe<Supplier>;
  supplier_cost?: Maybe<Scalars['Float']['output']>;
  supplier_id?: Maybe<Scalars['ID']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transit_stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  variations?: Maybe<Array<Maybe<Variation>>>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ProductAvatar = {
  __typename?: 'ProductAvatar';
  avatar?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  product_id?: Maybe<Scalars['ID']['output']>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  avatar?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<Maybe<ProductCategory>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<Scalars['ID']['output']>;
  tenant_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<CategoryType>;
};

export type ProductCategoryAndTagsInput = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  personnel?: InputMaybe<Scalars['String']['input']>;
  product_id: Scalars['ID']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductCategoryCount = {
  __typename?: 'ProductCategoryCount';
  category: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type ProductCategoryFilter = {
  country?: InputMaybe<StringOperator>;
  description?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  parent?: InputMaybe<NumberOperator>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
  shop_id?: InputMaybe<IdOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  type?: InputMaybe<StringOperator>;
};

export type ProductCategoryInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<CategoryType>;
};

export type ProductCollection = {
  __typename?: 'ProductCollection';
  collection?: Maybe<Catalog>;
  id?: Maybe<Scalars['ID']['output']>;
  product?: Maybe<Product>;
};

export type ProductCombination = {
  __typename?: 'ProductCombination';
  available_stock: Scalars['Int']['output'];
  combination_string: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  price: Scalars['Float']['output'];
  sku: Scalars['String']['output'];
};

export type ProductCombinationFilter = {
  available_stock?: InputMaybe<NumberOperator>;
  combination_string?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  price?: InputMaybe<MoneyOperator>;
  sku?: InputMaybe<StringOperator>;
};

export type ProductCombinationInput = {
  avatar: Scalars['String']['input'];
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  combination_string: Scalars['String']['input'];
  cost_price: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  inventory_locations?: InputMaybe<Array<InputMaybe<InventoryLocationQuantityInput>>>;
  media?: InputMaybe<Array<Scalars['String']['input']>>;
  price: Scalars['Float']['input'];
  qty: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type ProductComment = {
  __typename?: 'ProductComment';
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  staff_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export enum ProductCondition {
  In = 'IN',
  NotIn = 'NOT_IN'
}

export enum ProductDistinctField {
  AttendedTo = 'attended_to',
  Avatar = 'avatar',
  CombinationString = 'combination_string',
  CostPrice = 'cost_price',
  Country = 'country',
  CreatedAt = 'created_at',
  Currency = 'currency',
  Description = 'description',
  Id = 'id',
  Inhouse = 'inhouse',
  LimitedStock = 'limited_stock',
  Price = 'price',
  Published = 'published',
  Qty = 'qty',
  ShopId = 'shop_id',
  Sku = 'sku',
  Title = 'title',
  UpdatedAt = 'updated_at',
  Uuid = 'uuid',
  Verified = 'verified',
  Weight = 'weight'
}

export type ProductHistory = {
  __typename?: 'ProductHistory';
  action?: Maybe<Scalars['String']['output']>;
  actor?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  newSnapshot?: Maybe<Scalars['Any']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  oldSnapshot?: Maybe<Scalars['Any']['output']>;
  product_id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ProductHistoryFilter = {
  action?: InputMaybe<StringOperator>;
  product_id?: InputMaybe<IdOperator>;
};

export type ProductIdConverterResult = {
  __typename?: 'ProductIdConverterResult';
  main_product_id?: Maybe<Scalars['String']['output']>;
  sub_product_id?: Maybe<SubProductId>;
};

export type ProductInformationInput = {
  cost_price?: InputMaybe<Scalars['Float']['input']>;
  country?: InputMaybe<CountryCode>;
  currency?: InputMaybe<CurrencyCode>;
  description?: InputMaybe<Scalars['String']['input']>;
  extra_information?: InputMaybe<Scalars['String']['input']>;
  maximumDeliveryTime?: InputMaybe<Scalars['Int']['input']>;
  minimumDeliveryTime?: InputMaybe<Scalars['Int']['input']>;
  minimumOrderQuantity?: InputMaybe<Scalars['Int']['input']>;
  personnel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  product_id: Scalars['ID']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  status?: InputMaybe<ProductStatus>;
  supplier_cost?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductInventoryHistory = {
  __typename?: 'ProductInventoryHistory';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  new_cost_price: Scalars['Float']['output'];
  new_price: Scalars['Float']['output'];
  new_quantity: Scalars['Int']['output'];
  old_cost_price: Scalars['Float']['output'];
  old_price: Scalars['Float']['output'];
  old_quantity: Scalars['Int']['output'];
  product_id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ProductInventoryHistoryFilter = {
  product_id?: InputMaybe<IdOperator>;
};

export type ProductInventoryInput = {
  cost_price?: InputMaybe<Scalars['Float']['input']>;
  limited_stock?: InputMaybe<Scalars['Boolean']['input']>;
  personnel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  product_id: Scalars['ID']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductStatus>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductMediaInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<Scalars['String']['input']>>;
  personnel?: InputMaybe<Scalars['String']['input']>;
  product_id: Scalars['ID']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductStatus>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductMetricsFilter = {
  country: StringOperator;
  published?: InputMaybe<BooleanOperator>;
  verified?: InputMaybe<BooleanOperator>;
};

export enum ProductOrigin {
  InHouse = 'IN_HOUSE',
  Magento = 'MAGENTO',
  Shopify = 'SHOPIFY',
  SupplierOfflineCatalogue = 'SUPPLIER_OFFLINE_CATALOGUE',
  SupplierTendoOnlineCatalogue = 'SUPPLIER_TENDO_ONLINE_CATALOGUE',
  Woocommence = 'WOOCOMMENCE'
}

export enum ProductPolicy {
  Resell = 'RESELL',
  Supplier = 'SUPPLIER'
}

export type ProductRequest = {
  __typename?: 'ProductRequest';
  id: Scalars['ID']['output'];
  product?: Maybe<Product>;
  qty?: Maybe<Scalars['Int']['output']>;
  shop_id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<ProductRequestStatus>;
};

export enum ProductRequestStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ProductShipment = {
  __typename?: 'ProductShipment';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ShipmentItem>>>;
  shipmentCode?: Maybe<Scalars['String']['output']>;
  shipmentDescription?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ProductShipmentFilter = {
  id?: InputMaybe<IdOperator>;
  sku?: InputMaybe<StringOperator>;
};

export type ProductShipmentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<InputMaybe<ShipmentItemItem>>>;
  shipmentCode?: InputMaybe<Scalars['String']['input']>;
  shipmentDescription?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSort = {
  field: ProductDistinctField;
  order: SortOrder;
};

export enum ProductStat {
  Likes = 'LIKES',
  Saves = 'SAVES'
}

export enum ProductStatEditType {
  Decrement = 'DECREMENT',
  Increment = 'INCREMENT'
}

export enum ProductStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ProductStockHistoryItem = {
  __typename?: 'ProductStockHistoryItem';
  createdAt: Scalars['Date']['output'];
  exhausted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  product_id: Scalars['ID']['output'];
  qty: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ProductStockInput = {
  id: Scalars['ID']['input'];
  personnel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  qty: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ProductTemplate = {
  __typename?: 'ProductTemplate';
  body?: Maybe<Array<Template>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum ProductType {
  Digital = 'Digital',
  Physical = 'Physical'
}

export type ProductVariationInput = {
  name: Scalars['String']['input'];
  options: Array<Scalars['String']['input']>;
  prices?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type ProductsStats = {
  __typename?: 'ProductsStats';
  total_in_stock: Scalars['Int']['output'];
  total_in_transit: Scalars['Int']['output'];
  total_out_stock: Scalars['Int']['output'];
  total_unique_products: Scalars['Int']['output'];
};

export type ProfitRevenueStats = {
  __typename?: 'ProfitRevenueStats';
  allTimeRevenue?: Maybe<Scalars['Float']['output']>;
  dayRevenue?: Maybe<Scalars['Float']['output']>;
  monthRevenue?: Maybe<Scalars['Float']['output']>;
  weekRevenue?: Maybe<Scalars['Float']['output']>;
  yearRevenue?: Maybe<Scalars['Float']['output']>;
};

export enum ProfitType {
  Amount = 'amount',
  Percent = 'percent'
}

export type PromoBanner = {
  __typename?: 'PromoBanner';
  active: Scalars['Boolean']['output'];
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  screen: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PromoBannerFilter = {
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
};

export type PromoBannerInput = {
  active: Scalars['Boolean']['input'];
  country: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  screen: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export enum ProviderType {
  External = 'external',
  Internal = 'internal'
}

export type ProviderTypeOperator = {
  eq?: InputMaybe<ProviderType>;
  in?: InputMaybe<Array<ProviderType>>;
  notIn?: InputMaybe<Array<ProviderType>>;
};

export type PspCredential = {
  __typename?: 'PspCredential';
  country: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  environment: PspEnvironment;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  key_version: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  provider: PspProvider;
  public_key?: Maybe<Scalars['String']['output']>;
  rotated_at?: Maybe<Scalars['DateTime']['output']>;
  transaction_fee?: Maybe<Scalars['Float']['output']>;
};

export enum PspEnvironment {
  Live = 'live',
  Test = 'test'
}

export enum PspProvider {
  Paystack = 'paystack',
  Stripe = 'stripe'
}

export enum QuantityAdjustmentType {
  Decrease = 'DECREASE',
  Increase = 'INCREASE'
}

export type Query = {
  __typename?: 'Query';
  activeOrganization?: Maybe<Organization>;
  /**
   * Get API key usage statistics for the current organization.
   * Requires: apikey:read permission or owner/admin role.
   */
  apiKeyStats: ApiKeyStats;
  appBanner?: Maybe<AppBanner>;
  appBanners?: Maybe<Array<AppBanner>>;
  /** Get available permissions that can be assigned to API keys. */
  availableApiKeyPermissions: AvailableApiKeyPermissions;
  /** Get available features for tenant based on their tier and type */
  availableFeatures: Array<FeatureModule>;
  bobGetCourierRates?: Maybe<BobGetCourierRatesResponseDto>;
  /** Get order fulfillments */
  bobGetOrderFulfillments?: Maybe<BobGetOrderFulfillmentsResponseDto>;
  bobGetOrders?: Maybe<BobGetOrdersResponseDto>;
  bobGetRateRequests?: Maybe<BobGetRateRequestsResponseDto>;
  /** Get rates at checkout */
  bobGetRatesAtCheckout?: Maybe<BobGetRatesAtCheckoutResponseDto>;
  bobGetShipmentWaybill?: Maybe<BobShipmentWaybill>;
  bobGetShipments?: Maybe<BobGetShipmentsResponseDto>;
  bobGetTrackingEvents?: Maybe<Array<Maybe<BobTrackingEvent>>>;
  /** Check if a tenant can enable a feature by subscription tier and tenant type */
  canEnableFeature: Scalars['Boolean']['output'];
  /** Check if user can access specific feature */
  checkFeatureAccess: FeatureAccessCheck;
  checkStockAvailability?: Maybe<Array<Maybe<StockAvailability>>>;
  checkTransaction?: Maybe<CheckTransactionResponseDto>;
  confirmCardSetup?: Maybe<Scalars['Boolean']['output']>;
  currentAuth?: Maybe<AuthResult>;
  currentTenant?: Maybe<TenantContext>;
  deliveryLocation?: Maybe<Delivery>;
  deliveryLocations?: Maybe<Array<Maybe<Delivery>>>;
  deliveryLocationsLength: Scalars['Int']['output'];
  doesShopDomainExist: SokoWorldDomainExistsResponseDto;
  doesShopExist: DoesShopExistResponseDto;
  downloadWalletStatement?: Maybe<WalletStatementDto>;
  /** Get feature definition by module */
  featureDefinition?: Maybe<FeatureDefinition>;
  /** Get all available feature definitions */
  featureDefinitions: Array<FeatureDefinition>;
  /** Get feature usage statistics (Super admin only) */
  featureUsageStats: Array<FeatureUsageStats>;
  featuredCategories?: Maybe<Array<FeaturedCategories>>;
  /** Get features by category */
  featuresByCategory: Array<FeatureDefinition>;
  /** Get features by tenant type */
  featuresByTenantType: Array<FeatureDefinition>;
  /** Get features by subscription tier */
  featuresByTier: Array<FeatureDefinition>;
  findDeliveryZone?: Maybe<DeliveryZone>;
  getActiveTendoLeaderBoard?: Maybe<TendoLeaderBoard>;
  getActiveTendoLeaderBoardPositions: Array<TendoLeaderBoardPosition>;
  getAffiliate: Affiliate;
  getAffiliateLinks: Array<AffiliateLink>;
  getAffiliatePrograms: Array<AffiliateProgram>;
  getAffiliates: Array<Affiliate>;
  getAliExpressProduct?: Maybe<GeneratedAliExpressProduct>;
  getAliExpressProducts?: Maybe<AliExpressProductResponse>;
  getAllDelayedProfitPayoutDeliveredOrders?: Maybe<Array<Maybe<DeliveredOrders>>>;
  getAllTimeActiveUsers?: Maybe<Scalars['Any']['output']>;
  getAppCart?: Maybe<AppCart>;
  getAssignedOrdersForRider?: Maybe<Array<Maybe<Order>>>;
  getAssignedOrdersForRiderLength: Scalars['Int']['output'];
  getAvailablePaymentFacilitator?: Maybe<Array<Maybe<PaymentFacilitatorResponseDto>>>;
  getAvailablePermissions: Array<Scalars['String']['output']>;
  getAvailableTenantTypes: Array<Scalars['String']['output']>;
  getCampaign?: Maybe<Campaign>;
  getCampaignModels?: Maybe<Array<Maybe<CampaignModel>>>;
  getCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  getCampaignsCount?: Maybe<Scalars['Int']['output']>;
  getCart?: Maybe<Order>;
  getCarts?: Maybe<Array<Maybe<Order>>>;
  getCartsLength: Scalars['Int']['output'];
  getCatalog: Catalog;
  getCatalogs?: Maybe<Array<Maybe<Catalog>>>;
  getCatalogsLength: Scalars['Int']['output'];
  getCategoryMedia: Array<Maybe<ProductAvatar>>;
  getCollectionProducts?: Maybe<Array<Maybe<Product>>>;
  getCollectionProductsLength: Scalars['Int']['output'];
  getCoupon?: Maybe<Coupon>;
  getCouponRedemptions?: Maybe<Array<Maybe<CouponRedemption>>>;
  getCouponRedemptionsLength: Scalars['Int']['output'];
  getCoupons?: Maybe<Array<Coupon>>;
  getCouponsLength: Scalars['Int']['output'];
  getCurentForexRate?: Maybe<ForexRate>;
  getCustomer?: Maybe<Customer>;
  getCustomers?: Maybe<Array<Maybe<Customer>>>;
  getCustomersLength: Scalars['Int']['output'];
  getDailyActiveUsers?: Maybe<Scalars['Any']['output']>;
  getDailyOrdersSummary?: Maybe<Scalars['Any']['output']>;
  getDefaultResellerUser?: Maybe<User>;
  getDelayedProfitPayouts?: Maybe<Array<Maybe<OrderItem>>>;
  getDelayedProfitPayoutsLength: Scalars['Int']['output'];
  getDeliveredOrders?: Maybe<Array<Maybe<DeliveredOrders>>>;
  getDeliveryPrices?: Maybe<Array<AutogeneratedMainType>>;
  getDeliveryZone?: Maybe<DeliveryZone>;
  getDeliveryZones?: Maybe<Array<DeliveryZone>>;
  getDeliveryZonesLength: Scalars['Int']['output'];
  getDeveloper?: Maybe<Developer>;
  getDevelopers?: Maybe<Array<Maybe<Developer>>>;
  getDigitalOrder?: Maybe<DigitalOrder>;
  getDigitalOrders?: Maybe<Array<Maybe<DigitalOrder>>>;
  getDigitalOrdersLength: Scalars['Int']['output'];
  getDiscount?: Maybe<Discount>;
  getDiscountProductCondition?: Maybe<DiscountProductCondition>;
  getDiscountProductConditions?: Maybe<Array<Maybe<DiscountProductCondition>>>;
  getDiscountProductConditionsLength: Scalars['Int']['output'];
  getDiscounts?: Maybe<Array<Maybe<Discount>>>;
  getDiscountsLength: Scalars['Int']['output'];
  getFailedOfflineOrders?: Maybe<Array<OfflineOrder>>;
  getFailedOfflineOrdersLength: Scalars['Int']['output'];
  getForexRates?: Maybe<Array<ForexRate>>;
  getInsightOnCoupon?: Maybe<CouponInsight>;
  getInventory?: Maybe<Array<Maybe<Inventory>>>;
  getInventoryBySku?: Maybe<Array<Maybe<Inventory>>>;
  getInventoryLength: Scalars['Int']['output'];
  getInventoryLocation?: Maybe<InventoryLocation>;
  getInventoryLocations?: Maybe<Array<Maybe<InventoryLocation>>>;
  getInventoryLocationsLength: Scalars['Int']['output'];
  getInventoryReservations?: Maybe<Array<Maybe<InventoryReservation>>>;
  getInventoryReservationsLength: Scalars['Int']['output'];
  getInventoryStats?: Maybe<InventoryStats>;
  getInventoryTransactions?: Maybe<Array<Maybe<InventoryTransaction>>>;
  getInventoryTransactionsLength: Scalars['Int']['output'];
  getMainCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  getMonthlyActiveUsers?: Maybe<Scalars['Any']['output']>;
  getNineMonthsActiveUsers?: Maybe<Scalars['Any']['output']>;
  getNumberOfTimesDiscountWasUsed?: Maybe<Scalars['Int']['output']>;
  getOperationCountries?: Maybe<Array<Maybe<OperationCountry>>>;
  getOperationCountriesLength: Scalars['Int']['output'];
  getOperationCountry?: Maybe<OperationCountry>;
  getOpsConfig?: Maybe<OpsConfig>;
  getOrder?: Maybe<OrderItem>;
  getOrderLifecycleHistory: Array<OrderLifecycleHistoryEntry>;
  getOrderStatusHistory: Array<OrderStatusHistoryEntry>;
  getOrderStatusRegistry: Array<OrderStatusRegistry>;
  getOrderStatusesStats?: Maybe<OrderStatsStats>;
  getOrders?: Maybe<Array<Maybe<OrderItem>>>;
  getOrdersLength: Scalars['Int']['output'];
  getOrganization?: Maybe<Organization>;
  getOrganizationComprehensive?: Maybe<OrganizationComprehensive>;
  getOrganizationInvitation?: Maybe<OrganizationInvitationResponse>;
  getOrganizationLength: Scalars['Int']['output'];
  getOrganizationPaymentAccount?: Maybe<OrganizationPaymentAccount>;
  getOrganizationPaymentAccounts?: Maybe<Array<Maybe<OrganizationPaymentAccount>>>;
  getOrganizationPaymentSetup?: Maybe<OrganizationPaymentSetup>;
  getOrganizationPaymentSetups?: Maybe<Array<Maybe<OrganizationPaymentSetup>>>;
  getOrganizations: Array<Organization>;
  getPartnership?: Maybe<Partnership>;
  getPartnerships: Array<Partnership>;
  getPartnershipsLength: Scalars['Int']['output'];
  getPickUpLocation?: Maybe<Pickup>;
  getPickUpLocations?: Maybe<Array<Pickup>>;
  getPickUpLocationsLength: Scalars['Int']['output'];
  getPlatformMe: PlatformUser;
  getPlatformRole?: Maybe<PlatformRole>;
  getPlatformRoles?: Maybe<Array<PlatformRole>>;
  getPlatformRolesLength: Scalars['Int']['output'];
  getPlatformUser?: Maybe<PlatformUser>;
  getPlatformUserLength: Scalars['Int']['output'];
  getPlatformUserStats: PlatformUserStats;
  getPlatformUsers?: Maybe<Array<PlatformUser>>;
  getPlugin?: Maybe<Plugin>;
  getPlugins?: Maybe<Array<Maybe<Plugin>>>;
  getPositionInTendoLeaderBoard?: Maybe<TendoLeaderBoardPosition>;
  getProduct?: Maybe<Product>;
  getProductAssignedCategories?: Maybe<Array<ProductCategory>>;
  getProductCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  getProductCategoriesLength: Scalars['Int']['output'];
  getProductCategory?: Maybe<ProductCategory>;
  getProductCombination: Scalars['Int']['output'];
  getProductCombinations?: Maybe<Array<Maybe<ProductCombination>>>;
  getProductCombinationsLength: Scalars['Int']['output'];
  getProductDiscount?: Maybe<Discount>;
  getProductHistory?: Maybe<Array<Maybe<ProductHistory>>>;
  getProductInventoryHistory?: Maybe<Array<Maybe<ProductInventoryHistory>>>;
  getProductMargins?: Maybe<Scalars['Any']['output']>;
  getProductRequests?: Maybe<Array<Maybe<ProductRequest>>>;
  getProductStockUpdateHistory?: Maybe<Array<Maybe<ProductStockHistoryItem>>>;
  getProductStockUpdateHistoryLength: Scalars['Int']['output'];
  getProductTemplate?: Maybe<ProductTemplate>;
  getProductTemplates?: Maybe<Array<ProductTemplate>>;
  getProductTemplatesLength?: Maybe<Scalars['Int']['output']>;
  getProducts?: Maybe<Array<Maybe<Product>>>;
  getProductsCountByCategories?: Maybe<Array<Maybe<ProductCategoryCount>>>;
  getProductsForAdmin?: Maybe<Array<Maybe<Product>>>;
  getProductsForAdminLength: Scalars['Int']['output'];
  getProductsForMobileApp?: Maybe<Array<Maybe<Product>>>;
  getProductsForMobileAppLength: Scalars['Int']['output'];
  getProductsForSupplierApp?: Maybe<Array<Maybe<Product>>>;
  getProductsForSupplierAppLength: Scalars['Int']['output'];
  getProductsForSupplierDashboard?: Maybe<Array<Maybe<Product>>>;
  getProductsForSupplierDashboardLength: Scalars['Int']['output'];
  getProductsForWebApp?: Maybe<Array<Maybe<Product>>>;
  getProductsForWebAppLength: Scalars['Int']['output'];
  getProductsLength?: Maybe<Scalars['Int']['output']>;
  getProductsLikedByUser: Array<Maybe<Product>>;
  getProductsMetrics?: Maybe<ProductsStats>;
  getProductsSavedByUser: Array<Maybe<Product>>;
  getProductsSharedByUser: Array<Maybe<SharedProduct>>;
  getProductsShipments?: Maybe<Array<Maybe<ProductShipment>>>;
  getPromoBanner?: Maybe<PromoBanner>;
  getPromoBanners?: Maybe<Array<Maybe<PromoBanner>>>;
  getPromoBannersLength: Scalars['Int']['output'];
  getRandomProducts?: Maybe<Array<Maybe<Product>>>;
  getRecentOrderForUser?: Maybe<Order>;
  getRevenueFromProfit?: Maybe<ProfitRevenueStats>;
  getReview: Review;
  getReviews?: Maybe<Array<Maybe<Review>>>;
  getReviewsLength: Scalars['Int']['output'];
  getRider?: Maybe<Rider>;
  getRiderIssueReports?: Maybe<Array<RiderIssueReport>>;
  getRiderIssueReportsLength: Scalars['Int']['output'];
  getRiders?: Maybe<Array<Rider>>;
  getRidersLength: Scalars['Int']['output'];
  getSKU?: Maybe<Scalars['String']['output']>;
  getSales?: Maybe<Array<Maybe<Sales>>>;
  getSelfCheckoutCustomer?: Maybe<Customer>;
  getSelfCheckoutLink?: Maybe<Scalars['String']['output']>;
  getSharedProduct: SharedProduct;
  getSharedProducts?: Maybe<Array<Maybe<SharedProduct>>>;
  getShop?: Maybe<Shop>;
  getShopCollection?: Maybe<ShopCollection>;
  getShopCollectionProducts?: Maybe<Array<Maybe<Product>>>;
  getShopCollectionProductsLength: Scalars['Int']['output'];
  getShopCollections?: Maybe<Array<ShopCollection>>;
  getShopCollectionsLength: Scalars['Int']['output'];
  getShopProducts?: Maybe<Array<Maybe<Product>>>;
  getShopProductsLength: Scalars['Int']['output'];
  getShopifyShop?: Maybe<ShopifyShop>;
  getShopifyShops?: Maybe<Array<Maybe<ShopifyShop>>>;
  getShops?: Maybe<Array<Shop>>;
  getShopsLength: Scalars['Int']['output'];
  getSixMonthsActiveUsers?: Maybe<Scalars['Any']['output']>;
  getStorefrontCart?: Maybe<StorefrontCart>;
  getStorefrontCarts?: Maybe<StorefrontCartsReturnType>;
  getStorefrontCartsLength?: Maybe<Scalars['Int']['output']>;
  getStorefrontTransaction?: Maybe<Transaction>;
  getStorefrontTransactions?: Maybe<Array<Maybe<Transaction>>>;
  getSubCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  getSupplier?: Maybe<Supplier>;
  getSupplierAccountHistory?: Maybe<Array<SupplierAccountHistory>>;
  getSupplierAccountHistoryLength: Scalars['Int']['output'];
  getSupplierBusinessPickupLocations?: Maybe<Array<Maybe<SupplierLocation>>>;
  getSupplierDailyOrdersSummary?: Maybe<Scalars['Any']['output']>;
  getSupplierOrdersByStatusSummary?: Maybe<OrderStatusesStats>;
  getSupplierPickupLocation?: Maybe<SupplierLocation>;
  getSupplierStats?: Maybe<SupplierStats>;
  getSupplierWallets?: Maybe<Array<Maybe<WalletResponseDto>>>;
  getSuppliers?: Maybe<Array<Supplier>>;
  getSuppliersLength: Scalars['Int']['output'];
  getSupportedCurrencies?: Maybe<Array<Maybe<SupportedCurrenciesResponseDto>>>;
  getSupportedProviders?: Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>;
  getTeam?: Maybe<Team>;
  getTeams?: Maybe<Array<Maybe<Team>>>;
  getTenantTypeStatusTemplates: Array<IndustryStatusTemplate>;
  getTenantWallet?: Maybe<WalletResponseDto>;
  getTendoLeaderBoardPositions?: Maybe<Array<TendoLeaderBoardPosition>>;
  getTendoLeaderBoardPositionsLength: Scalars['Int']['output'];
  getTendoLeaderBoards: Array<TendoLeaderBoard>;
  getTendoLeaderBoardsLength: Scalars['Int']['output'];
  getTerm?: Maybe<Terms>;
  getTerms?: Maybe<Array<Terms>>;
  getTermsLength: Scalars['Int']['output'];
  getThreeMonthsActiveUsers?: Maybe<Scalars['Any']['output']>;
  getTopProducts: TopProductsResponseDto;
  getTopResellersForTheWeek?: Maybe<Array<Maybe<TopReseller>>>;
  getTopResellersForTheWeekByOrderCount?: Maybe<Array<Maybe<TopReseller>>>;
  getTransaction?: Maybe<Transaction>;
  getTransactions?: Maybe<Array<Maybe<Transaction>>>;
  getTransactionsCount?: Maybe<Scalars['Int']['output']>;
  getUnverifiedProducts?: Maybe<Array<Maybe<Product>>>;
  getUser?: Maybe<User>;
  getUserAccountSecurity?: Maybe<Array<Maybe<UserAccountSecurity>>>;
  getUserCoupons?: Maybe<Array<CouponRedemption>>;
  getUserCouponsLength: Scalars['Int']['output'];
  getUserDelayedOrders?: Maybe<Array<Maybe<OrderItem>>>;
  getUserNotification?: Maybe<UserNotification>;
  getUserNotifications?: Maybe<Array<Maybe<UserNotification>>>;
  getUserNotificationsLength: Scalars['Int']['output'];
  getUserPaymentDetails?: Maybe<Array<UserPayment>>;
  getUserPlugins?: Maybe<Array<Maybe<UserPlugin>>>;
  getUserReferralsMetrics?: Maybe<UserReferralMetrics>;
  getUserWallet?: Maybe<WalletResponseDto>;
  getUserWallets?: Maybe<Array<Maybe<WalletResponseDto>>>;
  getUsers?: Maybe<Array<Maybe<User>>>;
  getUsersLength: Scalars['Int']['output'];
  getVariation: Scalars['Int']['output'];
  getVariations?: Maybe<Array<Maybe<Variation>>>;
  getVariationsLength: Scalars['Int']['output'];
  getWalletBalance?: Maybe<WalletBalanceDto>;
  getWalletPayout?: Maybe<WalletPayoutResponseDto>;
  getWalletPayouts?: Maybe<Array<Maybe<WalletPayoutResponseDto>>>;
  getWalletPayoutsCount?: Maybe<Scalars['Int']['output']>;
  getWalletTransactions?: Maybe<Array<Maybe<Transaction>>>;
  getWalletTransactionsCount?: Maybe<Scalars['Int']['output']>;
  getWeeklyActiveUsers?: Maybe<Scalars['Any']['output']>;
  getWeeklyActiveUsersGraph?: Maybe<Scalars['Any']['output']>;
  getYearActiveUsers?: Maybe<Scalars['Any']['output']>;
  getYesterDayActiveUser?: Maybe<Scalars['Any']['output']>;
  hasPermission: Scalars['Boolean']['output'];
  isProductInShop?: Maybe<Scalars['Boolean']['output']>;
  isProductLikedByUser?: Maybe<Scalars['Boolean']['output']>;
  isProductSavedByUser?: Maybe<Scalars['Boolean']['output']>;
  isProductSharedByUser?: Maybe<Scalars['Boolean']['output']>;
  isSkuAvailable?: Maybe<Scalars['Boolean']['output']>;
  listOrganizations?: Maybe<Array<Organization>>;
  listPspCredentials?: Maybe<Array<Maybe<PspCredential>>>;
  loadShopifyProducts?: Maybe<Array<Maybe<ShopifyLoadedProduct>>>;
  me?: Maybe<User>;
  /** Get current user's available features */
  myAvailableFeatures: Array<FeatureModule>;
  myCustomerProfile?: Maybe<Customer>;
  myPermissions: Array<Permission>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  onBoardingCouponExistsAndNotConsumed?: Maybe<Scalars['Boolean']['output']>;
  orderGraphStats?: Maybe<Array<Maybe<OrderGraphData>>>;
  orderStats?: Maybe<OrderStats>;
  organization?: Maybe<Organization>;
  /**
   * Get a specific API key by ID.
   * Requires: apikey:read permission or owner/admin role.
   */
  organizationApiKey?: Maybe<ApiKey>;
  /**
   * List API keys for the current organization.
   * Requires: apikey:read permission or owner/admin role.
   */
  organizationApiKeys: ApiKeyList;
  organizationByCustomDomain?: Maybe<Organization>;
  organizationBySlug?: Maybe<Organization>;
  organizationBySlugMinimal?: Maybe<Organization>;
  organizationInvitations: Array<OrganizationInvitation>;
  organizationMembers: Array<OrganizationMember>;
  organizationOperationCountries: Array<OperationCountry>;
  organizationTenantInfo?: Maybe<TenantInfo>;
  platformDashboardStats: DashboardStats;
  platformOrganizationStats?: Maybe<OrganizationStats>;
  tenantCustomer?: Maybe<Customer>;
  tenantCustomers: Array<Customer>;
  tenantCustomersCount: Scalars['Int']['output'];
  /**
   * Lightweight utility to get enabled features for the current tenant.
   * No access checks or validation - for frontend/client to drive UI and functionality.
   * Re-query when tenant or features change.
   */
  tenantEnabledFeatures: Array<FeatureModule>;
  /** Get tenant feature summary */
  tenantFeatureSummary: TenantFeatureSummary;
  /** Get tenant's feature status with access information */
  tenantFeatures: Array<TenantFeatureStatus>;
  tenantOrders: Array<Order>;
  tenantProduct?: Maybe<Product>;
  tenantProducts: Array<Product>;
  tenantProductsCount: Scalars['Int']['output'];
  tenantRider?: Maybe<Rider>;
  tenantRiders: Array<Rider>;
  tenantRidersCount: Scalars['Int']['output'];
  topDeals?: Maybe<Array<Product>>;
  topDealsBanners?: Maybe<Array<TopDealBanner>>;
  topDealsLength: Scalars['Int']['output'];
  trendingProducts?: Maybe<Array<Product>>;
  user?: Maybe<User>;
  userGraphStats?: Maybe<Array<Maybe<UserGraphData>>>;
  userStats?: Maybe<UserStats>;
  users?: Maybe<Array<Maybe<User>>>;
  validateOrderStatusTransition: StatusTransitionValidation;
  verifyAccountDetails?: Maybe<Scalars['JSONObject']['output']>;
  verifyAuth: Auth;
  verifyPlatformToken: Scalars['Boolean']['output'];
};


export type QueryAppBannerArgs = {
  filter: AppBannerFilter;
};


export type QueryAppBannersArgs = {
  filter?: InputMaybe<AppBannerFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryAvailableFeaturesArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBobGetCourierRatesArgs = {
  data: BobGetCourierRatesRequestDto;
};


export type QueryBobGetOrderFulfillmentsArgs = {
  data: BobGetOrderFulfillmentsRequestDto;
};


export type QueryBobGetOrdersArgs = {
  data: BobGetOrdersRequestDto;
};


export type QueryBobGetRateRequestsArgs = {
  data: BobGetRateRequestsRequestDto;
};


export type QueryBobGetRatesAtCheckoutArgs = {
  data: BobGetRatesAtCheckoutRequestDto;
};


export type QueryBobGetShipmentWaybillArgs = {
  data: BobGetShipmentWaybillRequestDto;
};


export type QueryBobGetShipmentsArgs = {
  data: BobGetShipmentsRequestDto;
};


export type QueryBobGetTrackingEventsArgs = {
  data: BobGetTrackingEventsRequestDto;
};


export type QueryCanEnableFeatureArgs = {
  feature: FeatureModule;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCheckFeatureAccessArgs = {
  feature: FeatureModule;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCheckStockAvailabilityArgs = {
  skus: Array<StockAvailabilityInput>;
};


export type QueryCheckTransactionArgs = {
  input: CheckTransactionInput;
};


export type QueryConfirmCardSetupArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDeliveryLocationArgs = {
  filter: DeliveryFilter;
};


export type QueryDeliveryLocationsArgs = {
  filter?: InputMaybe<DeliveryFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryDeliveryLocationsLengthArgs = {
  filter?: InputMaybe<DeliveryFilter>;
};


export type QueryDoesShopDomainExistArgs = {
  data: SokoWorldDomainExistsRequestDto;
};


export type QueryDoesShopExistArgs = {
  filter: ShopFilter;
};


export type QueryDownloadWalletStatementArgs = {
  input: DownloadWalletStatementInput;
};


export type QueryFeatureDefinitionArgs = {
  feature: FeatureModule;
};


export type QueryFeaturedCategoriesArgs = {
  filter?: InputMaybe<FeaturedCategoriesFilter>;
};


export type QueryFeaturesByCategoryArgs = {
  category: FeatureCategory;
};


export type QueryFeaturesByTenantTypeArgs = {
  tenantType: TenantType;
};


export type QueryFeaturesByTierArgs = {
  tier: SubscriptionTier;
};


export type QueryFindDeliveryZoneArgs = {
  location?: InputMaybe<LatLngInput>;
};


export type QueryGetActiveTendoLeaderBoardPositionsArgs = {
  limit: Scalars['Int']['input'];
};


export type QueryGetAffiliateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAffiliateLinksArgs = {
  affiliate_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAliExpressProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAliExpressProductsArgs = {
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAppCartArgs = {
  user_id: Scalars['ID']['input'];
};


export type QueryGetAssignedOrdersForRiderArgs = {
  filter?: InputMaybe<CartAssignmentFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetAssignedOrdersForRiderLengthArgs = {
  filter?: InputMaybe<CartAssignmentFilter>;
};


export type QueryGetAvailablePaymentFacilitatorArgs = {
  input: GetAvailablePaymentFacilitatorInput;
};


export type QueryGetCampaignArgs = {
  filter?: InputMaybe<CampaignFilter>;
};


export type QueryGetCampaignsArgs = {
  filter?: InputMaybe<CampaignFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCampaignsCountArgs = {
  filter?: InputMaybe<CampaignFilter>;
};


export type QueryGetCartArgs = {
  filter?: InputMaybe<CartFilter>;
};


export type QueryGetCartsArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<CartFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCartsLengthArgs = {
  filter?: InputMaybe<CartFilter>;
};


export type QueryGetCatalogArgs = {
  filter?: InputMaybe<CatalogFilter>;
};


export type QueryGetCatalogsArgs = {
  filter?: InputMaybe<CatalogFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCatalogsLengthArgs = {
  filter?: InputMaybe<CatalogFilter>;
};


export type QueryGetCategoryMediaArgs = {
  filter: ProductCategoryFilter;
  pagination: Pagination;
};


export type QueryGetCollectionProductsArgs = {
  filter?: InputMaybe<CatalogFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCollectionProductsLengthArgs = {
  filter?: InputMaybe<CatalogFilter>;
};


export type QueryGetCouponArgs = {
  filter: CouponFilter;
};


export type QueryGetCouponRedemptionsArgs = {
  filter: CouponRedemptionFilter;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCouponRedemptionsLengthArgs = {
  filter: CouponRedemptionFilter;
};


export type QueryGetCouponsArgs = {
  filter?: InputMaybe<CouponFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCouponsLengthArgs = {
  filter?: InputMaybe<CouponFilter>;
};


export type QueryGetCustomerArgs = {
  filter?: InputMaybe<CustomerFilter>;
};


export type QueryGetCustomersArgs = {
  filter?: InputMaybe<CustomerFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCustomersLengthArgs = {
  filter?: InputMaybe<CustomerFilter>;
};


export type QueryGetDailyOrdersSummaryArgs = {
  country: Scalars['String']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type QueryGetDelayedProfitPayoutsArgs = {
  country: Scalars['String']['input'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDelayedProfitPayoutsLengthArgs = {
  country: Scalars['String']['input'];
};


export type QueryGetDeliveredOrdersArgs = {
  filter?: InputMaybe<DeliveredOrdersFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDeliveryPricesArgs = {
  input?: InputMaybe<DeliveryPricesInput>;
};


export type QueryGetDeliveryZoneArgs = {
  filter?: InputMaybe<DeliveryZonesFilter>;
};


export type QueryGetDeliveryZonesArgs = {
  filter?: InputMaybe<DeliveryZonesFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDeliveryZonesLengthArgs = {
  filter?: InputMaybe<DeliveryZonesFilter>;
};


export type QueryGetDeveloperArgs = {
  input: GetDeveloperInput;
};


export type QueryGetDevelopersArgs = {
  input: GetDevelopersInput;
};


export type QueryGetDigitalOrderArgs = {
  filter: DigitalOrderFilter;
};


export type QueryGetDigitalOrdersArgs = {
  filter?: InputMaybe<DigitalOrderFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDigitalOrdersLengthArgs = {
  filter?: InputMaybe<DigitalOrderFilter>;
};


export type QueryGetDiscountArgs = {
  filter: DiscountFilter;
};


export type QueryGetDiscountProductConditionArgs = {
  filter: DiscountProductConditionFilter;
};


export type QueryGetDiscountProductConditionsArgs = {
  filter?: InputMaybe<DiscountProductConditionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDiscountProductConditionsLengthArgs = {
  filter?: InputMaybe<DiscountProductConditionFilter>;
};


export type QueryGetDiscountsArgs = {
  filter?: InputMaybe<DiscountFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDiscountsLengthArgs = {
  filter?: InputMaybe<DiscountFilter>;
};


export type QueryGetFailedOfflineOrdersArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetForexRatesArgs = {
  filter?: InputMaybe<ForexRateFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetInsightOnCouponArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInventoryArgs = {
  filter?: InputMaybe<InventoryFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<InventorySort>;
};


export type QueryGetInventoryBySkuArgs = {
  sku: Scalars['String']['input'];
};


export type QueryGetInventoryLengthArgs = {
  filter?: InputMaybe<InventoryFilter>;
};


export type QueryGetInventoryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInventoryLocationsArgs = {
  filter?: InputMaybe<InventoryLocationFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<InventoryLocationSort>;
};


export type QueryGetInventoryLocationsLengthArgs = {
  filter?: InputMaybe<InventoryLocationFilter>;
};


export type QueryGetInventoryReservationsArgs = {
  filter?: InputMaybe<InventoryReservationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetInventoryReservationsLengthArgs = {
  filter?: InputMaybe<InventoryReservationFilter>;
};


export type QueryGetInventoryTransactionsArgs = {
  filter?: InputMaybe<InventoryTransactionFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<InventoryTransactionSort>;
};


export type QueryGetInventoryTransactionsLengthArgs = {
  filter?: InputMaybe<InventoryTransactionFilter>;
};


export type QueryGetMainCategoriesArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetNumberOfTimesDiscountWasUsedArgs = {
  input: DiscountUseFilter;
};


export type QueryGetOperationCountriesArgs = {
  input?: InputMaybe<GetOperationCountryInput>;
};


export type QueryGetOperationCountriesLengthArgs = {
  input?: InputMaybe<GetOperationCountryInput>;
};


export type QueryGetOperationCountryArgs = {
  input: GetOperationCountryInput;
};


export type QueryGetOpsConfigArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrderArgs = {
  filter?: InputMaybe<OrderFilter>;
};


export type QueryGetOrderLifecycleHistoryArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryGetOrderStatusHistoryArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryGetOrderStatusRegistryArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetOrderStatusesStatsArgs = {
  country: Scalars['String']['input'];
};


export type QueryGetOrdersArgs = {
  filter?: InputMaybe<OrderFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<OrderSort>;
};


export type QueryGetOrdersLengthArgs = {
  filter?: InputMaybe<OrderFilter>;
};


export type QueryGetOrganizationArgs = {
  filter: OrganizationFilter;
};


export type QueryGetOrganizationComprehensiveArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetOrganizationInvitationArgs = {
  invitationId: Scalars['String']['input'];
  organizationSlug: Scalars['String']['input'];
};


export type QueryGetOrganizationLengthArgs = {
  filter?: InputMaybe<OrganizationFilter>;
};


export type QueryGetOrganizationPaymentAccountArgs = {
  input: GetOrganizationPaymentAccountsInput;
};


export type QueryGetOrganizationPaymentAccountsArgs = {
  input: GetOrganizationPaymentAccountsInput;
};


export type QueryGetOrganizationPaymentSetupArgs = {
  input: GetOrganizationPaymentSetupsInput;
};


export type QueryGetOrganizationPaymentSetupsArgs = {
  input: GetOrganizationPaymentSetupsInput;
};


export type QueryGetOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPartnershipArgs = {
  filter: PartnershipFilter;
};


export type QueryGetPartnershipsArgs = {
  filter?: InputMaybe<PartnershipFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPartnershipsLengthArgs = {
  filter?: InputMaybe<PartnershipFilter>;
};


export type QueryGetPickUpLocationArgs = {
  filter?: InputMaybe<DeliveryFilter>;
};


export type QueryGetPickUpLocationsArgs = {
  filter?: InputMaybe<DeliveryFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPickUpLocationsLengthArgs = {
  filter?: InputMaybe<DeliveryFilter>;
};


export type QueryGetPlatformRoleArgs = {
  filter: PlatformRoleFilter;
};


export type QueryGetPlatformRolesArgs = {
  filter?: InputMaybe<PlatformRoleFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPlatformRolesLengthArgs = {
  filter?: InputMaybe<PlatformRoleFilter>;
};


export type QueryGetPlatformUserArgs = {
  filter: PlatformUserFilter;
};


export type QueryGetPlatformUserLengthArgs = {
  filter?: InputMaybe<PlatformUserFilter>;
};


export type QueryGetPlatformUsersArgs = {
  filter?: InputMaybe<PlatformUserFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPluginArgs = {
  filter: PluginFilter;
};


export type QueryGetPluginsArgs = {
  filter?: InputMaybe<PluginFilter>;
  pagination?: InputMaybe<Pagination>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPositionInTendoLeaderBoardArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetProductArgs = {
  filter?: InputMaybe<ProductFilter>;
};


export type QueryGetProductAssignedCategoriesArgs = {
  product_id: Scalars['ID']['input'];
};


export type QueryGetProductCategoriesArgs = {
  filter?: InputMaybe<ProductCategoryFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetProductCategoriesLengthArgs = {
  filter?: InputMaybe<ProductCategoryFilter>;
};


export type QueryGetProductCategoryArgs = {
  filter?: InputMaybe<ProductCategoryFilter>;
};


export type QueryGetProductCombinationArgs = {
  filter?: InputMaybe<ProductCombinationFilter>;
};


export type QueryGetProductCombinationsArgs = {
  filter?: InputMaybe<ProductCombinationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetProductCombinationsLengthArgs = {
  filter?: InputMaybe<ProductCombinationFilter>;
};


export type QueryGetProductDiscountArgs = {
  productSKU?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProductHistoryArgs = {
  filter: ProductHistoryFilter;
  pagination: Pagination;
};


export type QueryGetProductInventoryHistoryArgs = {
  filter: ProductInventoryHistoryFilter;
  pagination: Pagination;
};


export type QueryGetProductRequestsArgs = {
  filter?: InputMaybe<ProductRequestFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetProductStockUpdateHistoryArgs = {
  filter: ProductInventoryHistoryFilter;
  pagination: Pagination;
};


export type QueryGetProductStockUpdateHistoryLengthArgs = {
  filter: ProductInventoryHistoryFilter;
};


export type QueryGetProductTemplateArgs = {
  filter: TemplateFilter;
};


export type QueryGetProductTemplatesArgs = {
  filter?: InputMaybe<TemplateFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetProductTemplatesLengthArgs = {
  filter?: InputMaybe<TemplateFilter>;
};


export type QueryGetProductsArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetProductsCountByCategoriesArgs = {
  supplier_id: Scalars['ID']['input'];
};


export type QueryGetProductsForAdminArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetProductsForAdminLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ProductFilter>;
};


export type QueryGetProductsForMobileAppArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ClientProductFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetProductsForMobileAppLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ClientProductFilter>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetProductsForSupplierAppArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<SupplierProductFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetProductsForSupplierAppLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<SupplierProductFilter>;
};


export type QueryGetProductsForSupplierDashboardArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<SupplierProductFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetProductsForSupplierDashboardLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<SupplierProductFilter>;
};


export type QueryGetProductsForWebAppArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ClientProductFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetProductsForWebAppLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ClientProductFilter>;
};


export type QueryGetProductsLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ProductFilter>;
};


export type QueryGetProductsLikedByUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetProductsMetricsArgs = {
  filter: ProductMetricsFilter;
};


export type QueryGetProductsSavedByUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetProductsSharedByUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetProductsShipmentsArgs = {
  filter?: InputMaybe<ProductShipmentFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPromoBannerArgs = {
  screen: Scalars['String']['input'];
};


export type QueryGetPromoBannersArgs = {
  filter?: InputMaybe<PromoBannerFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPromoBannersLengthArgs = {
  filter?: InputMaybe<PromoBannerFilter>;
};


export type QueryGetRandomProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetRecentOrderForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetRevenueFromProfitArgs = {
  country: Scalars['String']['input'];
};


export type QueryGetReviewArgs = {
  filter: ReviewFilter;
};


export type QueryGetReviewsArgs = {
  filter?: InputMaybe<ReviewFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetReviewsLengthArgs = {
  filter: ReviewFilter;
};


export type QueryGetRiderArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<RiderFilter>;
};


export type QueryGetRiderIssueReportsArgs = {
  filter?: InputMaybe<RiderIssueReportFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetRiderIssueReportsLengthArgs = {
  filter?: InputMaybe<RiderIssueReportFilter>;
};


export type QueryGetRidersArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<RiderFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetRidersLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<RiderFilter>;
};


export type QueryGetSalesArgs = {
  filter?: InputMaybe<SalesFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSelfCheckoutCustomerArgs = {
  input: GetCustomerInput;
};


export type QueryGetSelfCheckoutLinkArgs = {
  shared_product_id: Scalars['ID']['input'];
};


export type QueryGetSharedProductArgs = {
  input: GetSharedProductRequestDto;
};


export type QueryGetSharedProductsArgs = {
  filter?: InputMaybe<SharedProductFilter>;
  pagination?: InputMaybe<Pagination>;
  productFilter?: InputMaybe<ProductFilter>;
};


export type QueryGetShopArgs = {
  filter: ShopFilter;
};


export type QueryGetShopCollectionArgs = {
  filter: ShopCollectionFilter;
};


export type QueryGetShopCollectionProductsArgs = {
  filter: ShopCollectionProductsFilter;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetShopCollectionProductsLengthArgs = {
  filter: ShopCollectionProductsFilter;
};


export type QueryGetShopCollectionsArgs = {
  filter?: InputMaybe<ShopCollectionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetShopCollectionsLengthArgs = {
  filter?: InputMaybe<ShopCollectionFilter>;
};


export type QueryGetShopProductsArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ShopProductsFilter>;
  pagination?: InputMaybe<Pagination>;
  shop_id: Scalars['ID']['input'];
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetShopProductsLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ShopProductsFilter>;
  shop_id: Scalars['ID']['input'];
  sort?: InputMaybe<ProductSort>;
};


export type QueryGetShopifyShopArgs = {
  input?: InputMaybe<FetchShopifyShopInput>;
};


export type QueryGetShopifyShopsArgs = {
  input?: InputMaybe<FetchShopifyShopsInput>;
};


export type QueryGetShopsArgs = {
  filter?: InputMaybe<ShopFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetShopsLengthArgs = {
  filter?: InputMaybe<ShopFilter>;
};


export type QueryGetStorefrontCartArgs = {
  filter?: InputMaybe<StorefrontCartFilter>;
};


export type QueryGetStorefrontCartsArgs = {
  filter?: InputMaybe<StorefrontCartFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetStorefrontCartsLengthArgs = {
  filter?: InputMaybe<StorefrontCartFilter>;
};


export type QueryGetStorefrontTransactionArgs = {
  input: GetStorefrontTransactionsInput;
};


export type QueryGetStorefrontTransactionsArgs = {
  input: GetStorefrontTransactionsInput;
};


export type QueryGetSubCategoriesArgs = {
  filter?: InputMaybe<ProductCategoryFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSupplierArgs = {
  filter?: InputMaybe<SupplierFilter>;
};


export type QueryGetSupplierAccountHistoryArgs = {
  pagination?: InputMaybe<Pagination>;
  supplier_id: Scalars['ID']['input'];
};


export type QueryGetSupplierAccountHistoryLengthArgs = {
  supplier_id: Scalars['ID']['input'];
};


export type QueryGetSupplierBusinessPickupLocationsArgs = {
  filter?: InputMaybe<SupplierLocationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSupplierDailyOrdersSummaryArgs = {
  from: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  to: Scalars['Date']['input'];
};


export type QueryGetSupplierOrdersByStatusSummaryArgs = {
  from: Scalars['Date']['input'];
  supplier_id: Scalars['ID']['input'];
  to: Scalars['Date']['input'];
};


export type QueryGetSupplierPickupLocationArgs = {
  input?: InputMaybe<GetSupplierPickupLocationInput>;
};


export type QueryGetSupplierStatsArgs = {
  supplier_id: Scalars['ID']['input'];
};


export type QueryGetSupplierWalletsArgs = {
  user_id: Scalars['ID']['input'];
};


export type QueryGetSuppliersArgs = {
  filter?: InputMaybe<SupplierFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSuppliersLengthArgs = {
  filter?: InputMaybe<SupplierFilter>;
};


export type QueryGetSupportedCurrenciesArgs = {
  input?: InputMaybe<SupportedCurrencyFilter>;
};


export type QueryGetSupportedProvidersArgs = {
  input?: InputMaybe<GetSupportedProvidersInput>;
};


export type QueryGetTeamArgs = {
  input: GetTeamInput;
};


export type QueryGetTeamsArgs = {
  input: GetTeamsInput;
};


export type QueryGetTenantTypeStatusTemplatesArgs = {
  tenantType: Scalars['String']['input'];
};


export type QueryGetTenantWalletArgs = {
  input: GetTenantWalletInput;
};


export type QueryGetTendoLeaderBoardPositionsArgs = {
  filter: TendoLeaderBoardFilter;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetTendoLeaderBoardPositionsLengthArgs = {
  filter: TendoLeaderBoardFilter;
};


export type QueryGetTendoLeaderBoardsArgs = {
  filter?: InputMaybe<TendoLeaderBoardFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetTendoLeaderBoardsLengthArgs = {
  filter?: InputMaybe<TendoLeaderBoardFilter>;
};


export type QueryGetTermArgs = {
  filter?: InputMaybe<TermsFilter>;
};


export type QueryGetTermsArgs = {
  filter?: InputMaybe<TermsFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetTermsLengthArgs = {
  filter?: InputMaybe<TermsFilter>;
};


export type QueryGetTopProductsArgs = {
  input: TopProductsRequestDto;
};


export type QueryGetTopResellersForTheWeekArgs = {
  country: Scalars['String']['input'];
};


export type QueryGetTopResellersForTheWeekByOrderCountArgs = {
  country: Scalars['String']['input'];
};


export type QueryGetTransactionArgs = {
  input: GetTransactionsInput;
};


export type QueryGetTransactionsArgs = {
  input: GetTransactionsInput;
};


export type QueryGetTransactionsCountArgs = {
  input: GetTransactionsInput;
};


export type QueryGetUnverifiedProductsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUserArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<UserFilter>;
};


export type QueryGetUserAccountSecurityArgs = {
  filter?: InputMaybe<AccountSecurityFilter>;
};


export type QueryGetUserCouponsArgs = {
  filter?: InputMaybe<CouponRedemptionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUserCouponsLengthArgs = {
  filter?: InputMaybe<CouponRedemptionFilter>;
};


export type QueryGetUserDelayedOrdersArgs = {
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetUserNotificationArgs = {
  filter?: InputMaybe<NotificationFilter>;
};


export type QueryGetUserNotificationsArgs = {
  filter?: InputMaybe<NotificationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUserNotificationsLengthArgs = {
  filter?: InputMaybe<NotificationFilter>;
};


export type QueryGetUserPaymentDetailsArgs = {
  filter?: InputMaybe<UserPaymentFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUserPluginsArgs = {
  filter?: InputMaybe<UserPluginFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUserReferralsMetricsArgs = {
  username: Scalars['String']['input'];
};


export type QueryGetUserWalletArgs = {
  input: GetWalletInput;
};


export type QueryGetUserWalletsArgs = {
  user_id: Scalars['ID']['input'];
};


export type QueryGetUsersArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<UserFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUsersLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<UserFilter>;
};


export type QueryGetVariationArgs = {
  filter?: InputMaybe<VariationFilter>;
};


export type QueryGetVariationsArgs = {
  filter?: InputMaybe<VariationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetVariationsLengthArgs = {
  filter?: InputMaybe<VariationFilter>;
};


export type QueryGetWalletBalanceArgs = {
  input?: InputMaybe<GetWalletBalanceInput>;
};


export type QueryGetWalletPayoutArgs = {
  input: GetWalletPayoutsInput;
};


export type QueryGetWalletPayoutsArgs = {
  input: GetWalletPayoutsInput;
};


export type QueryGetWalletPayoutsCountArgs = {
  input?: InputMaybe<GetWalletPayoutsInput>;
};


export type QueryGetWalletTransactionsArgs = {
  input: GetWalletTransactionsInput;
};


export type QueryGetWalletTransactionsCountArgs = {
  input: GetWalletTransactionsInput;
};


export type QueryHasPermissionArgs = {
  permission: Scalars['String']['input'];
};


export type QueryIsProductInShopArgs = {
  product_id: Scalars['ID']['input'];
  shop_id: Scalars['ID']['input'];
};


export type QueryIsProductLikedByUserArgs = {
  input: IsProductLikedByUserInput;
};


export type QueryIsProductSavedByUserArgs = {
  input: IsProductSavedByUserInput;
};


export type QueryIsProductSharedByUserArgs = {
  input: IsProductSharedByUserInput;
};


export type QueryIsSkuAvailableArgs = {
  sku: Scalars['String']['input'];
};


export type QueryLoadShopifyProductsArgs = {
  integrationId: Scalars['ID']['input'];
};


export type QueryOnBoardingCouponExistsAndNotConsumedArgs = {
  userCreatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryOrderStatsArgs = {
  country: Scalars['String']['input'];
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationApiKeysArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationByCustomDomainArgs = {
  customDomain: Scalars['String']['input'];
};


export type QueryOrganizationBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryOrganizationBySlugMinimalArgs = {
  slug: Scalars['String']['input'];
};


export type QueryOrganizationInvitationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrganizationMembersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrganizationOperationCountriesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTenantCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantCustomersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTenantCustomersCountArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTenantEnabledFeaturesArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTenantFeatureSummaryArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTenantFeaturesArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTenantOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTenantProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantProductsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTenantProductsCountArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTenantRiderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantRidersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenantRidersCountArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopDealsArgs = {
  filter?: InputMaybe<FeaturedCategoriesFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryTopDealsBannersArgs = {
  filter?: InputMaybe<FeaturedCategoriesFilter>;
};


export type QueryTopDealsLengthArgs = {
  filter?: InputMaybe<ProductFilter>;
};


export type QueryTrendingProductsArgs = {
  filter?: InputMaybe<TrendingProductsFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserStatsArgs = {
  country: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  input?: InputMaybe<FetchUserInput>;
};


export type QueryValidateOrderStatusTransitionArgs = {
  fromStatus: Scalars['String']['input'];
  toStatus: Scalars['String']['input'];
};


export type QueryVerifyAccountDetailsArgs = {
  input: PaystackValidateAccountInput;
};


export type QueryVerifyAuthArgs = {
  input?: InputMaybe<VerifyEmailInput>;
};


export type QueryVerifyPlatformTokenArgs = {
  token: Scalars['String']['input'];
};

export enum ReasonForPayment {
  /** payment record created when a customer makes payment for an order on either the storefront or the self-checkout(future) */
  OrderPurchase = 'order_purchase',
  /** payment record created when reseller makes payment to be credited to their wallet */
  WalletTopup = 'wallet_topup'
}

export type RecentSignup = {
  __typename?: 'RecentSignup';
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  plan: Scalars['String']['output'];
};

export enum ReductionType {
  Amount = 'amount',
  Percentage = 'percentage'
}

export type RemoveItemFromStorefrontCartInput = {
  cart_id: Scalars['ID']['input'];
  item: StorefrontCartItemInput;
};

export type RequestOtpResponse = {
  __typename?: 'RequestOTPResponse';
  token?: Maybe<Scalars['String']['output']>;
};

export type RequestRiderOtpInput = {
  channel?: InputMaybe<ChannelType>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type RequestSupplierOtpResponse = {
  __typename?: 'RequestSupplierOTPResponse';
  token?: Maybe<Scalars['String']['output']>;
};

export type RequestSupplierPhoneVerificationResponse = {
  __typename?: 'RequestSupplierPhoneVerificationResponse';
  code: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export enum ReservationStatus {
  Active = 'active',
  Consumed = 'consumed',
  Expired = 'expired'
}

export type Result = {
  __typename?: 'Result';
  ae_item_base_info_dto?: Maybe<AeItemBaseInfoDto>;
  ae_item_properties?: Maybe<AeItemProperty>;
  ae_item_sku_info_dtos?: Maybe<AeItemSkuInfoDtos>;
  ae_multimedia_info_dto?: Maybe<AeMultimediaInfoDto>;
  ae_store_info?: Maybe<AeStoreInfo>;
  has_whole_sale?: Maybe<Scalars['String']['output']>;
  logistics_info_dto?: Maybe<LogisticsInfoDto>;
  package_info_dto?: Maybe<PackageInfoDto>;
  product_id_converter_result?: Maybe<ProductIdConverterResult>;
};

export type ReverseTransactionInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  ops_personnel?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

export type Review = {
  __typename?: 'Review';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rating: Scalars['Float']['output'];
  user_id: Scalars['ID']['output'];
};

export type ReviewBreakDown = {
  __typename?: 'ReviewBreakDown';
  breakDown: BreakDownItems;
  totalReviews: Scalars['Int']['output'];
};

export type ReviewFilter = {
  id?: InputMaybe<IdOperator>;
  product_id?: InputMaybe<IdOperator>;
};

export type ReviewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  product_id: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
  user_id: Scalars['ID']['input'];
};

export type RewardBrackets = {
  __typename?: 'RewardBrackets';
  is_minimum_value?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  range?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  reward_value?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type Rider = {
  __typename?: 'Rider';
  country: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  profilePicture?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RiderAuth = {
  __typename?: 'RiderAuth';
  rider: Rider;
  token: Scalars['String']['output'];
};

export type RiderFilter = {
  country?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  firstName?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  lastName?: InputMaybe<StringOperator>;
  phoneNumber?: InputMaybe<StringOperator>;
};

export type RiderInput = {
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  profilePicture?: InputMaybe<Scalars['String']['input']>;
};

export type RiderIssueReport = {
  __typename?: 'RiderIssueReport';
  assignment_id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue_type: Scalars['String']['output'];
  order?: Maybe<Order>;
  order_id: Scalars['ID']['output'];
  rider?: Maybe<Rider>;
  rider_id: Scalars['ID']['output'];
  status: RiderIssueStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type RiderIssueReportFilter = {
  issue_type?: InputMaybe<StringOperator>;
  order_id?: InputMaybe<IdOperator>;
  rider_id?: InputMaybe<IdOperator>;
  status?: InputMaybe<StringOperator>;
};

export type RiderIssueReportInput = {
  description: Scalars['String']['input'];
  issue_type: Scalars['String']['input'];
  order_id: Scalars['ID']['input'];
};

export enum RiderIssueStatus {
  Dismissed = 'DISMISSED',
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type RoleCount = {
  __typename?: 'RoleCount';
  count: Scalars['Int']['output'];
  role: Scalars['String']['output'];
};

export type Root = {
  __typename?: 'Root';
  name: Scalars['String']['output'];
};

export type RotatePspCredentialInput = {
  id: Scalars['ID']['input'];
  secret_key: Scalars['String']['input'];
  webhook_secret?: InputMaybe<Scalars['String']['input']>;
};

export enum Service_Agreement_Terms {
  Commission = 'COMMISSION',
  Custom = 'CUSTOM',
  FixedFee = 'FIXED_FEE',
  Markup = 'MARKUP'
}

export enum Service_Agreement_Terms_Unit {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Sales = {
  __typename?: 'Sales';
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order_date?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['ID']['output']>;
  order_value: Scalars['Int']['output'];
  payment_reference?: Maybe<Scalars['ID']['output']>;
  product_cost: Scalars['Int']['output'];
  product_price?: Maybe<Scalars['Float']['output']>;
  profit_added: Scalars['Int']['output'];
  reseller_id?: Maybe<Scalars['ID']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type SalesFilter = {
  country?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<StringOperator>;
  currency?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  order_date?: InputMaybe<StringOperator>;
  order_id?: InputMaybe<IdOperator>;
  order_value?: InputMaybe<NumberOperator>;
  payment_reference?: InputMaybe<IdOperator>;
  product_cost?: InputMaybe<NumberOperator>;
  product_price?: InputMaybe<NumberOperator>;
  profit_added?: InputMaybe<NumberOperator>;
  reseller_id?: InputMaybe<IdOperator>;
  sku?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  updated_at?: InputMaybe<StringOperator>;
};

export type SelectOption = {
  __typename?: 'SelectOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SelectOptionInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SetSupplierPickupLocationInput = {
  location_id: Scalars['String']['input'];
  supplier_id: Scalars['String']['input'];
};

export type SetSupplierProductMarkupInput = {
  markup_amount: Scalars['Float']['input'];
  markup_value: Scalars['Float']['input'];
  personnel?: InputMaybe<Scalars['String']['input']>;
  product_id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  supplier_agreement: SupplierAgreement;
  supplier_id: Scalars['ID']['input'];
};

export enum Settlement {
  Commission = 'Commission',
  Markup = 'Markup'
}

export type SharedProduct = {
  __typename?: 'SharedProduct';
  created_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  long_url: Scalars['String']['output'];
  number_of_times_sold: Scalars['Int']['output'];
  product?: Maybe<Product>;
  product_cost_price: Scalars['Float']['output'];
  product_id: Scalars['ID']['output'];
  profit_added_by_reseller: Scalars['Float']['output'];
  reseller?: Maybe<User>;
  self_checkout_link?: Maybe<Scalars['String']['output']>;
  shared_by: Scalars['ID']['output'];
  short_url: Scalars['String']['output'];
  total_accumulated_profit: Scalars['Float']['output'];
  total_accumulated_sales: Scalars['Float']['output'];
  total_selling_price: Scalars['Float']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type SharedProductFilter = {
  id?: InputMaybe<IdOperator>;
  long_url?: InputMaybe<StringOperator>;
  number_of_times_sold?: InputMaybe<NumberOperator>;
  product_cost_price?: InputMaybe<NumberOperator>;
  product_id?: InputMaybe<IdOperator>;
  profit_added_by_reseller?: InputMaybe<NumberOperator>;
  shared_by?: InputMaybe<IdOperator>;
  short_url?: InputMaybe<StringOperator>;
  total_accumulated_profit?: InputMaybe<NumberOperator>;
  total_accumulated_sales?: InputMaybe<NumberOperator>;
  total_selling_price?: InputMaybe<NumberOperator>;
};

export type ShipmentItem = {
  __typename?: 'ShipmentItem';
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
};

export type ShipmentItemItem = {
  price: Scalars['Float']['input'];
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type Shop = {
  __typename?: 'Shop';
  avatar?: Maybe<Scalars['String']['output']>;
  /** The public-facing contact email address for the shop. Customers will use this email to communicate with the shop owner. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryCode>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The three letter code for the shop's currency. */
  currency?: Maybe<CurrencyCode>;
  /** Domain(s) the user has linked to their soko.world domain */
  customDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deliveryAgent?: Maybe<DeliveryAgent>;
  deliveryOption?: Maybe<DeliveryOption>;
  /** The shop's meta description used in search engine results. */
  description?: Maybe<Scalars['String']['output']>;
  /** The shop owner's email address. Tendo will use this email address to communicate with the shop owner. */
  email?: Maybe<Scalars['String']['output']>;
  /** Indicates whether shop has undergone onboarding and setup */
  hasBeenSetup?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Indicates whether shop is still receiving traffic. Use case: freeing up .tendo.com domain for other users. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  locations?: Maybe<Array<Maybe<ShopLocationModel>>>;
  /** Full name of the shop */
  name?: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['ID']['output'];
  paymentOptions?: Maybe<Array<PaymentOption>>;
  phone?: Maybe<Scalars['String']['output']>;
  /** The primary domain of the shop's online store. */
  primaryDomain?: Maybe<Scalars['String']['output']>;
  shopId?: Maybe<Scalars['ID']['output']>;
  /** Tags associated with shop to aid shop SEO */
  shopTags?: Maybe<Array<Scalars['String']['output']>>;
  shopType?: Maybe<ShopType>;
  shortUrl?: Maybe<Scalars['String']['output']>;
  /** auto-generated slug. Not to be sent as input payload */
  slug?: Maybe<Scalars['String']['output']>;
  /** The shop's .tendo.com domain name */
  sokoWorldDomain?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['ID']['output']>;
  tenantId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Alias for primary domain */
  url?: Maybe<Scalars['String']['output']>;
};

export type ShopCollection = {
  __typename?: 'ShopCollection';
  banner: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type ShopCollectionFilter = {
  id?: InputMaybe<IdOperator>;
  shop_id?: InputMaybe<IdOperator>;
  tenant_id?: InputMaybe<StringOperator>;
};

export type ShopCollectionInput = {
  banner: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  shop_id: Scalars['ID']['input'];
};

export type ShopCollectionProductFilter = {
  collection_id?: InputMaybe<IdOperator>;
};

export type ShopCollectionProductsFilter = {
  collection_id?: InputMaybe<IdOperator>;
};

export type ShopFilter = {
  avatar?: InputMaybe<StringOperator>;
  contactEmail?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  coverImage?: InputMaybe<StringOperator>;
  createdAt?: InputMaybe<DateOperator>;
  currency?: InputMaybe<StringOperator>;
  deliveryAgent?: InputMaybe<StringOperator>;
  deliveryOption?: InputMaybe<StringOperator>;
  description?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  hasBeenSetup?: InputMaybe<BooleanOperator>;
  id?: InputMaybe<IdOperator>;
  isActive?: InputMaybe<BooleanOperator>;
  name?: InputMaybe<StringOperator>;
  ownerId?: InputMaybe<StringOperator>;
  phone?: InputMaybe<StringOperator>;
  primaryDomain?: InputMaybe<StringOperator>;
  shopType?: InputMaybe<StringOperator>;
  shortUrl?: InputMaybe<StringOperator>;
  slug?: InputMaybe<StringOperator>;
  sokoWorldDomain?: InputMaybe<StringOperator>;
  tenantId?: InputMaybe<StringOperator>;
  updatedAt?: InputMaybe<DateOperator>;
  url?: InputMaybe<StringOperator>;
};

export type ShopLocationModel = {
  __typename?: 'ShopLocationModel';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lat: Scalars['Float']['output'];
  long: Scalars['Float']['output'];
  shop: Shop;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ShopLocationRequestDto = {
  lat: Scalars['Float']['input'];
  long: Scalars['Float']['input'];
};

export type ShopPaymentMethod = {
  __typename?: 'ShopPaymentMethod';
  created_at?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  secure_code?: Maybe<Scalars['String']['output']>;
  shopify_id?: Maybe<Scalars['ID']['output']>;
  supplier_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type ShopProductFilter = {
  shop_id?: InputMaybe<IdOperator>;
};

export type ShopProductsFilter = {
  catalog?: InputMaybe<CatalogFilter>;
  category?: InputMaybe<ProductCategoryFilter>;
  id?: InputMaybe<IdOperator>;
  price?: InputMaybe<NumberOperator>;
  productType?: InputMaybe<ProductType>;
  product_origin?: InputMaybe<StringOperator>;
  qty?: InputMaybe<NumberOperator>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
  shopCollection?: InputMaybe<ShopCollectionProductFilter>;
  sku?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  tags?: InputMaybe<StringOperator>;
  title?: InputMaybe<StringOperator>;
  uuid?: InputMaybe<StringOperator>;
};

export enum ShopType {
  Reseller = 'reseller',
  Supplier = 'supplier'
}

export type ShopifyCustomer = {
  address?: InputMaybe<AddressInput>;
  email: Scalars['String']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ShopifyImage = {
  __typename?: 'ShopifyImage';
  created_at?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  product_id?: Maybe<Scalars['ID']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  variant_ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ShopifyLoadedProduct = {
  __typename?: 'ShopifyLoadedProduct';
  body_html?: Maybe<Scalars['String']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  images?: Maybe<Array<Maybe<ShopifyImage>>>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ShopifyOrderProductInput = {
  cost_price?: InputMaybe<Scalars['Float']['input']>;
  price: Scalars['Float']['input'];
  product_id: Scalars['ID']['input'];
  qty: Scalars['Int']['input'];
};

export type ShopifyResellingProducts = {
  __typename?: 'ShopifyResellingProducts';
  product?: Maybe<Scalars['ID']['output']>;
  reseller_shop?: Maybe<Scalars['ID']['output']>;
  supplier_shop?: Maybe<Scalars['ID']['output']>;
};

export type ShopifyShop = {
  __typename?: 'ShopifyShop';
  country_code?: Maybe<Scalars['String']['output']>;
  country_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  products?: Maybe<Array<Maybe<SyncShopifyProduct>>>;
  redirect_url?: Maybe<Scalars['String']['output']>;
  shop: Scalars['String']['output'];
  shop_currency?: Maybe<Scalars['String']['output']>;
  shop_payment_method?: Maybe<ShopPaymentMethod>;
  shop_reselling_products?: Maybe<Array<Maybe<ShopifyResellingProducts>>>;
  supplier_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type ShopifyShopFilter = {
  id?: InputMaybe<IdOperator>;
  shop?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
};

export type ShopifySupplierOrderCreateInput = {
  customer: ShopifyCustomer;
  customer_paid: Scalars['Boolean']['input'];
  payment_id?: InputMaybe<Scalars['String']['input']>;
  products: Array<ShopifyOrderProductInput>;
  reseller: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  supplier_id: Scalars['ID']['input'];
  total_amount: Scalars['Float']['input'];
};

export enum SocialPlatform {
  Apple = 'Apple',
  Facebook = 'Facebook',
  Google = 'Google',
  Twitter = 'Twitter'
}

export type SokoWorldDomainExistsRequestDto = {
  /** format should be [domain].com, eg.www.mysoko.shop. Omit http:// or https:// */
  sokoWorldDomain?: InputMaybe<Scalars['String']['input']>;
};

export type SokoWorldDomainExistsResponseDto = {
  __typename?: 'SokoWorldDomainExistsResponseDto';
  domainExists?: Maybe<Scalars['Boolean']['output']>;
};

export enum SortOrder {
  Ascending = 'ascending',
  Descending = 'descending'
}

export enum Status {
  Failed = 'failed',
  Pending = 'pending',
  Success = 'success'
}

export type StatusOperator = {
  eq?: InputMaybe<Status>;
  in?: InputMaybe<Array<Status>>;
  notIn?: InputMaybe<Array<Status>>;
};

export type StatusTransitionValidation = {
  __typename?: 'StatusTransitionValidation';
  reason?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type StockAvailability = {
  __typename?: 'StockAvailability';
  isAvailable: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
};

export type StockAvailabilityInput = {
  qty: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type StorefrontCart = {
  __typename?: 'StorefrontCart';
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<StorefrontCartCustomer>;
  customer_id?: Maybe<Scalars['ID']['output']>;
  delivery?: Maybe<StorefrontCartDelivery>;
  id: Scalars['ID']['output'];
  identity?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<StorefrontCartItem>>>;
  payment?: Maybe<StorefrontCartPayment>;
  shop_id: Scalars['ID']['output'];
  status?: Maybe<StorefrontCartStatusType>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type StorefrontCartCustomer = {
  __typename?: 'StorefrontCartCustomer';
  address_id?: Maybe<Scalars['ID']['output']>;
  customer_id?: Maybe<Scalars['ID']['output']>;
};

export type StorefrontCartCustomerInput = {
  address_id?: InputMaybe<Scalars['ID']['input']>;
  customer_id?: InputMaybe<Scalars['ID']['input']>;
};

export type StorefrontCartDelivery = {
  __typename?: 'StorefrontCartDelivery';
  delivery_amount?: Maybe<Scalars['Float']['output']>;
  delivery_id?: Maybe<Scalars['ID']['output']>;
  delivery_type?: Maybe<Scalars['String']['output']>;
  instantDelivery?: Maybe<Scalars['Boolean']['output']>;
};

export type StorefrontCartDeliveryInput = {
  delivery_amount?: InputMaybe<Scalars['Float']['input']>;
  delivery_id?: InputMaybe<Scalars['ID']['input']>;
  delivery_type?: InputMaybe<Scalars['String']['input']>;
  instantDelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StorefrontCartFilter = {
  customer_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  identity?: InputMaybe<StringOperator>;
  shop_id?: InputMaybe<IdOperator>;
  status?: InputMaybe<StringOperator>;
};

export type StorefrontCartItem = {
  __typename?: 'StorefrontCartItem';
  avatar?: Maybe<Scalars['String']['output']>;
  cart_id: Scalars['ID']['output'];
  created_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  product_id: Scalars['ID']['output'];
  product_price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  reseller_profit?: Maybe<Scalars['Float']['output']>;
  sku: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type StorefrontCartItemInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  cart_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  price: Scalars['Float']['input'];
  product_id: Scalars['ID']['input'];
  product_price: Scalars['Float']['input'];
  quantity: Scalars['Int']['input'];
  reseller_profit?: InputMaybe<Scalars['Float']['input']>;
  sku: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type StorefrontCartPayment = {
  __typename?: 'StorefrontCartPayment';
  amount?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  invoice?: Maybe<Scalars['String']['output']>;
  payment_id: Scalars['String']['output'];
  payment_status?: Maybe<Scalars['String']['output']>;
  payment_type?: Maybe<Scalars['String']['output']>;
};

export type StorefrontCartPaymentInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<Scalars['String']['input']>;
  payment_id: Scalars['String']['input'];
  payment_status?: InputMaybe<Scalars['String']['input']>;
  payment_type?: InputMaybe<Scalars['String']['input']>;
};

export enum StorefrontCartStatusType {
  Abandoned = 'ABANDONED',
  Active = 'ACTIVE',
  Completed = 'COMPLETED'
}

export type StorefrontCartsReturnType = {
  __typename?: 'StorefrontCartsReturnType';
  carts?: Maybe<Array<Maybe<StorefrontCart>>>;
  count?: Maybe<Scalars['Int']['output']>;
};

export type StorefrontTransactionFilter = {
  created_at?: InputMaybe<DateOperator>;
  currency?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  reference?: InputMaybe<StringOperator>;
  type?: InputMaybe<TransactionTypeOperator>;
};

export type StringOperator = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type StripeAccountSessionInput = {
  business_data?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};

export type SubProductId = {
  __typename?: 'SubProductId';
  US?: Maybe<Scalars['Int']['output']>;
};

export type SubmitChargeOtpInput = {
  otp: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  annual_plan_cost: Scalars['Float']['output'];
  created_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  monthly_plan_cost: Scalars['Float']['output'];
  name: SubscriptionType;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type SubscriptionInput = {
  annual_plan_cost: Scalars['Float']['input'];
  created_at?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  monthly_plan_cost: Scalars['Float']['input'];
  name: SubscriptionType;
  updated_at?: InputMaybe<Scalars['Date']['input']>;
};

export enum SubscriptionStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Expired = 'expired',
  Initialised = 'initialised'
}

export enum SubscriptionTier {
  Enterprise = 'ENTERPRISE',
  Free = 'FREE',
  Growth = 'GROWTH',
  Pro = 'PRO',
  Starter = 'STARTER'
}

export enum SubscriptionType {
  Basic = 'basic',
  Enterprise = 'enterprise',
  Pro = 'pro'
}

export type Supplier = {
  __typename?: 'Supplier';
  agreement_terms?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  business_details?: Maybe<SupplierBusiness>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  device_token?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  generic_name?: Maybe<Scalars['String']['output']>;
  has_accepted_terms: Scalars['Boolean']['output'];
  has_verified_email: Scalars['Boolean']['output'];
  has_verified_phonenumber: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  payment_details?: Maybe<SupplierPaymentDetails>;
  permissions: Array<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  setupConfig?: Maybe<SupplierSetupConfig>;
  setup_complete: Scalars['Boolean']['output'];
  shop?: Maybe<Shop>;
  social_platform?: Maybe<Scalars['String']['output']>;
  social_platform_token?: Maybe<Scalars['String']['output']>;
  supplier_type: SupplierType;
};

export type SupplierAccountHistory = {
  __typename?: 'SupplierAccountHistory';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  supplier_id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SupplierAddDeviceTokenInput = {
  deviceToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export enum SupplierAgreement {
  Commission = 'COMMISSION',
  Markup = 'MARKUP'
}

export enum SupplierAgreementTerms {
  Commission = 'COMMISSION',
  Markup = 'MARKUP'
}

export type SupplierAuthPayload = {
  __typename?: 'SupplierAuthPayload';
  supplier?: Maybe<Supplier>;
  token?: Maybe<Scalars['String']['output']>;
};

export type SupplierBusiness = {
  __typename?: 'SupplierBusiness';
  business_address?: Maybe<Scalars['String']['output']>;
  business_name?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  delivery_option?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<SupplierBusinessDocument>>>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  registered?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  supplier_business_verified?: Maybe<Scalars['Boolean']['output']>;
  supplier_id?: Maybe<Scalars['ID']['output']>;
};

export type SupplierBusinessDocument = {
  __typename?: 'SupplierBusinessDocument';
  business_id?: Maybe<Scalars['ID']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  document_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SupplierBusinessInput = {
  business_address?: InputMaybe<Scalars['String']['input']>;
  business_name: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  delivery_option?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  industry: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  postal_code?: InputMaybe<Scalars['String']['input']>;
  referred_by?: InputMaybe<Scalars['String']['input']>;
  registered: Scalars['Boolean']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  supplier_id: Scalars['ID']['input'];
};

export type SupplierCheckList = {
  __typename?: 'SupplierCheckList';
  supplier_id: Scalars['ID']['output'];
};

export type SupplierCreationResponse = {
  __typename?: 'SupplierCreationResponse';
  created: Scalars['Boolean']['output'];
  verification_token?: Maybe<Scalars['String']['output']>;
};

export type SupplierEmailChangeInput = {
  id: Scalars['ID']['input'];
  newEmail: Scalars['String']['input'];
};

export type SupplierFilter = {
  country?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  has_accepted_terms?: InputMaybe<BooleanOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  phone?: InputMaybe<StringOperator>;
  supplier_type?: InputMaybe<SupplierType>;
};

export type SupplierInput = {
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  onboardingType?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  supplier_type?: InputMaybe<SupplierType>;
};

export type SupplierLocation = {
  __typename?: 'SupplierLocation';
  address: Scalars['String']['output'];
  address_ext?: Maybe<Scalars['String']['output']>;
  business_id: Scalars['ID']['output'];
  city: Scalars['String']['output'];
  created_at?: Maybe<Scalars['Date']['output']>;
  deleted_at?: Maybe<Scalars['Date']['output']>;
  gmap_data: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  lat: Scalars['String']['output'];
  lng: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  postal_code: Scalars['String']['output'];
  state: Scalars['String']['output'];
  state_code: Scalars['String']['output'];
  supplier_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type SupplierLocationFilter = {
  business_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
};

export type SupplierPasswordChangeInput = {
  id: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type SupplierPasswordResetInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type SupplierPasswordResetMailInput = {
  email: Scalars['String']['input'];
};

export type SupplierPaymentDetails = {
  __typename?: 'SupplierPaymentDetails';
  account_name?: Maybe<Scalars['String']['output']>;
  account_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  supplier_id?: Maybe<Scalars['ID']['output']>;
};

export type SupplierProductFilter = {
  category?: InputMaybe<ProductCategoryFilter>;
  combination_string?: InputMaybe<StringOperator>;
  contractor?: InputMaybe<IdOperator>;
  country?: InputMaybe<StringOperator>;
  distributionChannels?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  main_stock?: InputMaybe<NumberOperator>;
  partner?: InputMaybe<IdOperator>;
  price?: InputMaybe<NumberOperator>;
  productType?: InputMaybe<ProductType>;
  product_origin?: InputMaybe<StringOperator>;
  published?: InputMaybe<BooleanOperator>;
  qty?: InputMaybe<NumberOperator>;
  resell?: InputMaybe<BooleanOperator>;
  reseller_id?: InputMaybe<IdOperator>;
  sku?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  tags?: InputMaybe<StringOperator>;
  title?: InputMaybe<StringOperator>;
  transit_stock?: InputMaybe<NumberOperator>;
  verified?: InputMaybe<BooleanOperator>;
};

export type SupplierProfileUpdateInput = {
  id: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SupplierSetupConfig = {
  __typename?: 'SupplierSetupConfig';
  hasCategories: Scalars['Boolean']['output'];
  hasPaymentMethod: Scalars['Boolean']['output'];
  hasProducts: Scalars['Boolean']['output'];
  hasTerms: Scalars['Boolean']['output'];
  supplier_id: Scalars['ID']['output'];
};

export type SupplierStats = {
  __typename?: 'SupplierStats';
  supplier_id: Scalars['ID']['output'];
  total_active_orders: Scalars['Int']['output'];
  total_customers: Scalars['Int']['output'];
  total_finished_orders: Scalars['Int']['output'];
  total_orders: Scalars['Int']['output'];
  total_products: Scalars['Int']['output'];
  total_products_in_stock: Scalars['Int']['output'];
  total_products_in_transit: Scalars['Int']['output'];
  total_products_out_of_stock: Scalars['Int']['output'];
  total_resellers: Scalars['Int']['output'];
  total_unverified_products: Scalars['Int']['output'];
  total_verified_products: Scalars['Int']['output'];
};

export enum SupplierType {
  Advanced = 'ADVANCED',
  Basic = 'BASIC'
}

export type SupportedCurrenciesResponseDto = {
  __typename?: 'SupportedCurrenciesResponseDTO';
  country: Scalars['String']['output'];
  currencies: Array<Maybe<SupportedCurrency>>;
};

export type SupportedCurrency = {
  __typename?: 'SupportedCurrency';
  code: Scalars['String']['output'];
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: CurrencyType;
};

export type SupportedCurrencyFilter = {
  country?: InputMaybe<CountryCode>;
  type?: InputMaybe<CurrencyType>;
};

export type SyncShopifyProduct = {
  __typename?: 'SyncShopifyProduct';
  body_html?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['ID']['output']>;
  shop?: Maybe<Scalars['String']['output']>;
  shopify_id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  variants?: Maybe<Array<Maybe<SyncedProductVariants>>>;
};

export type SyncShopifyProductInput = {
  distributionChannel?: InputMaybe<Array<InputMaybe<DistributionChannel>>>;
  integration_id: Scalars['ID']['input'];
  product_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  supplier_country: Scalars['String']['input'];
};

export type SyncedProductVariants = {
  __typename?: 'SyncedProductVariants';
  created_at?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inventory_quantity?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<Scalars['JSONObject']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['String']['output']>;
  shopify_product_id?: Maybe<Scalars['Int']['output']>;
  shopify_variant_id?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type Team = {
  __typename?: 'Team';
  country: Scalars['String']['output'];
  created_at?: Maybe<Scalars['Date']['output']>;
  credential?: Maybe<TeamCredential>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<Maybe<Member>>>;
  name: Scalars['String']['output'];
  service_agreement_terms?: Maybe<Service_Agreement_Terms>;
  service_agreement_terms_value?: Maybe<Scalars['JSONObject']['output']>;
  service_id: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type TeamCredential = {
  __typename?: 'TeamCredential';
  created_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  scope?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  secret_key: Scalars['String']['output'];
  team_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type TeamServiceAgreementTermsValue = {
  __typename?: 'TeamServiceAgreementTermsValue';
  id: Scalars['ID']['output'];
  team_id: Scalars['ID']['output'];
  terms: Service_Agreement_Terms;
  terms_value: Scalars['JSONObject']['output'];
};

export type TeamServiceAgreementTermsValueInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  unit: Service_Agreement_Terms_Unit;
  value: Scalars['Float']['input'];
};

export type TempCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  shop_id: Scalars['ID']['input'];
};

export type Template = {
  __typename?: 'Template';
  dependsOn?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  options?: Maybe<Array<SelectOption>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type: TemplateType;
};

export type TemplateFilter = {
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
};

export type TemplateInput = {
  dependsOn?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  options?: InputMaybe<Array<SelectOptionInput>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type: TemplateType;
};

export enum TemplateType {
  Alert = 'ALERT',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Email = 'EMAIL',
  File = 'FILE',
  Number = 'NUMBER',
  Password = 'PASSWORD',
  Radio = 'RADIO',
  Richtext = 'RICHTEXT',
  Select = 'SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA'
}

export type TenantContext = {
  __typename?: 'TenantContext';
  permissions: Array<Scalars['String']['output']>;
  scope: TenantScope;
  tenant?: Maybe<TenantInfo>;
};

export type TenantError = {
  __typename?: 'TenantError';
  code: Scalars['String']['output'];
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type TenantFeatureStatus = {
  __typename?: 'TenantFeatureStatus';
  config?: Maybe<Scalars['JSONObject']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  enabled: Scalars['Boolean']['output'];
  enabledAt?: Maybe<Scalars['DateTime']['output']>;
  feature: FeatureModule;
  hasAccess: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type TenantFeatureSummary = {
  __typename?: 'TenantFeatureSummary';
  available: Array<FeatureModule>;
  enabled: Array<FeatureModule>;
  enabledCount: Scalars['Int']['output'];
  restricted: Array<FeatureModule>;
  tier: SubscriptionTier;
  totalFeatures: Scalars['Int']['output'];
  type: TenantType;
};

export type TenantInfo = {
  __typename?: 'TenantInfo';
  createdAt: Scalars['DateTime']['output'];
  customDomain?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TenantOperationResult = {
  __typename?: 'TenantOperationResult';
  data?: Maybe<Scalars['JSONObject']['output']>;
  errors?: Maybe<Array<TenantError>>;
  success: Scalars['Boolean']['output'];
};

export type TenantProductInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stock?: InputMaybe<Scalars['Int']['input']>;
  variations?: InputMaybe<Array<ProductVariationInput>>;
};

export type TenantResource = {
  createdAt: Scalars['DateTime']['output'];
  tenantId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum TenantScope {
  Customer = 'CUSTOMER',
  Organization = 'ORGANIZATION',
  Public = 'PUBLIC'
}

export enum TenantType {
  Distributor = 'DISTRIBUTOR',
  Marketplace = 'MARKETPLACE',
  Organization = 'ORGANIZATION',
  Restaurant = 'RESTAURANT',
  Retail = 'RETAIL',
  TendoInternal = 'TENDO_INTERNAL'
}

export type TenantUpgradeResult = {
  __typename?: 'TenantUpgradeResult';
  message?: Maybe<Scalars['String']['output']>;
  newFeatures: Array<FeatureModule>;
  removedFeatures: Array<FeatureModule>;
  success: Scalars['Boolean']['output'];
  tier: SubscriptionTier;
};

export type TendoLeaderBoard = {
  __typename?: 'TendoLeaderBoard';
  country: CountryCode;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rewardsConfig?: Maybe<LeaderBoardConfig>;
  status: TendoLeaderBoardStatus;
  updatedAt: Scalars['String']['output'];
};

export type TendoLeaderBoardFilter = {
  country?: InputMaybe<CountryCode>;
  endDateAfter?: InputMaybe<DateOperator>;
  endDateBefore?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
  isActive?: InputMaybe<BooleanOperator>;
  startDateAfter?: InputMaybe<DateOperator>;
  startDateBefore?: InputMaybe<DateOperator>;
};

export type TendoLeaderBoardPosition = {
  __typename?: 'TendoLeaderBoardPosition';
  leaderBoardId: Scalars['ID']['output'];
  points: Scalars['Int']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
};

export enum TendoLeaderBoardStatus {
  Closed = 'CLOSED',
  Running = 'RUNNING',
  Upcoming = 'UPCOMING'
}

export type TermInput = {
  ShippingLocations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cancellationPolicy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedDeliveryTime?: InputMaybe<Scalars['Int']['input']>;
  estimatedDeliveryTimeUnit?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  returnPeriod?: InputMaybe<Scalars['Int']['input']>;
  returnPolicy?: InputMaybe<Scalars['String']['input']>;
  settlementCurrency?: InputMaybe<Scalars['String']['input']>;
  settlementPeriod?: InputMaybe<Scalars['Int']['input']>;
  settlementType: Settlement;
  settlementValue: Scalars['Float']['input'];
  shipTo?: InputMaybe<Scalars['String']['input']>;
  shippingPolicy?: InputMaybe<Scalars['String']['input']>;
  supplier_id: Scalars['ID']['input'];
};

export type Terms = {
  __typename?: 'Terms';
  cancellationPolicy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryTime?: Maybe<Scalars['Int']['output']>;
  estimatedDeliveryTimeUnit?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  returnPeriod?: Maybe<Scalars['Int']['output']>;
  returnPolicy?: Maybe<Scalars['String']['output']>;
  settlementCurrency?: Maybe<Scalars['String']['output']>;
  settlementPeriod?: Maybe<Scalars['Int']['output']>;
  settlementType: Settlement;
  settlementValue: Scalars['Float']['output'];
  shipTo?: Maybe<Scalars['String']['output']>;
  shippingLocations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shippingPolicy?: Maybe<Scalars['String']['output']>;
};

export type TermsFilter = {
  description?: InputMaybe<StringOperator>;
  estimatedDeliveryTime?: InputMaybe<NumberOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  returnPeriod?: InputMaybe<NumberOperator>;
  settlementCurrency?: InputMaybe<StringOperator>;
  settlementPeriod?: InputMaybe<NumberOperator>;
  settlementType?: InputMaybe<Settlement>;
  shipTo?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
};

export type TopDealBanner = {
  __typename?: 'TopDealBanner';
  id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type TopProduct = {
  __typename?: 'TopProduct';
  numberOfTimesOrdered?: Maybe<Scalars['Float']['output']>;
  orderValue?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Product>;
  productSKU: Scalars['String']['output'];
  totalQuantityOrdered?: Maybe<Scalars['Float']['output']>;
};

export type TopProductsOrderFilter = {
  cart_number?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<DateOperator>;
  customer_address_id?: InputMaybe<NumberOperator>;
  customer_id?: InputMaybe<NumberOperator>;
  delivery_id?: InputMaybe<NumberOperator>;
  delivery_instructions?: InputMaybe<StringOperator>;
  delivery_type?: InputMaybe<StringOperator>;
  discount?: InputMaybe<NumberOperator>;
  free_delivery?: InputMaybe<BooleanOperator>;
  id?: InputMaybe<IdOperator>;
  order_total?: InputMaybe<NumberOperator>;
  payment_id?: InputMaybe<StringOperator>;
  payment_method?: InputMaybe<StringOperator>;
  payment_status?: InputMaybe<StringOperator>;
  source?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<NumberOperator>;
  updated_at?: InputMaybe<DateOperator>;
  user_id?: InputMaybe<NumberOperator>;
};

export type TopProductsRequestDto = {
  /** The top (x) number of products to fetch */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Additional filters for orders */
  orderFilter?: InputMaybe<TopProductsOrderFilter>;
  /** Additional filters for order products */
  productFilter?: InputMaybe<OrderProductFilter>;
};

export type TopProductsResponseDto = {
  __typename?: 'TopProductsResponseDto';
  products?: Maybe<Array<Maybe<TopProduct>>>;
  totalOrderValue?: Maybe<Scalars['Float']['output']>;
};

export type TopReseller = {
  __typename?: 'TopReseller';
  highest_amount: Scalars['Float']['output'];
  order_count: Scalars['Int']['output'];
  reseller?: Maybe<User>;
  total_amount: Scalars['Float']['output'];
  user_id: Scalars['ID']['output'];
  week?: Maybe<Scalars['String']['output']>;
};

export type TopTenant = {
  __typename?: 'TopTenant';
  apiRequests: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  plan: Scalars['String']['output'];
  revenue: Scalars['String']['output'];
  userCount: Scalars['Int']['output'];
};

export type Transaction = {
  __typename?: 'Transaction';
  amount: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  direction: TransactionDirection;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  reference: Scalars['String']['output'];
  status: TransactionStatus;
  type: TransactionType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  wallet_id: Scalars['ID']['output'];
};

export enum TransactionDirection {
  Inbound = 'inbound',
  Outbound = 'outbound'
}

export type TransactionDirectionOperator = {
  eq?: InputMaybe<TransactionDirection>;
  in?: InputMaybe<Array<TransactionDirection>>;
  notIn?: InputMaybe<Array<TransactionDirection>>;
};

export type TransactionFilter = {
  created_at?: InputMaybe<DateOperator>;
  currency?: InputMaybe<StringOperator>;
  direction?: InputMaybe<TransactionDirectionOperator>;
  id?: InputMaybe<IdOperator>;
  merchant_id?: InputMaybe<IdOperator>;
  reference?: InputMaybe<StringOperator>;
  type?: InputMaybe<TransactionTypeOperator>;
  wallet_id?: InputMaybe<IdOperator>;
  wallet_type?: InputMaybe<WalletTypeOperator>;
};

export enum TransactionStatus {
  Failed = 'failed',
  Pending = 'pending',
  Success = 'success'
}

export enum TransactionType {
  Charge = 'charge',
  Conversion = 'conversion',
  Deposit = 'deposit',
  OrderPurchase = 'order_purchase',
  ProfitPayout = 'profit_payout',
  Refund = 'refund',
  Transfer = 'transfer',
  Withdrawal = 'withdrawal'
}

export type TransactionTypeOperator = {
  eq?: InputMaybe<TransactionType>;
  in?: InputMaybe<Array<TransactionType>>;
  notIn?: InputMaybe<Array<TransactionType>>;
};

export type TransferInventoryInput = {
  from_location_id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  reference_id?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  to_location_id: Scalars['ID']['input'];
};

export enum TransferType {
  International = 'international',
  Local = 'local'
}

export type TransferTypeOperator = {
  eq?: InputMaybe<TransferType>;
  in?: InputMaybe<Array<TransferType>>;
  notIn?: InputMaybe<Array<TransferType>>;
};

export type TrendingProductsFilter = {
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
};

export type TypeCount = {
  __typename?: 'TypeCount';
  count: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type UnshareProductRequestDto = {
  product_id: Scalars['ID']['input'];
  shared_by: Scalars['ID']['input'];
};

/** Input for updating an API key */
export type UpdateApiKeyInput = {
  /** Enable or disable the key */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated expiration in seconds from now */
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the API key to update */
  keyId: Scalars['ID']['input'];
  /** Updated metadata */
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Updated display name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated permissions */
  permissions?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Enable or disable rate limiting */
  rateLimitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated rate limit max */
  rateLimitMax?: InputMaybe<Scalars['Int']['input']>;
  /** Updated rate limit window */
  rateLimitTimeWindow?: InputMaybe<Scalars['Int']['input']>;
  /** Updated refill amount */
  refillAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Updated refill interval */
  refillInterval?: InputMaybe<Scalars['Int']['input']>;
  /** Updated remaining count */
  remaining?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCampaignInput = {
  campaignImageUrl?: InputMaybe<Scalars['String']['input']>;
  conditions: Array<CampaginConditionInput>;
  couponCode: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  title: Scalars['String']['input'];
};

export type UpdateCartItemInput = {
  cart_item_id: Scalars['ID']['input'];
  profit?: InputMaybe<Scalars['Float']['input']>;
  profit_type?: InputMaybe<ProfitType>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['ID']['input'];
};

export type UpdateDiscountData = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<UserType>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiry_date?: InputMaybe<Scalars['String']['input']>;
  fixed_amount_allocation?: InputMaybe<FixedAmountAllocation>;
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  redemptions_limit?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DiscountType>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  valid_country?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDiscountProductConditionRequestDto = {
  condition?: InputMaybe<ProductCondition>;
  id: Scalars['ID']['input'];
  product_sku?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInventoryLocationInput = {
  address?: InputMaybe<Scalars['Any']['input']>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_location_id?: InputMaybe<Scalars['ID']['input']>;
  settings?: InputMaybe<Scalars['Any']['input']>;
  type?: InputMaybe<InventoryLocationType>;
};

export type UpdateOperationCountryInput = {
  country: Scalars['String']['input'];
  country_code?: InputMaybe<CountryCode>;
  currency?: InputMaybe<CurrencyCode>;
  currency_code?: InputMaybe<CurrencyCode>;
  currency_symbol?: InputMaybe<Scalars['String']['input']>;
  iso_code?: InputMaybe<Scalars['String']['input']>;
  phone_code?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  custom_domain?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operation_countries?: InputMaybe<Array<Scalars['ID']['input']>>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tenant_type?: InputMaybe<TenantType>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationPaymentAccountInput = {
  account_address?: InputMaybe<Scalars['JSONObject']['input']>;
  account_code?: InputMaybe<Scalars['String']['input']>;
  account_name?: InputMaybe<Scalars['String']['input']>;
  account_number?: InputMaybe<Scalars['String']['input']>;
  account_provider?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyInput>;
  id: Scalars['ID']['input'];
  payment_type?: InputMaybe<PaymentType>;
  transfer_type?: InputMaybe<TransferType>;
};

export type UpdatePluginRequestDto = {
  banner_image?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  developer?: InputMaybe<Scalars['String']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProductCategoriesInput = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  personnel?: InputMaybe<Scalars['String']['input']>;
  product_id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductDistributionInput = {
  cost_price?: InputMaybe<Scalars['Float']['input']>;
  distributionChannels: Array<Scalars['String']['input']>;
  personnel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  product_id: Scalars['ID']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductStatus>;
  supplier_cost?: InputMaybe<Scalars['Float']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProductStatusInput = {
  personnel?: InputMaybe<Scalars['String']['input']>;
  product_id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductStatus>;
};

export type UpdateResellerSlugInput = {
  isBrand?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  user_id: Scalars['ID']['input'];
};

export type UpdateShopDetailsRequestDto = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyCode>;
  customDomains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deliveryAgent?: InputMaybe<DeliveryAgent>;
  deliveryOption?: InputMaybe<DeliveryOption>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<ShopLocationRequestDto>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentOptions?: InputMaybe<Array<InputMaybe<PaymentOption>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  primaryDomain?: InputMaybe<Scalars['String']['input']>;
  shopId: Scalars['ID']['input'];
  shopTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sokoWorldDomain?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateShopDetailsResponseDto = {
  __typename?: 'UpdateShopDetailsResponseDto';
  shopId?: Maybe<Scalars['ID']['output']>;
};

export type UpdateStatusDefinitionInput = {
  allowedTransitions?: InputMaybe<Array<Scalars['String']['input']>>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  statusColor?: InputMaybe<Scalars['String']['input']>;
  statusDescription?: InputMaybe<Scalars['String']['input']>;
  statusIcon?: InputMaybe<Scalars['String']['input']>;
  statusLabel?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStorefrontCartStatusInput = {
  cart_id: Scalars['ID']['input'];
  status: StorefrontCartStatusType;
};

export type UpdateSupplierBusinessContactInput = {
  input: UpdateSupplierBusinessContactInputOption;
  supplier_id: Scalars['ID']['input'];
};

export type UpdateSupplierBusinessContactInputOption = {
  business_address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierBusinessDetailsInput = {
  input: UpdateSupplierBusinessDetailsInputOptions;
  supplier_id: Scalars['ID']['input'];
};

export type UpdateSupplierBusinessDetailsInputOptions = {
  description?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierDetailsData = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierDetailsInput = {
  data?: InputMaybe<UpdateSupplierDetailsData>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSupplierPaymentInput = {
  input: UpdateSupplierPaymentInputOptions;
  supplier_id: Scalars['ID']['input'];
};

export type UpdateSupplierPaymentInputOptions = {
  account_name: Scalars['String']['input'];
  account_number: Scalars['String']['input'];
  method: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  stripe_account_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierSlugInput = {
  slug: Scalars['String']['input'];
  supplier_id: Scalars['ID']['input'];
};

export type UpdateTenantTierInput = {
  tenantId: Scalars['ID']['input'];
  tier: SubscriptionTier;
};

export type UpdateUserAccountSecurityInput = {
  id: Scalars['ID']['input'];
  oldSecurityToken: Scalars['String']['input'];
  securityToken: Scalars['String']['input'];
  securityType: AccountSecurityType;
  user_id: Scalars['ID']['input'];
};

export type UpdateVariationInput = {
  uuid: Scalars['String']['input'];
  variations?: InputMaybe<Array<InputMaybe<ProductCombinationInput>>>;
};

export type User = {
  __typename?: 'User';
  accepted_terms?: Maybe<Scalars['Boolean']['output']>;
  banned?: Maybe<Scalars['Boolean']['output']>;
  banned_by?: Maybe<Scalars['String']['output']>;
  banned_until?: Maybe<Scalars['Date']['output']>;
  country: Scalars['String']['output'];
  created_at?: Maybe<Scalars['Date']['output']>;
  customers?: Maybe<Array<Maybe<UserCustomers>>>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  details?: Maybe<UserDetails>;
  deviceToken?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  facebook_id?: Maybe<Scalars['String']['output']>;
  first_order_created?: Maybe<Scalars['Boolean']['output']>;
  google_id?: Maybe<Scalars['String']['output']>;
  hasReview?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paymentDetails?: Maybe<UserPayment>;
  phone: Scalars['String']['output'];
  shop?: Maybe<Shop>;
  state?: Maybe<Scalars['String']['output']>;
  supplier_shop_id?: Maybe<Scalars['ID']['output']>;
  suspended?: Maybe<Scalars['Boolean']['output']>;
  suspended_at?: Maybe<Scalars['Date']['output']>;
  suspended_by?: Maybe<Scalars['String']['output']>;
  suspended_reason?: Maybe<Scalars['String']['output']>;
  suspended_until?: Maybe<Scalars['Date']['output']>;
  tenant_id?: Maybe<Scalars['String']['output']>;
  twitter_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  user_type?: Maybe<UserAccountType>;
  username: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  verifiedDetails?: Maybe<VerifiedDetails>;
};

export type UserAccountSecurity = {
  __typename?: 'UserAccountSecurity';
  id: Scalars['ID']['output'];
  securityToken: Scalars['String']['output'];
  securityType: AccountSecurityType;
  userType: UserType;
  user_id: Scalars['ID']['output'];
};

export enum UserAccountType {
  Customer = 'CUSTOMER',
  Developer = 'DEVELOPER',
  Manager = 'MANAGER',
  Merchant = 'MERCHANT',
  Reseller = 'RESELLER',
  Supplier = 'SUPPLIER'
}

export type UserCustomers = {
  __typename?: 'UserCustomers';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type UserDetails = {
  __typename?: 'UserDetails';
  dob?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  referred_by?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type UserFilter = {
  country?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  phone?: InputMaybe<StringOperator>;
  referred_by?: InputMaybe<StringOperator>;
  state?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  user_type?: InputMaybe<StringOperator>;
  username?: InputMaybe<StringOperator>;
  verified?: InputMaybe<BooleanOperator>;
};

export type UserGraphData = {
  __typename?: 'UserGraphData';
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type UserNotification = {
  __typename?: 'UserNotification';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  notification?: Maybe<Notification>;
  notification_id: Scalars['ID']['output'];
  read?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user_id: Scalars['ID']['output'];
};

export type UserPayment = {
  __typename?: 'UserPayment';
  account_name?: Maybe<Scalars['String']['output']>;
  account_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UserPaymentType>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type UserPaymentFilter = {
  account_name?: InputMaybe<StringOperator>;
  account_number?: InputMaybe<StringOperator>;
  method?: InputMaybe<StringOperator>;
  provider?: InputMaybe<StringOperator>;
  type?: InputMaybe<UserPaymentType>;
  user_id?: InputMaybe<IdOperator>;
};

export type UserPaymentInput = {
  account_name: Scalars['String']['input'];
  account_number: Scalars['String']['input'];
  method: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  type: UserPaymentType;
  user_id: Scalars['ID']['input'];
};

export enum UserPaymentType {
  Deposit = 'Deposit',
  Withdrawal = 'Withdrawal'
}

export type UserPlugin = {
  __typename?: 'UserPlugin';
  id: Scalars['ID']['output'];
  plugin_id: Scalars['ID']['output'];
  plugin_name?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['ID']['output'];
};

export type UserPluginFilter = {
  id?: InputMaybe<IdOperator>;
  plugin_id?: InputMaybe<IdOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type UserReferralMetrics = {
  __typename?: 'UserReferralMetrics';
  total_referrals: Scalars['Int']['output'];
  total_succesful_referrals: Scalars['Int']['output'];
};

export enum UserRole {
  Admin = 'ADMIN',
  Cashier = 'CASHIER',
  Customer = 'CUSTOMER',
  Finance = 'FINANCE',
  Guest = 'GUEST',
  Manager = 'MANAGER',
  Owner = 'OWNER',
  Reseller = 'RESELLER',
  Rider = 'RIDER',
  Sales = 'SALES',
  SuperAdmin = 'SUPER_ADMIN',
  Supplier = 'SUPPLIER',
  Support = 'SUPPORT',
  Warehouse = 'WAREHOUSE'
}

export type UserStats = {
  __typename?: 'UserStats';
  usersAllTime: Scalars['Int']['output'];
  usersMonth: Scalars['Int']['output'];
  usersToday: Scalars['Int']['output'];
  usersWeek: Scalars['Int']['output'];
  usersYear: Scalars['Int']['output'];
};

export enum UserType {
  Developer = 'DEVELOPER',
  InHouse = 'IN_HOUSE',
  Reseller = 'RESELLER',
  Supplier = 'SUPPLIER'
}

export type UsersCouponInput = {
  cash_rewards?: InputMaybe<Scalars['Float']['input']>;
  code: Scalars['String']['input'];
  duration: CouponDuration;
  duration_value: Scalars['Int']['input'];
  free_deliveries?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueToAll: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  neverEnds: Scalars['Boolean']['input'];
  resellers: Array<Scalars['String']['input']>;
  start_date: Scalars['Date']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type: CouponType;
};

export type Variation = {
  __typename?: 'Variation';
  id?: Maybe<Scalars['ID']['output']>;
  variation_name: Scalars['String']['output'];
  variation_options: Array<Maybe<VariationOption>>;
};

export type VariationFilter = {
  id?: InputMaybe<IdOperator>;
};

export type VariationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  variation_name: Scalars['String']['input'];
  variation_options?: InputMaybe<Array<InputMaybe<VariationOptionInput>>>;
};

export type VariationOption = {
  __typename?: 'VariationOption';
  id?: Maybe<Scalars['ID']['output']>;
  variation_value?: Maybe<Scalars['String']['output']>;
};

export type VariationOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  variation_value?: InputMaybe<Scalars['String']['input']>;
};

export type VerifiedDetails = {
  __typename?: 'VerifiedDetails';
  has_verified_email?: Maybe<Scalars['Boolean']['output']>;
  has_verified_phonenumber?: Maybe<Scalars['Boolean']['output']>;
  setup_complete?: Maybe<Scalars['Boolean']['output']>;
};

export type VerifyAliExpressProductInput = {
  category?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  maximumDeliveryTime?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumDeliveryTime?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  shippingCost?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Result of API key verification */
export type VerifyApiKeyResult = {
  __typename?: 'VerifyApiKeyResult';
  error?: Maybe<ApiKeyError>;
  key?: Maybe<ApiKeyInfo>;
  valid: Scalars['Boolean']['output'];
};

export type VerifyPaymentInput = {
  reference: Scalars['String']['input'];
};

export type VerifyProductInput = {
  id: Scalars['ID']['input'];
  markup_amount?: InputMaybe<Scalars['Float']['input']>;
  markup_value?: InputMaybe<Scalars['Float']['input']>;
  personnel: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  supplier_agreement: SupplierAgreement;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
};

export type VerifyUserAccountSecurityInput = {
  securityToken: Scalars['String']['input'];
  securityType: AccountSecurityType;
  user_id: Scalars['ID']['input'];
};

export type Wallet = {
  __typename?: 'Wallet';
  country: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  lock_status: LockStatus;
  lock_status_changed_date?: Maybe<Scalars['String']['output']>;
  merchant_id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  wallet_type: WalletType;
};

export type WalletBalanceDto = {
  __typename?: 'WalletBalanceDTO';
  dateRange?: Maybe<DateRangeDto>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  wallet?: Maybe<WalletResponseDto>;
};

export type WalletPayoutFilter = {
  country?: InputMaybe<CountryCodeOperator>;
  created_at?: InputMaybe<DateOperator>;
  currency?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  merchant_id?: InputMaybe<IdOperator>;
  status?: InputMaybe<WalletPayoutStatusOperator>;
  transaction_id?: InputMaybe<IdOperator>;
  wallet_id?: InputMaybe<IdOperator>;
  wallet_type?: InputMaybe<WalletTypeOperator>;
};

export type WalletPayoutRequestDecision = {
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  ops_personnel?: InputMaybe<Scalars['ID']['input']>;
  payout_id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: WalletPayoutStatus;
};

export type WalletPayoutResponseDto = {
  __typename?: 'WalletPayoutResponseDTO';
  account_name: Scalars['String']['output'];
  account_number: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  country: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  provider: Scalars['String']['output'];
  status: WalletPayoutStatus;
  transaction?: Maybe<Transaction>;
  wallet?: Maybe<WalletResponseDto>;
};

export enum WalletPayoutStatus {
  Approved = 'approved',
  Declined = 'declined',
  Pending = 'pending'
}

export type WalletPayoutStatusOperator = {
  eq?: InputMaybe<WalletPayoutStatus>;
  in?: InputMaybe<Array<WalletPayoutStatus>>;
  notIn?: InputMaybe<Array<WalletPayoutStatus>>;
};

export type WalletResponseDto = {
  __typename?: 'WalletResponseDTO';
  balance: Scalars['Float']['output'];
  country: Scalars['String']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  lock_status: LockStatus;
  merchant_id: Scalars['ID']['output'];
  wallet_type: WalletType;
};

export type WalletStatementDto = {
  __typename?: 'WalletStatementDTO';
  filename: Scalars['String']['output'];
  filepath: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum WalletType {
  House = 'house',
  HouseProfit = 'house_profit',
  Merchant = 'merchant',
  PaymentFacilitator = 'payment_facilitator',
  Supplier = 'supplier'
}

export type WalletTypeOperator = {
  eq?: InputMaybe<WalletType>;
};

export type WalletWithdrawalInput = {
  amount: Scalars['Float']['input'];
  currency: CurrencyInput;
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  provider?: InputMaybe<WithdrawalProviderInput>;
  secret: Scalars['String']['input'];
  wallet_id: Scalars['ID']['input'];
};

export type WholesalePriceTiers = {
  __typename?: 'WholesalePriceTiers';
  discount?: Maybe<Scalars['String']['output']>;
  min_quantity?: Maybe<Scalars['String']['output']>;
  wholesale_price?: Maybe<Scalars['String']['output']>;
};

export type WithdrawalProviderInput = {
  account_name: Scalars['String']['input'];
  account_number: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type XeroTokenSet = {
  __typename?: 'XeroTokenSet';
  created_at?: Maybe<Scalars['Date']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  token_set?: Maybe<Scalars['JSONObject']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  user_id: Scalars['ID']['output'];
  user_type: Scalars['String']['output'];
};

export type AccountRegisterInput = {
  country: Scalars['String']['input'];
  details?: InputMaybe<Details>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  referred_by?: InputMaybe<Scalars['String']['input']>;
  social_login?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  supplier_shop_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AddBusinessDocumentInput = {
  business_id?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<DocumentInput>>;
};

export type AddCommentInput = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  staff_name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AddCommentsToProductInput = {
  message: Scalars['String']['input'];
  product_id: Scalars['ID']['input'];
  staff_number: Scalars['String']['input'];
};

export type AddSupplierPaymentInput = {
  account_name: Scalars['String']['input'];
  account_number: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  method: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  stripe_account_id?: InputMaybe<Scalars['String']['input']>;
  supplier_id: Scalars['ID']['input'];
};

export type AuthenticateWithTokenInput = {
  token: Scalars['String']['input'];
};

export type BanResellerInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['Date']['input']>;
  user_id: Scalars['ID']['input'];
};

export type ChangePasswordInput = {
  confirmPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type ChangeResellerUsernameInput = {
  changed_by?: InputMaybe<ChangeBy>;
  new_username: Scalars['String']['input'];
  old_username: Scalars['String']['input'];
  user_id: Scalars['ID']['input'];
};

export type CheckPasswordAvailabilityInput = {
  channel?: InputMaybe<ChannelType>;
  phone: Scalars['String']['input'];
};

export type CreateProductInput = {
  avatar: Scalars['String']['input'];
  barcode?: InputMaybe<Scalars['String']['input']>;
  catalog_id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  combination_string?: InputMaybe<Scalars['String']['input']>;
  combinations?: InputMaybe<Array<InputMaybe<ProductCombinationInput>>>;
  cost_price: Scalars['Float']['input'];
  country: CountryCode;
  currency: CurrencyCode;
  description: Scalars['String']['input'];
  digitalDetails?: InputMaybe<Scalars['Any']['input']>;
  distributionChannels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  extra_information?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inhouse?: InputMaybe<Scalars['Boolean']['input']>;
  instantDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  inventory_locations?: InputMaybe<Array<InputMaybe<InventoryLocationQuantityInput>>>;
  limited_stock?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDeliveryTime?: InputMaybe<Scalars['Int']['input']>;
  media: Array<Scalars['String']['input']>;
  minimumDeliveryTime?: InputMaybe<Scalars['Int']['input']>;
  minimumOrderQuantity?: InputMaybe<Scalars['Int']['input']>;
  personnel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  productType?: InputMaybe<ProductType>;
  product_origin?: InputMaybe<ProductOrigin>;
  published: Scalars['Boolean']['input'];
  qty?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  resell?: InputMaybe<Scalars['Boolean']['input']>;
  shippingCost?: InputMaybe<Scalars['Int']['input']>;
  shop_id?: InputMaybe<Scalars['ID']['input']>;
  sku: Scalars['String']['input'];
  status?: InputMaybe<ProductStatus>;
  supplier_cost?: InputMaybe<Scalars['Float']['input']>;
  supplier_id?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['String']['input'];
  variations?: InputMaybe<Array<InputMaybe<VariationInput>>>;
  verified: Scalars['Boolean']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type DeleteResellerInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  user_id: Scalars['ID']['input'];
};

export enum DistributionChannel {
  MarketPlace = 'MarketPlace',
  ResellerNetwork = 'ResellerNetwork',
  SupplierStorefront = 'SupplierStorefront',
  TendoNetwork = 'TendoNetwork'
}

export type DocumentInput = {
  file?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EditProductStatInput = {
  editType: ProductStatEditType;
  product_id: Scalars['ID']['input'];
  stat: ProductStat;
  user_id: Scalars['ID']['input'];
};

export type ForgotPasswordInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type IsProductLikedByUserInput = {
  product_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};

export type IsProductSavedByUserInput = {
  product_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};

export type IsProductSharedByUserInput = {
  product_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};

export type MakeRequestForProduct = {
  product_id: Scalars['ID']['input'];
  qty: Scalars['Int']['input'];
  shop_id: Scalars['ID']['input'];
};

export type MigrationUserCreateInput = {
  country: Scalars['String']['input'];
  details?: InputMaybe<Details>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  referred_by?: InputMaybe<Scalars['String']['input']>;
  social_login?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ProductFilter = {
  attended_to?: InputMaybe<BooleanOperator>;
  catalog?: InputMaybe<CatalogFilter>;
  category?: InputMaybe<ProductCategoryFilter>;
  combination_string?: InputMaybe<StringOperator>;
  contractor?: InputMaybe<IdOperator>;
  country?: InputMaybe<StringOperator>;
  distributionChannels?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  inhouse?: InputMaybe<BooleanOperator>;
  main_stock?: InputMaybe<NumberOperator>;
  partner?: InputMaybe<IdOperator>;
  price?: InputMaybe<NumberOperator>;
  productType?: InputMaybe<ProductType>;
  product_origin?: InputMaybe<StringOperator>;
  published?: InputMaybe<BooleanOperator>;
  qty?: InputMaybe<NumberOperator>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
  resell?: InputMaybe<BooleanOperator>;
  reseller_id?: InputMaybe<IdOperator>;
  shop?: InputMaybe<ShopProductFilter>;
  shopCollection?: InputMaybe<ShopCollectionProductFilter>;
  sku?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  tags?: InputMaybe<StringOperator>;
  title?: InputMaybe<StringOperator>;
  transit_stock?: InputMaybe<NumberOperator>;
  uuid?: InputMaybe<StringOperator>;
  verified?: InputMaybe<BooleanOperator>;
};

export type ProductRequestFilter = {
  product?: InputMaybe<ProductFilter>;
  qty?: InputMaybe<NumberOperator>;
  shop_id?: InputMaybe<IdOperator>;
};

export type RequestChangeEmailInput = {
  email: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
};

export type RequestChangePhoneInput = {
  newPhone: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type RequestChangeSupplierPhoneInput = {
  newPhone: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type RequestEmailVerificationInput = {
  email: Scalars['String']['input'];
};

export type RequestOtpInput = {
  channel?: InputMaybe<ChannelType>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type RequestSupplierEmailVerificationInput = {
  email: Scalars['String']['input'];
};

export type RequestSupplierPhoneVerificationInput = {
  phone: Scalars['String']['input'];
};

export type ResetPasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type SetupAccountInput = {
  confirm_password: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type ShopfiySupplierOrderCreateInput = {
  country: Scalars['String']['input'];
  customer: ShopifyCustomer;
  customer_paid: Scalars['Boolean']['input'];
  payment_id?: InputMaybe<Scalars['String']['input']>;
  products: Array<ShopifyOrderProductInput>;
  reseller: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  supplier_id: Scalars['ID']['input'];
  total_amount: Scalars['Float']['input'];
};

export type SupplierUserLoginInput = {
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  supplier_id: Scalars['ID']['input'];
};

export type SuspendResellerInput = {
  by?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['Date']['input']>;
  user_id: Scalars['ID']['input'];
};

export type TempCreateProductInput = {
  avatar: Scalars['String']['input'];
  catalog_id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<TempCategoryInput>>>;
  combination_string?: InputMaybe<Scalars['String']['input']>;
  combinations?: InputMaybe<Array<InputMaybe<ProductCombinationInput>>>;
  cost_price: Scalars['Float']['input'];
  country: CountryCode;
  currency: CurrencyCode;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  inhouse?: InputMaybe<Scalars['Boolean']['input']>;
  limited_stock?: InputMaybe<Scalars['Boolean']['input']>;
  media: Array<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  published: Scalars['Boolean']['input'];
  qty?: InputMaybe<Scalars['Int']['input']>;
  resell?: InputMaybe<Scalars['Boolean']['input']>;
  shop_id: Scalars['ID']['input'];
  sku: Scalars['String']['input'];
  status?: InputMaybe<ProductStatus>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['String']['input'];
  variations?: InputMaybe<Array<InputMaybe<VariationInput>>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateUserDetailsInput = {
  dob?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referred_by?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  user_id: Scalars['Int']['input'];
};

export type UserLoginInput = {
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyEmailInput = {
  token: Scalars['String']['input'];
};

export type VerifyOtpInput = {
  code: Scalars['String']['input'];
  medium: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  update?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerifySupplierAccountInput = {
  action: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type VerifySupplierBusinessInput = {
  agreed_term?: InputMaybe<SupplierAgreementTerms>;
  genericName: Scalars['String']['input'];
  supplier_id: Scalars['ID']['input'];
};

export type VerifySupplierEmailInput = {
  token: Scalars['String']['input'];
};

export type VerifySupplierOtpInput = {
  code: Scalars['String']['input'];
  medium: Scalars['String']['input'];
  token: Scalars['String']['input'];
  update?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierSignInMutationVariables = Exact<{
  emailOrPhone: Scalars['String']['input'];
  password: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type SupplierSignInMutation = { __typename?: 'Mutation', supplierSignIn: { __typename?: 'SupplierAuthPayload', token?: string | null, supplier?: { __typename?: 'Supplier', id: string, name: string, email?: string | null, supplier_type: SupplierType, phone?: string | null, country?: string | null, has_verified_phonenumber: boolean, has_verified_email: boolean, setup_complete: boolean, generic_name?: string | null, device_token?: string | null, agreement_terms?: string | null, social_platform?: string | null, social_platform_token?: string | null, createdAt?: any | null, deletedAt?: any | null, permissions: Array<string>, avatar?: string | null, business_details?: { __typename?: 'SupplierBusiness', business_name?: string | null } | null, setupConfig?: { __typename?: 'SupplierSetupConfig', hasCategories: boolean, hasTerms: boolean, hasPaymentMethod: boolean } | null, payment_details?: { __typename?: 'SupplierPaymentDetails', id?: string | null, supplier_id?: string | null, account_name?: string | null, account_number?: string | null, provider?: string | null, method?: string | null } | null } | null } };

export type RequestSupplierOtpMutationVariables = Exact<{
  input?: InputMaybe<RequestOtpInput>;
}>;


export type RequestSupplierOtpMutation = { __typename?: 'Mutation', requestSupplierOTP?: { __typename?: 'RequestSupplierOTPResponse', token?: string | null } | null };

export type VerifySupplierOtpMutationVariables = Exact<{
  input?: InputMaybe<VerifySupplierOtpInput>;
}>;


export type VerifySupplierOtpMutation = { __typename?: 'Mutation', verifySupplierOTP?: boolean | null };

export type CreateSupplierMutationVariables = Exact<{
  input?: InputMaybe<SupplierInput>;
}>;


export type CreateSupplierMutation = { __typename?: 'Mutation', createSupplier?: { __typename?: 'SupplierCreationResponse', created: boolean, verification_token?: string | null } | null };

export type ChangeSupplierPasswordMutationVariables = Exact<{
  input?: InputMaybe<SupplierPasswordChangeInput>;
}>;


export type ChangeSupplierPasswordMutation = { __typename?: 'Mutation', changeSupplierPassword?: boolean | null };

export type RequestChangeSupplierPhoneMutationVariables = Exact<{
  input?: InputMaybe<RequestChangeSupplierPhoneInput>;
}>;


export type RequestChangeSupplierPhoneMutation = { __typename?: 'Mutation', requestChangeSupplierPhone?: boolean | null };

export type AccountRegisterMutationVariables = Exact<{
  input?: InputMaybe<AccountRegisterInput>;
}>;


export type AccountRegisterMutation = { __typename?: 'Mutation', accountRegister: { __typename?: 'Auth', token: string, user: { __typename?: 'User', id: string } } };

export type JoinSupplierResellerNetworkMutationVariables = Exact<{
  supplierId: Scalars['ID']['input'];
  resellerId: Scalars['ID']['input'];
  termsId: Scalars['ID']['input'];
}>;


export type JoinSupplierResellerNetworkMutation = { __typename?: 'Mutation', joinSupplierResellerNetwork?: boolean | null };

export type AddSupplierBusinessDetailsMutationVariables = Exact<{
  input?: InputMaybe<SupplierBusinessInput>;
}>;


export type AddSupplierBusinessDetailsMutation = { __typename?: 'Mutation', addSupplierBusinessDetails?: boolean | null };

export type AddSupplierCategoriesMutationVariables = Exact<{
  supplierId: Scalars['ID']['input'];
  categories: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddSupplierCategoriesMutation = { __typename?: 'Mutation', addSupplierCategories: boolean };

export type CreateDiscountMutationVariables = Exact<{
  input: CreateDiscountRequestDto;
}>;


export type CreateDiscountMutation = { __typename?: 'Mutation', createDiscount?: { __typename?: 'Discount', id: string } | null };

export type DeleteDiscountMutationVariables = Exact<{
  deleteDiscountId: Scalars['ID']['input'];
}>;


export type DeleteDiscountMutation = { __typename?: 'Mutation', deleteDiscount?: boolean | null };

export type UpdateDiscountMutationVariables = Exact<{
  filter: DiscountFilter;
  data: UpdateDiscountData;
}>;


export type UpdateDiscountMutation = { __typename?: 'Mutation', updateDiscount?: { __typename?: 'Discount', id: string, type: DiscountType, valid_country: string, code?: string | null, percentage?: number | null, amount?: number | null, description: string, is_draft: boolean, start_date: string, expiry_date: string, redemptions_limit?: number | null, product_condition?: ProductCondition | null, products?: Array<string | null> | null, fixed_amount_allocation?: FixedAmountAllocation | null, created_at?: any | null, updated_at?: any | null, created_by?: UserType | null, user_id?: string | null, has_expired?: boolean | null, number_of_times_used?: number | null, locations?: Array<string | null> | null, locations_tagname?: string | null } | null };

export type AddPluginToUserMutationVariables = Exact<{
  data: AddPluginToUserRequestDto;
}>;


export type AddPluginToUserMutation = { __typename?: 'Mutation', addPluginToUser?: { __typename?: 'UserPlugin', id: string, user_id: string, plugin_id: string } | null };

export type RemovePluginFromUserMutationVariables = Exact<{
  filter: UserPluginFilter;
}>;


export type RemovePluginFromUserMutation = { __typename?: 'Mutation', removePluginFromUser?: boolean | null };

export type RemoveShopifyShopMutationVariables = Exact<{
  supplierId: Scalars['ID']['input'];
}>;


export type RemoveShopifyShopMutation = { __typename?: 'Mutation', removeShopifyShop?: boolean | null };

export type StripeAccountSessionMutationVariables = Exact<{
  input?: InputMaybe<StripeAccountSessionInput>;
}>;


export type StripeAccountSessionMutation = { __typename?: 'Mutation', stripeAccountSession?: string | null };

export type StripeExternalBankAccountMutationVariables = Exact<{
  supplierId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StripeExternalBankAccountMutation = { __typename?: 'Mutation', stripeExternalBankAccount?: boolean | null };

export type InviteResellerBySupplierMutationVariables = Exact<{
  supplierId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  termsId: Scalars['ID']['input'];
}>;


export type InviteResellerBySupplierMutation = { __typename?: 'Mutation', inviteResellerBySupplier?: boolean | null };

export type AddSupplierDeviceTokenMutationVariables = Exact<{
  input?: InputMaybe<SupplierAddDeviceTokenInput>;
}>;


export type AddSupplierDeviceTokenMutation = { __typename?: 'Mutation', addSupplierDeviceToken?: boolean | null };

export type ProcessOrderMutationVariables = Exact<{
  processOrderId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProcessOrderMutation = { __typename?: 'Mutation', processOrder?: boolean | null };

export type ChangeSupplierStatusMutationVariables = Exact<{
  changeSupplierStatusId: Scalars['ID']['input'];
  supplierStatus?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeSupplierStatusMutation = { __typename?: 'Mutation', changeSupplierStatus?: boolean | null };

export type CreateCustomerMutationVariables = Exact<{
  input?: InputMaybe<CustomerInput>;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer?: { __typename?: 'Customer', id: string, name: string, phone: string, email?: string | null, address?: Array<{ __typename?: 'CustomerAddress', id: string, area: string, city?: string | null, country?: string | null, landmark?: string | null } | null> | null } | null };

export type CreateOrderMutationVariables = Exact<{
  input?: InputMaybe<OrderCreateInput>;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: string };

export type CreatePartnershipMutationVariables = Exact<{
  name: Scalars['String']['input'];
  contractor: Scalars['ID']['input'];
  skus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  client: Scalars['ID']['input'];
}>;


export type CreatePartnershipMutation = { __typename?: 'Mutation', createPartnership: boolean };

export type UpdatePartnershipMutationVariables = Exact<{
  updatePartnershipId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  skus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdatePartnershipMutation = { __typename?: 'Mutation', updatePartnership: boolean };

export type RejectPartnershipMutationVariables = Exact<{
  rejectPartnershipId: Scalars['ID']['input'];
}>;


export type RejectPartnershipMutation = { __typename?: 'Mutation', rejectPartnership: boolean };

export type ApprovePartnershipMutationVariables = Exact<{
  approvePartnershipId: Scalars['ID']['input'];
  termId: Scalars['ID']['input'];
}>;


export type ApprovePartnershipMutation = { __typename?: 'Mutation', approvePartnership: boolean };

export type AddSupplierPaymentDetailsMutationVariables = Exact<{
  input?: InputMaybe<AddSupplierPaymentInput>;
}>;


export type AddSupplierPaymentDetailsMutation = { __typename?: 'Mutation', addSupplierPaymentDetails?: boolean | null };

export type UpdateSupplierPaymentMutationVariables = Exact<{
  input?: InputMaybe<UpdateSupplierPaymentInput>;
}>;


export type UpdateSupplierPaymentMutation = { __typename?: 'Mutation', updateSupplierPayment?: { __typename?: 'SupplierPaymentDetails', id?: string | null } | null };

export type MakeWalletWithdrawalMutationVariables = Exact<{
  input: WalletWithdrawalInput;
}>;


export type MakeWalletWithdrawalMutation = { __typename?: 'Mutation', makeWalletWithdrawal: { __typename?: 'ChargeWalletResponseDTO', reference: string, status: string, error?: string | null, metadata?: any | null } };

export type InitiateCardSetupMutationVariables = Exact<{
  input?: InputMaybe<InitiateCardSetupInput>;
}>;


export type InitiateCardSetupMutation = { __typename?: 'Mutation', initiateCardSetup?: string | null };

export type CreateProductMutationVariables = Exact<{
  input?: InputMaybe<CreateProductInput>;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct?: boolean | null };

export type UpdateProductCategoryAndTagsMutationVariables = Exact<{
  input?: InputMaybe<ProductCategoryAndTagsInput>;
}>;


export type UpdateProductCategoryAndTagsMutation = { __typename?: 'Mutation', updateProductCategoryAndTags?: boolean | null };

export type UpdateProductMediaMutationVariables = Exact<{
  input?: InputMaybe<ProductMediaInput>;
}>;


export type UpdateProductMediaMutation = { __typename?: 'Mutation', updateProductMedia?: boolean | null };

export type BulkUpdateProductSockMutationVariables = Exact<{
  input?: InputMaybe<Array<BulkProductStockInput> | BulkProductStockInput>;
}>;


export type BulkUpdateProductSockMutation = { __typename?: 'Mutation', bulkUpdateProductSock?: boolean | null };

export type UpdateProductInventoryMutationVariables = Exact<{
  input?: InputMaybe<ProductInventoryInput>;
}>;


export type UpdateProductInventoryMutation = { __typename?: 'Mutation', updateProductInventory?: boolean | null };

export type UpdateProductInformationMutationVariables = Exact<{
  input?: InputMaybe<ProductInformationInput>;
}>;


export type UpdateProductInformationMutation = { __typename?: 'Mutation', updateProductInformation?: boolean | null };

export type UpdateProductDistributionMutationVariables = Exact<{
  input?: InputMaybe<UpdateProductDistributionInput>;
}>;


export type UpdateProductDistributionMutation = { __typename?: 'Mutation', updateProductDistribution?: boolean | null };

export type RemoveProductMutationVariables = Exact<{
  removeProductId: Scalars['ID']['input'];
}>;


export type RemoveProductMutation = { __typename?: 'Mutation', removeProduct?: boolean | null };

export type SyncShopifyProductsMutationVariables = Exact<{
  input: SyncShopifyProductInput;
}>;


export type SyncShopifyProductsMutation = { __typename?: 'Mutation', syncShopifyProducts?: boolean | null };

export type PublishOrUnpublishProductMutationVariables = Exact<{
  publishOrUnpublishProductId: Scalars['ID']['input'];
  published: Scalars['Boolean']['input'];
  personnel: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublishOrUnpublishProductMutation = { __typename?: 'Mutation', publishOrUnpublishProduct?: boolean | null };

export type LoadProductsToShopifyMutationVariables = Exact<{
  input?: InputMaybe<LoadProductToShopifyInput>;
}>;


export type LoadProductsToShopifyMutation = { __typename?: 'Mutation', loadProductsToShopify?: boolean | null };

export type RemoveResellerBySupplierMutationVariables = Exact<{
  supplierId: Scalars['ID']['input'];
  resellerId: Scalars['ID']['input'];
}>;


export type RemoveResellerBySupplierMutation = { __typename?: 'Mutation', removeResellerBySupplier?: boolean | null };

export type ActivateShopMutationVariables = Exact<{
  data: ActivateShopRequestDto;
}>;


export type ActivateShopMutation = { __typename?: 'Mutation', activateShop: boolean };

export type UpdateSupplierShopDetailsMutationVariables = Exact<{
  data: UpdateShopDetailsRequestDto;
}>;


export type UpdateSupplierShopDetailsMutation = { __typename?: 'Mutation', updateSupplierShopDetails: { __typename?: 'UpdateShopDetailsResponseDto', shopId?: string | null } };

export type UpdateSupplierShopSlugMutationVariables = Exact<{
  data: UpdateSupplierSlugInput;
}>;


export type UpdateSupplierShopSlugMutation = { __typename?: 'Mutation', updateSupplierShopSlug?: { __typename?: 'Shop', shopId?: string | null } | null };

export type CreateTermMutationVariables = Exact<{
  input: TermInput;
}>;


export type CreateTermMutation = { __typename?: 'Mutation', createTerm: boolean };

export type UpdateTermMutationVariables = Exact<{
  input: TermInput;
}>;


export type UpdateTermMutation = { __typename?: 'Mutation', updateTerm: boolean };

export type UpdateSupplierDetailsMutationVariables = Exact<{
  input?: InputMaybe<UpdateSupplierDetailsInput>;
}>;


export type UpdateSupplierDetailsMutation = { __typename?: 'Mutation', updateSupplierDetails?: boolean | null };

export type ChangeSupplierEmailMutationVariables = Exact<{
  input?: InputMaybe<SupplierEmailChangeInput>;
}>;


export type ChangeSupplierEmailMutation = { __typename?: 'Mutation', changeSupplierEmail?: boolean | null };

export type ResetSupplierPasswordMutationVariables = Exact<{
  input?: InputMaybe<SupplierPasswordResetInput>;
}>;


export type ResetSupplierPasswordMutation = { __typename?: 'Mutation', resetSupplierPassword?: boolean | null };

export type GetCustomersQueryVariables = Exact<{
  filter?: InputMaybe<CustomerFilter>;
  pagination?: InputMaybe<Pagination>;
}>;


export type GetCustomersQuery = { __typename?: 'Query', getCustomersLength: number, getCustomers?: Array<{ __typename?: 'Customer', id: string, name: string, email?: string | null, phone: string, address?: Array<{ __typename?: 'CustomerAddress', id: string, area: string, city?: string | null, country?: string | null, landmark?: string | null } | null> | null } | null> | null };

export type GetCustomerQueryVariables = Exact<{
  filter?: InputMaybe<CustomerFilter>;
}>;


export type GetCustomerQuery = { __typename?: 'Query', getCustomer?: { __typename?: 'Customer', email?: string | null, id: string, name: string, phone: string, address?: Array<{ __typename?: 'CustomerAddress', area: string, city?: string | null, country?: string | null, landmark?: string | null } | null> | null, reseller?: { __typename?: 'User', id: string } | null } | null };

export type GetSupplierDailyOrdersSummaryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type GetSupplierDailyOrdersSummaryQuery = { __typename?: 'Query', getSupplierDailyOrdersSummary?: any | null };

export type GetSupplierStatsQueryVariables = Exact<{
  supplierId: Scalars['ID']['input'];
}>;


export type GetSupplierStatsQuery = { __typename?: 'Query', getSupplierStats?: { __typename?: 'SupplierStats', supplier_id: string, total_active_orders: number, total_orders: number, total_finished_orders: number, total_products: number, total_verified_products: number, total_unverified_products: number, total_products_in_stock: number, total_products_out_of_stock: number, total_products_in_transit: number, total_customers: number, total_resellers: number } | null };

export type GetSupplierOrdersByStatusSummaryQueryVariables = Exact<{
  supplierId: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type GetSupplierOrdersByStatusSummaryQuery = { __typename?: 'Query', getSupplierOrdersByStatusSummary?: { __typename?: 'OrderStatusesStats', totalPending: number, totalDelivered: number, totalCancelled: number, totalSuccessful: number } | null };

export type GetProductsCountByCategoriesQueryVariables = Exact<{
  supplierId: Scalars['ID']['input'];
}>;


export type GetProductsCountByCategoriesQuery = { __typename?: 'Query', getProductsCountByCategories?: Array<{ __typename?: 'ProductCategoryCount', category: string, count: number } | null> | null };

export type DeliveryLocationsQueryVariables = Exact<{
  filter?: InputMaybe<DeliveryFilter>;
}>;


export type DeliveryLocationsQuery = { __typename?: 'Query', deliveryLocations?: Array<{ __typename?: 'Delivery', id: string, location: string, price: number, country?: string | null, remarks?: string | null, isPayOnline: boolean, hasInstantDelivery: boolean, instantDeliveryPrice?: number | null } | null> | null };

export type GetPluginsQueryVariables = Exact<{
  filter?: InputMaybe<PluginFilter>;
  pagination?: InputMaybe<Pagination>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPluginsQuery = { __typename?: 'Query', getPlugins?: Array<{ __typename?: 'Plugin', id: string, name: string, logo: string, banner_image?: string | null, category: string, developer?: string | null, verified: boolean, description?: string | null, endpoint: string, is_installed_by_current_user?: boolean | null, created_at?: any | null, updated_at?: any | null } | null> | null };

export type GetUserPluginsQueryVariables = Exact<{
  filter?: InputMaybe<UserPluginFilter>;
  pagination?: InputMaybe<Pagination>;
}>;


export type GetUserPluginsQuery = { __typename?: 'Query', getUserPlugins?: Array<{ __typename?: 'UserPlugin', id: string, user_id: string, plugin_id: string } | null> | null };

export type ConfirmCardSetupQueryVariables = Exact<{
  confirmCardSetupId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfirmCardSetupQuery = { __typename?: 'Query', confirmCardSetup?: boolean | null };

export type GetCartsQueryVariables = Exact<{
  filter?: InputMaybe<CartFilter>;
  pagination?: InputMaybe<Pagination>;
}>;


export type GetCartsQuery = { __typename?: 'Query', count: number, rows?: Array<{ __typename?: 'Order', delivery_id?: string | null, id: string, customer_id: string, supplier_id?: string | null, customer_address_id?: string | null, user_id: string, order_total: number, security_deposit_paid?: boolean | null, security_deposit?: number | null, delivery_amount?: number | null, customer_paid: boolean, cart_number: string, payment_status?: string | null, discount?: number | null, free_delivery?: boolean | null, payment_id?: string | null, payment_type: string, tracking_code?: string | null, delivery_instructions?: string | null, source: string, country: string, createdAt?: any | null, updatedAt?: any | null, reseller?: { __typename?: 'User', id: string, email: string, name: string, country: string, phone: string, verified: boolean, first_order_created?: boolean | null, user_type?: UserAccountType | null, username: string, google_id?: string | null, deviceToken?: string | null, facebook_id?: string | null, twitter_id?: string | null, supplier_shop_id?: string | null } | null, supplier?: { __typename?: 'Supplier', id: string, name: string, email?: string | null, phone?: string | null, country?: string | null, has_verified_phonenumber: boolean, has_verified_email: boolean, setup_complete: boolean, generic_name?: string | null, device_token?: string | null, agreement_terms?: string | null, social_platform?: string | null, social_platform_token?: string | null, createdAt?: any | null, deletedAt?: any | null } | null, orderItems?: Array<{ __typename?: 'OrderItem', id: string, orderNumber?: string | null, quantity?: number | null, profitAdded?: number | null, status?: string | null, supplier_status?: string | null, source?: string | null, price?: number | null, sku: string, order_id?: string | null, createdAt?: any | null, updatedAt?: any | null, product?: { __typename?: 'Product', sku: string, id: string, title: string, limited_stock?: boolean | null, qty?: number | null, instantDelivery?: boolean | null, main_stock?: number | null, minimumOrderQuantity?: number | null, distributionChannels?: Array<string | null> | null, transit_stock?: number | null, price: number, profit_added?: number | null, currency?: string | null, country?: CountryCode | null, description: string, extra_information?: string | null, combination_string?: string | null, published: boolean, inhouse?: boolean | null, attended_to?: boolean | null, verified?: boolean | null, cost_price: number, weight?: number | null, avatar: string, tags?: Array<string | null> | null, shop_id?: string | null, resell: boolean, uuid?: string | null, likesCount?: number | null, savesCount?: number | null, sharesCount?: number | null, supplier_id?: string | null, created_at?: any | null, overalReview: number } | null } | null> | null, customer?: { __typename?: 'Customer', id: string, name: string, email?: string | null, phone: string } | null, delivery?: { __typename?: 'Delivery', id: string, location: string, price: number, country?: string | null, remarks?: string | null, isPayOnline: boolean } | null } | null> | null };

export type GetCartQueryVariables = Exact<{
  filter?: InputMaybe<CartFilter>;
}>;


export type GetCartQuery = { __typename?: 'Query', getCart?: { __typename?: 'Order', delivery_id?: string | null, id: string, customer_id: string, supplier_id?: string | null, customer_address_id?: string | null, user_id: string, order_total: number, security_deposit_paid?: boolean | null, security_deposit?: number | null, delivery_amount?: number | null, customer_paid: boolean, cart_number: string, payment_status?: string | null, discount?: number | null, free_delivery?: boolean | null, payment_id?: string | null, payment_type: string, delivery_type: string, tracking_code?: string | null, delivery_instructions?: string | null, source: string, country: string, createdAt?: any | null, updatedAt?: any | null, orderItems?: Array<{ __typename?: 'OrderItem', id: string, orderNumber?: string | null, quantity?: number | null, profitAdded?: number | null, status?: string | null, supplier_status?: string | null, source?: string | null, price?: number | null, sku: string, order_id?: string | null, createdAt?: any | null, updatedAt?: any | null, product?: { __typename?: 'Product', sku: string, id: string, title: string, limited_stock?: boolean | null, qty?: number | null, main_stock?: number | null, minimumOrderQuantity?: number | null, distributionChannels?: Array<string | null> | null, transit_stock?: number | null, price: number, profit_added?: number | null, currency?: string | null, country?: CountryCode | null, description: string, extra_information?: string | null, combination_string?: string | null, published: boolean, inhouse?: boolean | null, attended_to?: boolean | null, verified?: boolean | null, cost_price: number, weight?: number | null, avatar: string, tags?: Array<string | null> | null, shop_id?: string | null, resell: boolean, uuid?: string | null, likesCount?: number | null, savesCount?: number | null, sharesCount?: number | null, supplier_id?: string | null, created_at?: any | null, instantDelivery?: boolean | null, overalReview: number } | null } | null> | null, delivery?: { __typename?: 'Delivery', id: string, location: string, price: number, country?: string | null, remarks?: string | null, isPayOnline: boolean } | null, customer?: { __typename?: 'Customer', id: string, name: string, email?: string | null, phone: string } | null, reseller?: { __typename?: 'User', id: string, email: string, name: string, country: string, phone: string, verified: boolean, first_order_created?: boolean | null, user_type?: UserAccountType | null, username: string, google_id?: string | null, deviceToken?: string | null, facebook_id?: string | null, twitter_id?: string | null, supplier_shop_id?: string | null } | null, address?: { __typename?: 'CustomerAddress', country?: string | null, city?: string | null, area: string, landmark?: string | null, lat?: string | null, lng?: string | null, id: string } | null } | null };

export type GetPickUpLocationsQueryVariables = Exact<{
  filter?: InputMaybe<DeliveryFilter>;
  pagination?: InputMaybe<Pagination>;
}>;


export type GetPickUpLocationsQuery = { __typename?: 'Query', getPickUpLocations?: Array<{ __typename?: 'Pickup', id: string, location?: string | null, country?: string | null, google_location?: string | null, longitude?: string | null, latitude?: string | null, remarks?: string | null }> | null };

export type GetPartnershipsQueryVariables = Exact<{
  filter?: InputMaybe<PartnershipFilter>;
  pagination?: InputMaybe<Pagination>;
}>;


export type GetPartnershipsQuery = { __typename?: 'Query', count: number, rows: Array<{ __typename?: 'Partnership', createdAt: any, id: string, name: string, skus: Array<string>, status: PartnershipStatus, supplier_id: string, updatedAt: any }> };

export type GetPartnershipQueryVariables = Exact<{
  filter: PartnershipFilter;
}>;


export type GetPartnershipQuery = { __typename?: 'Query', getPartnership?: { __typename?: 'Partnership', id: string, name: string, supplier_id: string, skus: Array<string>, createdAt: any, updatedAt: any, status: PartnershipStatus, products: Array<{ __typename?: 'Product', sku: string, id: string, title: string, limited_stock?: boolean | null, qty?: number | null, main_stock?: number | null, minimumOrderQuantity?: number | null, distributionChannels?: Array<string | null> | null, transit_stock?: number | null, price: number, profit_added?: number | null, currency?: string | null, country?: CountryCode | null, description: string, extra_information?: string | null, combination_string?: string | null, published: boolean, inhouse?: boolean | null, attended_to?: boolean | null, verified?: boolean | null, cost_price: number, weight?: number | null, avatar: string, tags?: Array<string | null> | null, shop_id?: string | null, resell: boolean, uuid?: string | null, likesCount?: number | null, savesCount?: number | null, sharesCount?: number | null, supplier_id?: string | null, created_at?: any | null, overalReview: number }> } | null };

export type VerifyAccountDetailsQueryVariables = Exact<{
  input: PaystackValidateAccountInput;
}>;


export type VerifyAccountDetailsQuery = { __typename?: 'Query', verifyAccountDetails?: any | null };

export type GetDiscountsQueryVariables = Exact<{
  filter?: InputMaybe<DiscountFilter>;
  pagination?: InputMaybe<Pagination>;
}>;


export type GetDiscountsQuery = { __typename?: 'Query', getDiscounts?: Array<{ __typename?: 'Discount', id: string, type: DiscountType, valid_country: string, code?: string | null, percentage?: number | null, amount?: number | null, description: string, is_draft: boolean, start_date: string, expiry_date: string, redemptions_limit?: number | null, product_condition?: ProductCondition | null, products?: Array<string | null> | null, fixed_amount_allocation?: FixedAmountAllocation | null, created_at?: any | null, updated_at?: any | null, created_by?: UserType | null, user_id?: string | null, has_expired?: boolean | null, number_of_times_used?: number | null, locations?: Array<string | null> | null } | null> | null };

export type GetDiscountQueryVariables = Exact<{
  filter: DiscountFilter;
}>;


export type GetDiscountQuery = { __typename?: 'Query', getDiscount?: { __typename?: 'Discount', id: string, type: DiscountType, valid_country: string, code?: string | null, percentage?: number | null, amount?: number | null, description: string, is_draft: boolean, start_date: string, expiry_date: string, redemptions_limit?: number | null, product_condition?: ProductCondition | null, products?: Array<string | null> | null, fixed_amount_allocation?: FixedAmountAllocation | null, created_at?: any | null, updated_at?: any | null, created_by?: UserType | null, user_id?: string | null, has_expired?: boolean | null, number_of_times_used?: number | null, locations?: Array<string | null> | null, locations_tagname?: string | null } | null };

export type GetDiscountProductConditionsQueryVariables = Exact<{
  filter?: InputMaybe<DiscountProductConditionFilter>;
  pagination?: InputMaybe<Pagination>;
}>;


export type GetDiscountProductConditionsQuery = { __typename?: 'Query', getDiscountProductConditions?: Array<{ __typename?: 'DiscountProductCondition', id: string, product_sku: string, discount_id: string, created_at?: any | null, updated_at?: any | null, product?: { __typename?: 'Product', sku: string, id: string, title: string, limited_stock?: boolean | null, qty?: number | null, main_stock?: number | null, transit_stock?: number | null, price: number, profit_added?: number | null, currency?: string | null, country?: CountryCode | null, description: string, extra_information?: string | null, combination_string?: string | null, published: boolean, inhouse?: boolean | null, attended_to?: boolean | null, verified?: boolean | null, cost_price: number, weight?: number | null, avatar: string, tags?: Array<string | null> | null, shop_id?: string | null, resell: boolean, uuid?: string | null, likesCount?: number | null, savesCount?: number | null, sharesCount?: number | null, supplier_id?: string | null, created_at?: any | null, overalReview: number } | null } | null> | null };

export type GetProductsLengthQueryVariables = Exact<{
  filter?: InputMaybe<ProductFilter>;
}>;


export type GetProductsLengthQuery = { __typename?: 'Query', getProductsLength?: number | null };

export type GetSkuQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSkuQuery = { __typename?: 'Query', getSKU?: string | null };

export type GetCategoriesLengthQueryVariables = Exact<{
  filter?: InputMaybe<ProductCategoryFilter>;
}>;


export type GetCategoriesLengthQuery = { __typename?: 'Query', getProductCategoriesLength: number };

export type FeaturedCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<FeaturedCategoriesFilter>;
}>;


export type FeaturedCategoriesQuery = { __typename?: 'Query', featuredCategories?: Array<{ __typename?: 'FeaturedCategories', id: string, color?: string | null, banners?: Array<string | null> | null, category?: { __typename?: 'ProductCategory', id: string, name: string, description?: string | null, avatar?: string | null, children?: Array<{ __typename?: 'ProductCategory', id: string, name: string, description?: string | null, avatar?: string | null } | null> | null } | null }> | null };

export type GetProductsQueryVariables = Exact<{
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<Pagination>;
  condition?: InputMaybe<Condition>;
}>;


export type GetProductsQuery = { __typename?: 'Query', getProductsLength?: number | null, getProducts?: Array<{ __typename?: 'Product', id: string, title: string, overalReview: number, sku: string, qty?: number | null, price: number, status?: ProductStatus | null, supplier_cost?: number | null, description: string, instantDelivery?: boolean | null, extra_information?: string | null, published: boolean, avatar: string, digitalDetails?: any | null, productType?: ProductType | null, limited_stock?: boolean | null, currency?: string | null, verified?: boolean | null, inhouse?: boolean | null, cost_price: number, weight?: number | null, tags?: Array<string | null> | null, combination_string?: string | null, distributionChannels?: Array<string | null> | null, main_stock?: number | null, transit_stock?: number | null, profit_added?: number | null, country?: CountryCode | null, attended_to?: boolean | null, shop_id?: string | null, resell: boolean, uuid?: string | null, likesCount?: number | null, savesCount?: number | null, sharesCount?: number | null, supplier_id?: string | null, categories?: Array<{ __typename?: 'ProductCategory', id: string, name: string, description?: string | null } | null> | null, media?: Array<{ __typename?: 'ProductAvatar', avatar?: string | null, id?: string | null } | null> | null, comments?: Array<{ __typename?: 'ProductComment', id: string, staff_number?: string | null, message?: string | null, created_at?: string | null, updated_at?: string | null } | null> | null, variations?: Array<{ __typename?: 'Variation', id?: string | null, variation_name: string, variation_options: Array<{ __typename?: 'VariationOption', id?: string | null, variation_value?: string | null } | null> } | null> | null, supplier?: { __typename?: 'Supplier', id: string, name: string, email?: string | null, phone?: string | null, country?: string | null, has_verified_phonenumber: boolean, has_verified_email: boolean, setup_complete: boolean, generic_name?: string | null, createdAt?: any | null, deletedAt?: any | null, agreement_terms?: string | null, business_details?: { __typename?: 'SupplierBusiness', business_name?: string | null } | null } | null } | null> | null };

export type GetProductQueryVariables = Exact<{
  filter?: InputMaybe<ProductFilter>;
}>;


export type GetProductQuery = { __typename?: 'Query', getProduct?: { __typename?: 'Product', id: string, title: string, sku: string, limited_stock?: boolean | null, status?: ProductStatus | null, qty?: number | null, price: number, supplier_cost?: number | null, product_origin?: ProductOrigin | null, currency?: string | null, distributionChannels?: Array<string | null> | null, description: string, digitalDetails?: any | null, combination_string?: string | null, instantDelivery?: boolean | null, productType?: ProductType | null, extra_information?: string | null, published: boolean, inhouse?: boolean | null, attended_to?: boolean | null, verified?: boolean | null, cost_price: number, weight?: number | null, country?: CountryCode | null, avatar: string, tags?: Array<string | null> | null, resell: boolean, uuid?: string | null, likesCount?: number | null, savesCount?: number | null, sharesCount?: number | null, shop_id?: string | null, minimumOrderQuantity?: number | null, main_stock?: number | null, transit_stock?: number | null, categories?: Array<{ __typename?: 'ProductCategory', id: string, name: string, description?: string | null, avatar?: string | null } | null> | null, media?: Array<{ __typename?: 'ProductAvatar', id?: string | null, avatar?: string | null } | null> | null, variations?: Array<{ __typename?: 'Variation', id?: string | null, variation_name: string, variation_options: Array<{ __typename?: 'VariationOption', id?: string | null, variation_value?: string | null } | null> } | null> | null, comments?: Array<{ __typename?: 'ProductComment', id: string, staff_number?: string | null, message?: string | null, created_at?: string | null, updated_at?: string | null } | null> | null, combinations?: Array<{ __typename?: 'ProductCombination', id?: string | null, sku: string, price: number, available_stock: number, combination_string: string } | null> | null } | null };

export type GetProductsForSupplierDashboardQueryVariables = Exact<{
  filter?: InputMaybe<SupplierProductFilter>;
  pagination?: InputMaybe<Pagination>;
  condition?: InputMaybe<Condition>;
  sort?: InputMaybe<ProductSort>;
}>;


export type GetProductsForSupplierDashboardQuery = { __typename?: 'Query', getProductsForSupplierDashboardLength: number, getProductsForSupplierDashboard?: Array<{ __typename?: 'Product', id: string, title: string, overalReview: number, sku: string, qty?: number | null, price: number, status?: ProductStatus | null, supplier_cost?: number | null, description: string, instantDelivery?: boolean | null, extra_information?: string | null, published: boolean, avatar: string, digitalDetails?: any | null, productType?: ProductType | null, limited_stock?: boolean | null, currency?: string | null, verified?: boolean | null, inhouse?: boolean | null, cost_price: number, weight?: number | null, tags?: Array<string | null> | null, combination_string?: string | null, distributionChannels?: Array<string | null> | null, main_stock?: number | null, transit_stock?: number | null, profit_added?: number | null, country?: CountryCode | null, attended_to?: boolean | null, shop_id?: string | null, resell: boolean, uuid?: string | null, likesCount?: number | null, savesCount?: number | null, sharesCount?: number | null, supplier_id?: string | null, categories?: Array<{ __typename?: 'ProductCategory', id: string, name: string, description?: string | null } | null> | null, media?: Array<{ __typename?: 'ProductAvatar', avatar?: string | null, id?: string | null } | null> | null, comments?: Array<{ __typename?: 'ProductComment', id: string, staff_number?: string | null, message?: string | null, created_at?: string | null, updated_at?: string | null } | null> | null, variations?: Array<{ __typename?: 'Variation', id?: string | null, variation_name: string, variation_options: Array<{ __typename?: 'VariationOption', id?: string | null, variation_value?: string | null } | null> } | null> | null, supplier?: { __typename?: 'Supplier', id: string, name: string, email?: string | null, phone?: string | null, country?: string | null, has_verified_phonenumber: boolean, has_verified_email: boolean, setup_complete: boolean, generic_name?: string | null, createdAt?: any | null, deletedAt?: any | null, agreement_terms?: string | null, business_details?: { __typename?: 'SupplierBusiness', business_name?: string | null } | null } | null } | null> | null };

export type GetProductTitleQueryVariables = Exact<{
  filter?: InputMaybe<ProductFilter>;
}>;


export type GetProductTitleQuery = { __typename?: 'Query', getProduct?: { __typename?: 'Product', id: string, title: string, sku: string } | null };

export type GetProductCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<ProductCategoryFilter>;
  pagination?: InputMaybe<Pagination>;
}>;


export type GetProductCategoriesQuery = { __typename?: 'Query', getProductCategoriesLength: number, getProductCategories?: Array<{ __typename?: 'ProductCategory', description?: string | null, id: string, name: string, avatar?: string | null } | null> | null };

export type GetProductCategoryQueryVariables = Exact<{
  filter?: InputMaybe<ProductCategoryFilter>;
}>;


export type GetProductCategoryQuery = { __typename?: 'Query', getProductCategory?: { __typename?: 'ProductCategory', id: string, name: string, description?: string | null, isActive?: boolean | null, avatar?: string | null, parent?: string | null } | null };

export type LoadShopifyProductsQueryVariables = Exact<{
  integrationId: Scalars['ID']['input'];
}>;


export type LoadShopifyProductsQuery = { __typename?: 'Query', loadShopifyProducts?: Array<{ __typename?: 'ShopifyLoadedProduct', id?: string | null, title?: string | null, handle?: string | null, body_html?: string | null, status?: string | null, images?: Array<{ __typename?: 'ShopifyImage', created_at?: string | null, height?: number | null, id?: string | null, position?: number | null, product_id?: string | null, src?: string | null, updated_at?: string | null, variant_ids?: Array<string | null> | null, width?: number | null } | null> | null } | null> | null };

export type GetProductTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<TemplateFilter>;
  pagination?: InputMaybe<Pagination>;
}>;


export type GetProductTemplatesQuery = { __typename?: 'Query', getProductTemplates?: Array<{ __typename?: 'ProductTemplate', id: string, name: string, description?: string | null, body?: Array<{ __typename?: 'Template', label: string, type: TemplateType, description?: string | null, required?: boolean | null, dependsOn?: string | null, options?: Array<{ __typename?: 'SelectOption', value: string, label: string }> | null }> | null }> | null };

export type GetProductTemplateQueryVariables = Exact<{
  filter: TemplateFilter;
}>;


export type GetProductTemplateQuery = { __typename?: 'Query', getProductTemplate?: { __typename?: 'ProductTemplate', id: string, name: string, description?: string | null, body?: Array<{ __typename?: 'Template', label: string, type: TemplateType, description?: string | null, required?: boolean | null, dependsOn?: string | null, options?: Array<{ __typename?: 'SelectOption', value: string, label: string }> | null }> | null } | null };

export type GetProductHistoryQueryVariables = Exact<{
  filter: ProductHistoryFilter;
  pagination: Pagination;
}>;


export type GetProductHistoryQuery = { __typename?: 'Query', getProductHistory?: Array<{ __typename?: 'ProductHistory', id?: string | null, product_id: string, action?: string | null, actor?: string | null, notes?: string | null, oldSnapshot?: any | null, newSnapshot?: any | null, createdAt: any, updatedAt: any } | null> | null };

export type GetShopQueryVariables = Exact<{
  filter: ShopFilter;
}>;


export type GetShopQuery = { __typename?: 'Query', getShop?: { __typename?: 'Shop', id: string, name?: string | null, description?: string | null, contactEmail?: string | null, email?: string | null, currency?: CurrencyCode | null, slug?: string | null, primaryDomain?: string | null, sokoWorldDomain?: string | null, customDomains?: Array<string | null> | null, hasBeenSetup?: boolean | null, isActive?: boolean | null, shopTags?: Array<string> | null, createdAt?: string | null, updatedAt?: string | null, avatar?: string | null, country?: CountryCode | null, coverImage?: string | null, deliveryOption?: DeliveryOption | null, deliveryAgent?: DeliveryAgent | null, paymentOptions?: Array<PaymentOption> | null, url?: string | null, shortUrl?: string | null, phone?: string | null, ownerId: string, supplierId?: string | null, shopId?: string | null } | null };

export type GetShopifyShopQueryVariables = Exact<{
  input?: InputMaybe<FetchShopifyShopInput>;
}>;


export type GetShopifyShopQuery = { __typename?: 'Query', getShopifyShop?: { __typename?: 'ShopifyShop', id?: string | null, shop: string, redirect_url?: string | null, supplier_id?: string | null, shop_currency?: string | null, country_code?: string | null, country_name?: string | null, created_at?: any | null, updated_at?: any | null, shop_payment_method?: { __typename?: 'ShopPaymentMethod', id?: string | null, shopify_id?: string | null, supplier_id?: string | null, name?: string | null, email?: string | null, phone?: string | null, provider?: string | null, secure_code?: string | null, created_at?: any | null, updated_at?: any | null } | null, shop_reselling_products?: Array<{ __typename?: 'ShopifyResellingProducts', product?: string | null } | null> | null, products?: Array<{ __typename?: 'SyncShopifyProduct', id?: string | null, product_id?: string | null, image?: string | null, title?: string | null, shop?: string | null, handle?: string | null, body_html?: string | null, shopify_id?: string | null, status?: string | null, created_at?: any | null, updated_at?: any | null } | null> | null } | null };

export type GetSupplierQueryVariables = Exact<{
  filter?: InputMaybe<SupplierFilter>;
}>;


export type GetSupplierQuery = { __typename?: 'Query', getSupplier?: { __typename?: 'Supplier', id: string, permissions: Array<string>, name: string, email?: string | null, phone?: string | null, country?: string | null, avatar?: string | null, supplier_type: SupplierType, has_verified_phonenumber: boolean, has_verified_email: boolean, setup_complete: boolean, generic_name?: string | null, device_token?: string | null, agreement_terms?: string | null, social_platform?: string | null, social_platform_token?: string | null, createdAt?: any | null, deletedAt?: any | null, setupConfig?: { __typename?: 'SupplierSetupConfig', hasCategories: boolean, hasTerms: boolean, hasPaymentMethod: boolean } | null, business_details?: { __typename?: 'SupplierBusiness', id?: string | null, supplier_id?: string | null, business_name?: string | null, business_address?: string | null, industry?: string | null, description?: string | null, logo?: string | null, registered?: boolean | null, email?: string | null, phone?: string | null, city?: string | null, state?: string | null, postal_code?: string | null, delivery_option?: string | null, supplier_business_verified?: boolean | null, country?: string | null } | null, payment_details?: { __typename?: 'SupplierPaymentDetails', id?: string | null, supplier_id?: string | null, account_name?: string | null, account_number?: string | null, provider?: string | null, method?: string | null } | null } | null };

export type GetSuppliersQueryVariables = Exact<{
  filter?: InputMaybe<SupplierFilter>;
  pagination?: InputMaybe<Pagination>;
}>;


export type GetSuppliersQuery = { __typename?: 'Query', getSuppliers?: Array<{ __typename?: 'Supplier', avatar?: string | null, agreement_terms?: string | null, country?: string | null, email?: string | null, generic_name?: string | null, name: string, phone?: string | null, supplier_type: SupplierType, id: string, business_details?: { __typename?: 'SupplierBusiness', business_name?: string | null, country?: string | null, phone?: string | null, supplier_business_verified?: boolean | null, logo?: string | null } | null, shop?: { __typename?: 'Shop', avatar?: string | null, shopTags?: Array<string> | null } | null }> | null };

export type GetSupportedProvidersQueryVariables = Exact<{
  input?: InputMaybe<GetSupportedProvidersInput>;
}>;


export type GetSupportedProvidersQuery = { __typename?: 'Query', getSupportedProviders?: Array<any | null> | null };

export type GetTermsQueryVariables = Exact<{
  filter?: InputMaybe<TermsFilter>;
  pagination?: InputMaybe<Pagination>;
}>;


export type GetTermsQuery = { __typename?: 'Query', getTermsLength: number, getTerms?: Array<{ __typename?: 'Terms', id: string, name: string, description?: string | null, settlementType: Settlement, settlementValue: number, settlementCurrency?: string | null, settlementPeriod?: number | null, returnPeriod?: number | null, returnPolicy?: string | null, shippingPolicy?: string | null, cancellationPolicy?: string | null, shipTo?: string | null, shippingLocations?: Array<string | null> | null, estimatedDeliveryTime?: number | null, estimatedDeliveryTimeUnit?: string | null }> | null };

export type GetTermQueryVariables = Exact<{
  filter?: InputMaybe<TermsFilter>;
}>;


export type GetTermQuery = { __typename?: 'Query', getTerm?: { __typename?: 'Terms', id: string, name: string, description?: string | null, settlementType: Settlement, settlementValue: number, settlementCurrency?: string | null, settlementPeriod?: number | null, returnPeriod?: number | null, returnPolicy?: string | null, shippingPolicy?: string | null, cancellationPolicy?: string | null, shipTo?: string | null, shippingLocations?: Array<string | null> | null, estimatedDeliveryTime?: number | null, estimatedDeliveryTimeUnit?: string | null } | null };

export type GetUsersQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<UserFilter>;
}>;


export type GetUsersQuery = { __typename?: 'Query', getUsersLength: number, getUsers?: Array<{ __typename?: 'User', id: string, email: string, name: string, phone: string, country: string, username: string, shop?: { __typename?: 'Shop', shortUrl?: string | null, slug?: string | null, url?: string | null } | null } | null> | null };

export type GetUserQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
  condition?: InputMaybe<Condition>;
}>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', id: string, email: string, name: string, country: string, phone: string, verified: boolean, first_order_created?: boolean | null, user_type?: UserAccountType | null, username: string, google_id?: string | null, deviceToken?: string | null, facebook_id?: string | null, twitter_id?: string | null, supplier_shop_id?: string | null, details?: { __typename?: 'UserDetails', id?: string | null, gender?: string | null, dob?: any | null, referred_by?: string | null, user_id?: string | null } | null } | null };

export type GetSupplierWalletsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetSupplierWalletsQuery = { __typename?: 'Query', getSupplierWallets?: Array<{ __typename?: 'WalletResponseDTO', id: string, merchant_id: string, country: string, wallet_type: WalletType, lock_status: LockStatus, balance: number, currency: { __typename?: 'Currency', code: string, name: string } } | null> | null };

export type GetTransactionsQueryVariables = Exact<{
  input: GetTransactionsInput;
}>;


export type GetTransactionsQuery = { __typename?: 'Query', getTransactions?: Array<{ __typename?: 'Transaction', id: string, wallet_id: string, reference: string, amount: number, direction: TransactionDirection, type: TransactionType, status: TransactionStatus, metadata?: any | null, created_at: any, updated_at?: any | null, currency: { __typename?: 'Currency', code: string, name: string } } | null> | null };

export type GetTransactionQueryVariables = Exact<{
  input: GetTransactionsInput;
}>;


export type GetTransactionQuery = { __typename?: 'Query', getTransaction?: { __typename?: 'Transaction', id: string, wallet_id: string, reference: string, amount: number, direction: TransactionDirection, type: TransactionType, status: TransactionStatus, metadata?: any | null, created_at: any, updated_at?: any | null, currency: { __typename?: 'Currency', code: string, name: string } } | null };

export type GetWalletPayoutsQueryVariables = Exact<{
  input: GetWalletPayoutsInput;
}>;


export type GetWalletPayoutsQuery = { __typename?: 'Query', getWalletPayouts?: Array<{ __typename?: 'WalletPayoutResponseDTO', id: string, amount: number, country: string, account_number: string, account_name: string, provider: string, status: WalletPayoutStatus, metadata?: any | null, created_at: any, currency: { __typename?: 'Currency', code: string, name: string }, transaction?: { __typename?: 'Transaction', id: string, wallet_id: string, reference: string, amount: number, direction: TransactionDirection, type: TransactionType, status: TransactionStatus, metadata?: any | null, created_at: any, updated_at?: any | null } | null } | null> | null };


export const SupplierSignInDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SupplierSignIn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailOrPhone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierSignIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"emailOrPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailOrPhone"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"business_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"business_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_type"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"has_verified_phonenumber"}},{"kind":"Field","name":{"kind":"Name","value":"has_verified_email"}},{"kind":"Field","name":{"kind":"Name","value":"setup_complete"}},{"kind":"Field","name":{"kind":"Name","value":"generic_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_token"}},{"kind":"Field","name":{"kind":"Name","value":"agreement_terms"}},{"kind":"Field","name":{"kind":"Name","value":"social_platform"}},{"kind":"Field","name":{"kind":"Name","value":"social_platform_token"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"setupConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasCategories"}},{"kind":"Field","name":{"kind":"Name","value":"hasTerms"}},{"kind":"Field","name":{"kind":"Name","value":"hasPaymentMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"account_name"}},{"kind":"Field","name":{"kind":"Name","value":"account_number"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"method"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SupplierSignInMutation, SupplierSignInMutationVariables>;
export const RequestSupplierOtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestSupplierOTP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"requestOTPInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestSupplierOTP"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<RequestSupplierOtpMutation, RequestSupplierOtpMutationVariables>;
export const VerifySupplierOtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifySupplierOTP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"verifySupplierOTPInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifySupplierOTP"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<VerifySupplierOtpMutation, VerifySupplierOtpMutationVariables>;
export const CreateSupplierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSupplier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSupplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"verification_token"}}]}}]}}]} as unknown as DocumentNode<CreateSupplierMutation, CreateSupplierMutationVariables>;
export const ChangeSupplierPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeSupplierPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierPasswordChangeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeSupplierPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ChangeSupplierPasswordMutation, ChangeSupplierPasswordMutationVariables>;
export const RequestChangeSupplierPhoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestChangeSupplierPhone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"requestChangeSupplierPhoneInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestChangeSupplierPhone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RequestChangeSupplierPhoneMutation, RequestChangeSupplierPhoneMutationVariables>;
export const AccountRegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountRegister"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"accountRegisterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountRegister"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AccountRegisterMutation, AccountRegisterMutationVariables>;
export const JoinSupplierResellerNetworkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JoinSupplierResellerNetwork"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resellerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"termsId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"joinSupplierResellerNetwork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"supplier_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reseller_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resellerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"terms_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"termsId"}}}]}]}}]} as unknown as DocumentNode<JoinSupplierResellerNetworkMutation, JoinSupplierResellerNetworkMutationVariables>;
export const AddSupplierBusinessDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddSupplierBusinessDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierBusinessInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addSupplierBusinessDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<AddSupplierBusinessDetailsMutation, AddSupplierBusinessDetailsMutationVariables>;
export const AddSupplierCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddSupplierCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categories"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addSupplierCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"supplier_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}}},{"kind":"Argument","name":{"kind":"Name","value":"categories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categories"}}}]}]}}]} as unknown as DocumentNode<AddSupplierCategoriesMutation, AddSupplierCategoriesMutationVariables>;
export const CreateDiscountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDiscount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDiscountRequestDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDiscount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateDiscountMutation, CreateDiscountMutationVariables>;
export const DeleteDiscountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDiscount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteDiscountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDiscount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteDiscountId"}}}]}]}}]} as unknown as DocumentNode<DeleteDiscountMutation, DeleteDiscountMutationVariables>;
export const UpdateDiscountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDiscount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DiscountFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDiscountData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDiscount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_country"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"is_draft"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"expiry_date"}},{"kind":"Field","name":{"kind":"Name","value":"redemptions_limit"}},{"kind":"Field","name":{"kind":"Name","value":"product_condition"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_amount_allocation"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_expired"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_times_used"}},{"kind":"Field","name":{"kind":"Name","value":"locations"}},{"kind":"Field","name":{"kind":"Name","value":"locations_tagname"}}]}}]}}]} as unknown as DocumentNode<UpdateDiscountMutation, UpdateDiscountMutationVariables>;
export const AddPluginToUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPluginToUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddPluginToUserRequestDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPluginToUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"plugin_id"}}]}}]}}]} as unknown as DocumentNode<AddPluginToUserMutation, AddPluginToUserMutationVariables>;
export const RemovePluginFromUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePluginFromUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserPluginFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePluginFromUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<RemovePluginFromUserMutation, RemovePluginFromUserMutationVariables>;
export const RemoveShopifyShopDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveShopifyShop"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeShopifyShop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"supplier_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}}}]}]}}]} as unknown as DocumentNode<RemoveShopifyShopMutation, RemoveShopifyShopMutationVariables>;
export const StripeAccountSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StripeAccountSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StripeAccountSessionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeAccountSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<StripeAccountSessionMutation, StripeAccountSessionMutationVariables>;
export const StripeExternalBankAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StripeExternalBankAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeExternalBankAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"supplier_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}}}]}]}}]} as unknown as DocumentNode<StripeExternalBankAccountMutation, StripeExternalBankAccountMutationVariables>;
export const InviteResellerBySupplierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteResellerBySupplier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"termsId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteResellerBySupplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"supplier_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"terms_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"termsId"}}}]}]}}]} as unknown as DocumentNode<InviteResellerBySupplierMutation, InviteResellerBySupplierMutationVariables>;
export const AddSupplierDeviceTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddSupplierDeviceToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierAddDeviceTokenInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addSupplierDeviceToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<AddSupplierDeviceTokenMutation, AddSupplierDeviceTokenMutationVariables>;
export const ProcessOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProcessOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}}]}]}}]} as unknown as DocumentNode<ProcessOrderMutation, ProcessOrderMutationVariables>;
export const ChangeSupplierStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeSupplierStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changeSupplierStatusId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeSupplierStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changeSupplierStatusId"}}},{"kind":"Argument","name":{"kind":"Name","value":"supplier_status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierStatus"}}}]}]}}]} as unknown as DocumentNode<ChangeSupplierStatusMutation, ChangeSupplierStatusMutationVariables>;
export const CreateCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"landmark"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CreateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderCreateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateOrderMutation, CreateOrderMutationVariables>;
export const CreatePartnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePartnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skus"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"client"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPartnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractor"}}},{"kind":"Argument","name":{"kind":"Name","value":"skus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skus"}}},{"kind":"Argument","name":{"kind":"Name","value":"client"},"value":{"kind":"Variable","name":{"kind":"Name","value":"client"}}}]}]}}]} as unknown as DocumentNode<CreatePartnershipMutation, CreatePartnershipMutationVariables>;
export const UpdatePartnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePartnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePartnershipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skus"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePartnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePartnershipId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"supplier_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skus"}}}]}]}}]} as unknown as DocumentNode<UpdatePartnershipMutation, UpdatePartnershipMutationVariables>;
export const RejectPartnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RejectPartnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rejectPartnershipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rejectPartnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rejectPartnershipId"}}}]}]}}]} as unknown as DocumentNode<RejectPartnershipMutation, RejectPartnershipMutationVariables>;
export const ApprovePartnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApprovePartnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approvePartnershipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"termId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvePartnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approvePartnershipId"}}},{"kind":"Argument","name":{"kind":"Name","value":"term_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"termId"}}}]}]}}]} as unknown as DocumentNode<ApprovePartnershipMutation, ApprovePartnershipMutationVariables>;
export const AddSupplierPaymentDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddSupplierPaymentDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"addSupplierPaymentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addSupplierPaymentDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<AddSupplierPaymentDetailsMutation, AddSupplierPaymentDetailsMutationVariables>;
export const UpdateSupplierPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSupplierPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSupplierPaymentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSupplierPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateSupplierPaymentMutation, UpdateSupplierPaymentMutationVariables>;
export const MakeWalletWithdrawalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MakeWalletWithdrawal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WalletWithdrawalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"makeWalletWithdrawal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<MakeWalletWithdrawalMutation, MakeWalletWithdrawalMutationVariables>;
export const InitiateCardSetupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitiateCardSetup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InitiateCardSetupInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiateCardSetup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<InitiateCardSetupMutation, InitiateCardSetupMutationVariables>;
export const CreateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"createProductInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductCategoryAndTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProductCategoryAndTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductCategoryAndTagsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductCategoryAndTags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateProductCategoryAndTagsMutation, UpdateProductCategoryAndTagsMutationVariables>;
export const UpdateProductMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProductMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMediaInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateProductMediaMutation, UpdateProductMediaMutationVariables>;
export const BulkUpdateProductSockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateProductSock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkProductStockInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateProductSock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<BulkUpdateProductSockMutation, BulkUpdateProductSockMutationVariables>;
export const UpdateProductInventoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProductInventory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductInventoryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductInventory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateProductInventoryMutation, UpdateProductInventoryMutationVariables>;
export const UpdateProductInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProductInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductInformationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateProductInformationMutation, UpdateProductInformationMutationVariables>;
export const UpdateProductDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProductDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProductDistributionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateProductDistributionMutation, UpdateProductDistributionMutationVariables>;
export const RemoveProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removeProductId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removeProductId"}}}]}]}}]} as unknown as DocumentNode<RemoveProductMutation, RemoveProductMutationVariables>;
export const SyncShopifyProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncShopifyProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SyncShopifyProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncShopifyProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SyncShopifyProductsMutation, SyncShopifyProductsMutationVariables>;
export const PublishOrUnpublishProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishOrUnpublishProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publishOrUnpublishProductId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"published"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personnel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishOrUnpublishProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publishOrUnpublishProductId"}}},{"kind":"Argument","name":{"kind":"Name","value":"published"},"value":{"kind":"Variable","name":{"kind":"Name","value":"published"}}},{"kind":"Argument","name":{"kind":"Name","value":"personnel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personnel"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}}]}]}}]} as unknown as DocumentNode<PublishOrUnpublishProductMutation, PublishOrUnpublishProductMutationVariables>;
export const LoadProductsToShopifyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoadProductsToShopify"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoadProductToShopifyInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loadProductsToShopify"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<LoadProductsToShopifyMutation, LoadProductsToShopifyMutationVariables>;
export const RemoveResellerBySupplierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveResellerBySupplier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resellerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeResellerBySupplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"supplier_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reseller_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resellerId"}}}]}]}}]} as unknown as DocumentNode<RemoveResellerBySupplierMutation, RemoveResellerBySupplierMutationVariables>;
export const ActivateShopDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateShop"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivateShopRequestDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateShop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<ActivateShopMutation, ActivateShopMutationVariables>;
export const UpdateSupplierShopDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSupplierShopDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShopDetailsRequestDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSupplierShopDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopId"}}]}}]}}]} as unknown as DocumentNode<UpdateSupplierShopDetailsMutation, UpdateSupplierShopDetailsMutationVariables>;
export const UpdateSupplierShopSlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSupplierShopSlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSupplierSlugInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSupplierShopSlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopId"}}]}}]}}]} as unknown as DocumentNode<UpdateSupplierShopSlugMutation, UpdateSupplierShopSlugMutationVariables>;
export const CreateTermDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTerm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TermInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTerm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateTermMutation, CreateTermMutationVariables>;
export const UpdateTermDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTerm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TermInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTerm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateTermMutation, UpdateTermMutationVariables>;
export const UpdateSupplierDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSupplierDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSupplierDetailsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSupplierDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateSupplierDetailsMutation, UpdateSupplierDetailsMutationVariables>;
export const ChangeSupplierEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeSupplierEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierEmailChangeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeSupplierEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ChangeSupplierEmailMutation, ChangeSupplierEmailMutationVariables>;
export const ResetSupplierPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetSupplierPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierPasswordResetInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetSupplierPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ResetSupplierPasswordMutation, ResetSupplierPasswordMutationVariables>;
export const GetCustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomersLength"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]},{"kind":"Field","name":{"kind":"Name","value":"getCustomers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"landmark"}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomersQuery, GetCustomersQueryVariables>;
export const GetCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"landmark"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"reseller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetCustomerQuery, GetCustomerQueryVariables>;
export const GetSupplierDailyOrdersSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupplierDailyOrdersSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSupplierDailyOrdersSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}]}}]} as unknown as DocumentNode<GetSupplierDailyOrdersSummaryQuery, GetSupplierDailyOrdersSummaryQueryVariables>;
export const GetSupplierStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupplierStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSupplierStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"supplier_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"total_active_orders"}},{"kind":"Field","name":{"kind":"Name","value":"total_orders"}},{"kind":"Field","name":{"kind":"Name","value":"total_finished_orders"}},{"kind":"Field","name":{"kind":"Name","value":"total_products"}},{"kind":"Field","name":{"kind":"Name","value":"total_verified_products"}},{"kind":"Field","name":{"kind":"Name","value":"total_unverified_products"}},{"kind":"Field","name":{"kind":"Name","value":"total_products_in_stock"}},{"kind":"Field","name":{"kind":"Name","value":"total_products_out_of_stock"}},{"kind":"Field","name":{"kind":"Name","value":"total_products_in_transit"}},{"kind":"Field","name":{"kind":"Name","value":"total_customers"}},{"kind":"Field","name":{"kind":"Name","value":"total_resellers"}}]}}]}}]} as unknown as DocumentNode<GetSupplierStatsQuery, GetSupplierStatsQueryVariables>;
export const GetSupplierOrdersByStatusSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupplierOrdersByStatusSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSupplierOrdersByStatusSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"supplier_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPending"}},{"kind":"Field","name":{"kind":"Name","value":"totalDelivered"}},{"kind":"Field","name":{"kind":"Name","value":"totalCancelled"}},{"kind":"Field","name":{"kind":"Name","value":"totalSuccessful"}}]}}]}}]} as unknown as DocumentNode<GetSupplierOrdersByStatusSummaryQuery, GetSupplierOrdersByStatusSummaryQueryVariables>;
export const GetProductsCountByCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductsCountByCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProductsCountByCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"supplier_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<GetProductsCountByCategoriesQuery, GetProductsCountByCategoriesQueryVariables>;
export const DeliveryLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeliveryLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"remarks"}},{"kind":"Field","name":{"kind":"Name","value":"isPayOnline"}},{"kind":"Field","name":{"kind":"Name","value":"hasInstantDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"instantDeliveryPrice"}}]}}]}}]} as unknown as DocumentNode<DeliveryLocationsQuery, DeliveryLocationsQueryVariables>;
export const GetPluginsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlugins"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PluginFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPlugins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"supplier_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"banner_image"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"developer"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"}},{"kind":"Field","name":{"kind":"Name","value":"is_installed_by_current_user"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<GetPluginsQuery, GetPluginsQueryVariables>;
export const GetUserPluginsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserPlugins"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserPluginFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserPlugins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"plugin_id"}}]}}]}}]} as unknown as DocumentNode<GetUserPluginsQuery, GetUserPluginsQueryVariables>;
export const ConfirmCardSetupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConfirmCardSetup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"confirmCardSetupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmCardSetup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"confirmCardSetupId"}}}]}]}}]} as unknown as DocumentNode<ConfirmCardSetupQuery, ConfirmCardSetupQueryVariables>;
export const GetCartsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCarts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CartFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"count"},"name":{"kind":"Name","value":"getCartsLength"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"rows"},"name":{"kind":"Name","value":"getCarts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delivery_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer_address_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_total"}},{"kind":"Field","name":{"kind":"Name","value":"security_deposit_paid"}},{"kind":"Field","name":{"kind":"Name","value":"security_deposit"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_amount"}},{"kind":"Field","name":{"kind":"Name","value":"customer_paid"}},{"kind":"Field","name":{"kind":"Name","value":"cart_number"}},{"kind":"Field","name":{"kind":"Name","value":"payment_status"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"free_delivery"}},{"kind":"Field","name":{"kind":"Name","value":"payment_id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_type"}},{"kind":"Field","name":{"kind":"Name","value":"tracking_code"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reseller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"first_order_created"}},{"kind":"Field","name":{"kind":"Name","value":"user_type"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"google_id"}},{"kind":"Field","name":{"kind":"Name","value":"deviceToken"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_id"}},{"kind":"Field","name":{"kind":"Name","value":"twitter_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_shop_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"has_verified_phonenumber"}},{"kind":"Field","name":{"kind":"Name","value":"has_verified_email"}},{"kind":"Field","name":{"kind":"Name","value":"setup_complete"}},{"kind":"Field","name":{"kind":"Name","value":"generic_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_token"}},{"kind":"Field","name":{"kind":"Name","value":"agreement_terms"}},{"kind":"Field","name":{"kind":"Name","value":"social_platform"}},{"kind":"Field","name":{"kind":"Name","value":"social_platform_token"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"profitAdded"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"order_id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"limited_stock"}},{"kind":"Field","name":{"kind":"Name","value":"qty"}},{"kind":"Field","name":{"kind":"Name","value":"instantDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"main_stock"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"distributionChannels"}},{"kind":"Field","name":{"kind":"Name","value":"transit_stock"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"profit_added"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"extra_information"}},{"kind":"Field","name":{"kind":"Name","value":"combination_string"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"inhouse"}},{"kind":"Field","name":{"kind":"Name","value":"attended_to"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"cost_price"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"shop_id"}},{"kind":"Field","name":{"kind":"Name","value":"resell"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"likesCount"}},{"kind":"Field","name":{"kind":"Name","value":"savesCount"}},{"kind":"Field","name":{"kind":"Name","value":"sharesCount"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"overalReview"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"remarks"}},{"kind":"Field","name":{"kind":"Name","value":"isPayOnline"}}]}}]}}]}}]} as unknown as DocumentNode<GetCartsQuery, GetCartsQueryVariables>;
export const GetCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CartFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delivery_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customer_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"customer_address_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_total"}},{"kind":"Field","name":{"kind":"Name","value":"security_deposit_paid"}},{"kind":"Field","name":{"kind":"Name","value":"security_deposit"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_amount"}},{"kind":"Field","name":{"kind":"Name","value":"customer_paid"}},{"kind":"Field","name":{"kind":"Name","value":"cart_number"}},{"kind":"Field","name":{"kind":"Name","value":"payment_status"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"free_delivery"}},{"kind":"Field","name":{"kind":"Name","value":"payment_id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_type"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_type"}},{"kind":"Field","name":{"kind":"Name","value":"tracking_code"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_instructions"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"orderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"profitAdded"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"order_id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"limited_stock"}},{"kind":"Field","name":{"kind":"Name","value":"qty"}},{"kind":"Field","name":{"kind":"Name","value":"main_stock"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"distributionChannels"}},{"kind":"Field","name":{"kind":"Name","value":"transit_stock"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"profit_added"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"extra_information"}},{"kind":"Field","name":{"kind":"Name","value":"combination_string"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"inhouse"}},{"kind":"Field","name":{"kind":"Name","value":"attended_to"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"cost_price"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"shop_id"}},{"kind":"Field","name":{"kind":"Name","value":"resell"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"likesCount"}},{"kind":"Field","name":{"kind":"Name","value":"savesCount"}},{"kind":"Field","name":{"kind":"Name","value":"sharesCount"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"instantDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"overalReview"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"remarks"}},{"kind":"Field","name":{"kind":"Name","value":"isPayOnline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reseller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"first_order_created"}},{"kind":"Field","name":{"kind":"Name","value":"user_type"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"google_id"}},{"kind":"Field","name":{"kind":"Name","value":"deviceToken"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_id"}},{"kind":"Field","name":{"kind":"Name","value":"twitter_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_shop_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"landmark"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetCartQuery, GetCartQueryVariables>;
export const GetPickUpLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPickUpLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPickUpLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"google_location"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"remarks"}}]}}]}}]} as unknown as DocumentNode<GetPickUpLocationsQuery, GetPickUpLocationsQueryVariables>;
export const GetPartnershipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPartnerships"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PartnershipFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rows"},"name":{"kind":"Name","value":"getPartnerships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"skus"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"count"},"name":{"kind":"Name","value":"getPartnershipsLength"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<GetPartnershipsQuery, GetPartnershipsQueryVariables>;
export const GetPartnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPartnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PartnershipFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPartnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"skus"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"limited_stock"}},{"kind":"Field","name":{"kind":"Name","value":"qty"}},{"kind":"Field","name":{"kind":"Name","value":"main_stock"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"distributionChannels"}},{"kind":"Field","name":{"kind":"Name","value":"transit_stock"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"profit_added"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"extra_information"}},{"kind":"Field","name":{"kind":"Name","value":"combination_string"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"inhouse"}},{"kind":"Field","name":{"kind":"Name","value":"attended_to"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"cost_price"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"shop_id"}},{"kind":"Field","name":{"kind":"Name","value":"resell"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"likesCount"}},{"kind":"Field","name":{"kind":"Name","value":"savesCount"}},{"kind":"Field","name":{"kind":"Name","value":"sharesCount"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"overalReview"}}]}}]}}]}}]} as unknown as DocumentNode<GetPartnershipQuery, GetPartnershipQueryVariables>;
export const VerifyAccountDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"verifyAccountDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaystackValidateAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyAccountDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<VerifyAccountDetailsQuery, VerifyAccountDetailsQueryVariables>;
export const GetDiscountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDiscounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DiscountFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_country"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"is_draft"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"expiry_date"}},{"kind":"Field","name":{"kind":"Name","value":"redemptions_limit"}},{"kind":"Field","name":{"kind":"Name","value":"product_condition"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_amount_allocation"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_expired"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_times_used"}},{"kind":"Field","name":{"kind":"Name","value":"locations"}}]}}]}}]} as unknown as DocumentNode<GetDiscountsQuery, GetDiscountsQueryVariables>;
export const GetDiscountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDiscount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DiscountFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDiscount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_country"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"is_draft"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"expiry_date"}},{"kind":"Field","name":{"kind":"Name","value":"redemptions_limit"}},{"kind":"Field","name":{"kind":"Name","value":"product_condition"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_amount_allocation"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_expired"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_times_used"}},{"kind":"Field","name":{"kind":"Name","value":"locations"}},{"kind":"Field","name":{"kind":"Name","value":"locations_tagname"}}]}}]}}]} as unknown as DocumentNode<GetDiscountQuery, GetDiscountQueryVariables>;
export const GetDiscountProductConditionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDiscountProductConditions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DiscountProductConditionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDiscountProductConditions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product_sku"}},{"kind":"Field","name":{"kind":"Name","value":"discount_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"limited_stock"}},{"kind":"Field","name":{"kind":"Name","value":"qty"}},{"kind":"Field","name":{"kind":"Name","value":"main_stock"}},{"kind":"Field","name":{"kind":"Name","value":"transit_stock"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"profit_added"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"extra_information"}},{"kind":"Field","name":{"kind":"Name","value":"combination_string"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"inhouse"}},{"kind":"Field","name":{"kind":"Name","value":"attended_to"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"cost_price"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"shop_id"}},{"kind":"Field","name":{"kind":"Name","value":"resell"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"likesCount"}},{"kind":"Field","name":{"kind":"Name","value":"savesCount"}},{"kind":"Field","name":{"kind":"Name","value":"sharesCount"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"overalReview"}}]}}]}}]}}]} as unknown as DocumentNode<GetDiscountProductConditionsQuery, GetDiscountProductConditionsQueryVariables>;
export const GetProductsLengthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductsLength"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"productFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProductsLength"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<GetProductsLengthQuery, GetProductsLengthQueryVariables>;
export const GetSkuDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSku"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSKU"}}]}}]} as unknown as DocumentNode<GetSkuQuery, GetSkuQueryVariables>;
export const GetCategoriesLengthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCategoriesLength"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductCategoryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProductCategoriesLength"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<GetCategoriesLengthQuery, GetCategoriesLengthQueryVariables>;
export const FeaturedCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeaturedCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FeaturedCategoriesFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"banners"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FeaturedCategoriesQuery, FeaturedCategoriesQueryVariables>;
export const GetProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"productFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"overalReview"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"qty"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_cost"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"instantDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"extra_information"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"digitalDetails"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limited_stock"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"inhouse"}},{"kind":"Field","name":{"kind":"Name","value":"cost_price"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"combination_string"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"staff_number"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variation_name"}},{"kind":"Field","name":{"kind":"Name","value":"variation_options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variation_value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"distributionChannels"}},{"kind":"Field","name":{"kind":"Name","value":"main_stock"}},{"kind":"Field","name":{"kind":"Name","value":"transit_stock"}},{"kind":"Field","name":{"kind":"Name","value":"profit_added"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"attended_to"}},{"kind":"Field","name":{"kind":"Name","value":"shop_id"}},{"kind":"Field","name":{"kind":"Name","value":"resell"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"likesCount"}},{"kind":"Field","name":{"kind":"Name","value":"savesCount"}},{"kind":"Field","name":{"kind":"Name","value":"sharesCount"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"has_verified_phonenumber"}},{"kind":"Field","name":{"kind":"Name","value":"has_verified_email"}},{"kind":"Field","name":{"kind":"Name","value":"setup_complete"}},{"kind":"Field","name":{"kind":"Name","value":"generic_name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agreement_terms"}},{"kind":"Field","name":{"kind":"Name","value":"business_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"business_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getProductsLength"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}]}]}}]} as unknown as DocumentNode<GetProductsQuery, GetProductsQueryVariables>;
export const GetProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"productFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"limited_stock"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"qty"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_cost"}},{"kind":"Field","name":{"kind":"Name","value":"product_origin"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"distributionChannels"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"digitalDetails"}},{"kind":"Field","name":{"kind":"Name","value":"combination_string"}},{"kind":"Field","name":{"kind":"Name","value":"instantDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"extra_information"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"inhouse"}},{"kind":"Field","name":{"kind":"Name","value":"attended_to"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"cost_price"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"resell"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"likesCount"}},{"kind":"Field","name":{"kind":"Name","value":"savesCount"}},{"kind":"Field","name":{"kind":"Name","value":"sharesCount"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variation_name"}},{"kind":"Field","name":{"kind":"Name","value":"variation_options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variation_value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"staff_number"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"combinations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"available_stock"}},{"kind":"Field","name":{"kind":"Name","value":"combination_string"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shop_id"}},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"main_stock"}},{"kind":"Field","name":{"kind":"Name","value":"transit_stock"}}]}}]}}]} as unknown as DocumentNode<GetProductQuery, GetProductQueryVariables>;
export const GetProductsForSupplierDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductsForSupplierDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierProductFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Condition"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProductsForSupplierDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"overalReview"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"qty"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_cost"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"instantDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"extra_information"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"digitalDetails"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limited_stock"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"inhouse"}},{"kind":"Field","name":{"kind":"Name","value":"cost_price"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"combination_string"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"staff_number"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variation_name"}},{"kind":"Field","name":{"kind":"Name","value":"variation_options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variation_value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"distributionChannels"}},{"kind":"Field","name":{"kind":"Name","value":"main_stock"}},{"kind":"Field","name":{"kind":"Name","value":"transit_stock"}},{"kind":"Field","name":{"kind":"Name","value":"profit_added"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"attended_to"}},{"kind":"Field","name":{"kind":"Name","value":"shop_id"}},{"kind":"Field","name":{"kind":"Name","value":"resell"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"likesCount"}},{"kind":"Field","name":{"kind":"Name","value":"savesCount"}},{"kind":"Field","name":{"kind":"Name","value":"sharesCount"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"has_verified_phonenumber"}},{"kind":"Field","name":{"kind":"Name","value":"has_verified_email"}},{"kind":"Field","name":{"kind":"Name","value":"setup_complete"}},{"kind":"Field","name":{"kind":"Name","value":"generic_name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agreement_terms"}},{"kind":"Field","name":{"kind":"Name","value":"business_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"business_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getProductsForSupplierDashboardLength"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}]}]}}]} as unknown as DocumentNode<GetProductsForSupplierDashboardQuery, GetProductsForSupplierDashboardQueryVariables>;
export const GetProductTitleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductTitle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"productFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}}]}}]} as unknown as DocumentNode<GetProductTitleQuery, GetProductTitleQueryVariables>;
export const GetProductCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductCategoryFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProductCategoriesLength"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]},{"kind":"Field","name":{"kind":"Name","value":"getProductCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]} as unknown as DocumentNode<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>;
export const GetProductCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductCategoryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProductCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}}]}}]}}]} as unknown as DocumentNode<GetProductCategoryQuery, GetProductCategoryQueryVariables>;
export const LoadShopifyProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadShopifyProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"integrationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loadShopifyProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"integrationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"integrationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"body_html"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"variant_ids"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}}]}}]} as unknown as DocumentNode<LoadShopifyProductsQuery, LoadShopifyProductsQueryVariables>;
export const GetProductTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProductTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"dependsOn"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProductTemplatesQuery, GetProductTemplatesQueryVariables>;
export const GetProductTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProductTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"dependsOn"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProductTemplateQuery, GetProductTemplateQueryVariables>;
export const GetProductHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductHistoryFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProductHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"actor"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"oldSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"newSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetProductHistoryQuery, GetProductHistoryQueryVariables>;
export const GetShopDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShop"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShopFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getShop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"primaryDomain"}},{"kind":"Field","name":{"kind":"Name","value":"sokoWorldDomain"}},{"kind":"Field","name":{"kind":"Name","value":"customDomains"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenSetup"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"shopTags"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"coverImage"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryOption"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryAgent"}},{"kind":"Field","name":{"kind":"Name","value":"paymentOptions"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"shortUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"shopId"}}]}}]}}]} as unknown as DocumentNode<GetShopQuery, GetShopQueryVariables>;
export const GetShopifyShopDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShopifyShop"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchShopifyShopInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getShopifyShop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shop"}},{"kind":"Field","name":{"kind":"Name","value":"redirect_url"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"shop_currency"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"country_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"shop_payment_method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shopify_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"secure_code"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shop_reselling_products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shop"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"body_html"}},{"kind":"Field","name":{"kind":"Name","value":"shopify_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]} as unknown as DocumentNode<GetShopifyShopQuery, GetShopifyShopQueryVariables>;
export const GetSupplierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupplier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSupplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setupConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasCategories"}},{"kind":"Field","name":{"kind":"Name","value":"hasTerms"}},{"kind":"Field","name":{"kind":"Name","value":"hasPaymentMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_type"}},{"kind":"Field","name":{"kind":"Name","value":"has_verified_phonenumber"}},{"kind":"Field","name":{"kind":"Name","value":"has_verified_email"}},{"kind":"Field","name":{"kind":"Name","value":"setup_complete"}},{"kind":"Field","name":{"kind":"Name","value":"generic_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_token"}},{"kind":"Field","name":{"kind":"Name","value":"agreement_terms"}},{"kind":"Field","name":{"kind":"Name","value":"social_platform"}},{"kind":"Field","name":{"kind":"Name","value":"social_platform_token"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"business_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"business_name"}},{"kind":"Field","name":{"kind":"Name","value":"business_address"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"registered"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_option"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_business_verified"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_id"}},{"kind":"Field","name":{"kind":"Name","value":"account_name"}},{"kind":"Field","name":{"kind":"Name","value":"account_number"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"method"}}]}}]}}]}}]} as unknown as DocumentNode<GetSupplierQuery, GetSupplierQueryVariables>;
export const GetSuppliersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSuppliers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSuppliers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"agreement_terms"}},{"kind":"Field","name":{"kind":"Name","value":"business_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"business_name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_business_verified"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"generic_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"shopTags"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetSuppliersQuery, GetSuppliersQueryVariables>;
export const GetSupportedProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupportedProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetSupportedProvidersInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSupportedProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<GetSupportedProvidersQuery, GetSupportedProvidersQueryVariables>;
export const GetTermsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTerms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TermsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTermsLength"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]},{"kind":"Field","name":{"kind":"Name","value":"getTerms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"settlementType"}},{"kind":"Field","name":{"kind":"Name","value":"settlementValue"}},{"kind":"Field","name":{"kind":"Name","value":"settlementCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"settlementPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"returnPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"returnPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"shippingPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"shipTo"}},{"kind":"Field","name":{"kind":"Name","value":"shippingLocations"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedDeliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedDeliveryTimeUnit"}}]}}]}}]} as unknown as DocumentNode<GetTermsQuery, GetTermsQueryVariables>;
export const GetTermDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTerm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TermsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTerm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"settlementType"}},{"kind":"Field","name":{"kind":"Name","value":"settlementValue"}},{"kind":"Field","name":{"kind":"Name","value":"settlementCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"settlementPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"returnPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"returnPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"shippingPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"shipTo"}},{"kind":"Field","name":{"kind":"Name","value":"shippingLocations"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedDeliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedDeliveryTimeUnit"}}]}}]}}]} as unknown as DocumentNode<GetTermQuery, GetTermQueryVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Condition"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUsersLength"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]},{"kind":"Field","name":{"kind":"Name","value":"getUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortUrl"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"first_order_created"}},{"kind":"Field","name":{"kind":"Name","value":"user_type"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"google_id"}},{"kind":"Field","name":{"kind":"Name","value":"deviceToken"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_id"}},{"kind":"Field","name":{"kind":"Name","value":"twitter_id"}},{"kind":"Field","name":{"kind":"Name","value":"supplier_shop_id"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"referred_by"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const GetSupplierWalletsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupplierWallets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSupplierWallets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"merchant_id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"wallet_type"}},{"kind":"Field","name":{"kind":"Name","value":"lock_status"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetSupplierWalletsQuery, GetSupplierWalletsQueryVariables>;
export const GetTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetTransactionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTransactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wallet_id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetTransactionsQuery, GetTransactionsQueryVariables>;
export const GetTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetTransactionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wallet_id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetTransactionQuery, GetTransactionQueryVariables>;
export const GetWalletPayoutsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWalletPayouts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetWalletPayoutsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWalletPayouts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"account_number"}},{"kind":"Field","name":{"kind":"Name","value":"account_name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wallet_id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]} as unknown as DocumentNode<GetWalletPayoutsQuery, GetWalletPayoutsQueryVariables>;